
(function(){
'use strict';

// ╔══════════════════════════════════════════════════════════╗
// ║  ⚙️  VASTE INSTELLINGEN — HIER INVULLEN                    ║
// ║                                                            ║
// ║  Vul hieronder je gegevens in tussen de aanhalingstekens. ║
// ║  Deze waarden staan VAST in de code en blijven dus altijd ║
// ║  werken, op elk apparaat en elke browser. Ze verdwijnen   ║
// ║  NIET bij verversen (in tegenstelling tot de admin-opslag).║
// ║                                                            ║
// ║  Laat een waarde leeg ('') om de admin-instelling te      ║
// ║  gebruiken in plaats van een vaste waarde.                ║
// ╚══════════════════════════════════════════════════════════╝
const RBL_FIXED = {
 // Admin-wachtwoord om bij het beheer te komen:
  pw: 'Judith190513!!',

  // Jouw e-mailadres voor aanvragen:
  email: 'inkoop@retro-empire.nl',

  // Formspree form-ID voor de MELDING NAAR JOU (alleen het ID na /f/):
  formspreeId: 'https://formspree.io/f/mvznwkjq',

  // Formspree form-ID voor de BEVESTIGING NAAR DE KLANT (optioneel, leeg = geen):
  formspreeConfirmId: '',

  // ── Supabase (centrale database voor aanvragen) ──
  // Te vinden in Supabase → Project Settings → API
  // Project URL (bijv. https://xxxxx.supabase.co):
  supabaseUrl: 'https://hiffoultmnstwbhjstfv.supabase.co',
  // anon public key (de "anon / public", NIET de service_role!):
  supabaseAnonKey: 'sb_publishable_GEvd15i03elEyRAHOMOj1w_EF2GpP8P',

  // ── Automatische ID-verificatie-uitnodiging ──
  // Volledige URL van je ID-formulier-pagina (zonder ?ref=, die plak ik er zelf achter):
  idFormUrl: 'https://retro-empire.nl/pages/id-verificatie',
  // Formspree form-ID met autoresponder voor de uitnodigingsmail naar de klant
  // (mag hetzelfde zijn als je bevestigings-form, leeg = geen automatische mail):
  formspreeInviteId: '',
};

// ╔══════════════════════════════════════════════════════════╗
// ║  📜  VOORWAARDEN & PRIVACY — HIER INVULLEN                 ║
// ║                                                            ║
// ║  Per onderwerp vul je 2 dingen in:                         ║
// ║   • samenvatting: korte tekst die in de pop-up verschijnt  ║
// ║   • url: link naar je volledige pagina in Shopify          ║
// ║                                                            ║
// ║  Gebruik \n voor een nieuwe regel. Laat url leeg ('') als  ║
// ║  er (nog) geen volledige pagina is — dan toont alleen de   ║
// ║  samenvatting zonder knop.                                 ║
// ╚══════════════════════════════════════════════════════════╝
const RBL_TERMS = {
  // Inkoopvoorwaarden (bod-geldigheid, verzending, conditiebeoordeling enz.):
  voorwaarden: {
    samenvatting:
      'In het kort: een uitgebracht bod is een richtbod; het definitieve bod hangt af '
      + 'van de conditiebeoordeling bij ontvangst van je kaarten. Verzending en uitbetaling '
      + 'verlopen zoals beschreven in onze volledige voorwaarden.\n\n'
      + 'Lees de volledige inkoopvoorwaarden voor alle details.',
    url: 'https://retro-empire.nl/pages/inkoop-voorwaarde-tcg',
  },

  // Beleid rond namaak / nep kaarten:
  nepKaarten: {
    samenvatting:
      'In het kort: wij kopen uitsluitend authentieke kaarten in. Blijken ingestuurde '
      + 'kaarten namaak te zijn, dan worden ze niet ingekocht en nemen wij contact met je op '
      + 'over de afhandeling.\n\n'
      + 'Lees ons volledige beleid rond namaak voor alle details.',
    url: 'https://retro-empire.nl/pages/beleid-rond-namaak-tcg?_pos=1&_psq=namaak&_ss=e&_v=1.0',
  },

  // Privacyverklaring (AVG):
  privacy: {
    samenvatting:
      'In het kort: we verzamelen je naam, e-mail en telefoonnummer om je aanvraag te '
      + 'verwerken en contact met je op te nemen. We delen je gegevens niet met derden voor '
      + 'marketing.\n\n'
      + 'Lees onze volledige privacyverklaring voor alle details.',
    url: 'https://retro-empire.nl/pages/privacyverklaring-retro-empire-gaming',
  },
};
// ── Einde vaste instellingen ──────────────────────────────────
// Helper: gebruik de vaste waarde alleen als die echt is ingevuld
// (niet leeg en niet nog de placeholder-tekst).
function rblFixed(key) {
  const v = RBL_FIXED[key];
  if(!v || /^VUL-/.test(v)) return null;
  return v;
}

// ════════════════════════════════════════════════════════
// SUPABASE — centrale database voor aanvragen
// Gebruikt de REST-API (PostgREST), geen externe library nodig.
// ════════════════════════════════════════════════════════
const SB_URL = (() => {
  let u = rblFixed('supabaseUrl');
  if(!u) return null;
  // Normaliseer: haal eventuele afsluitende slash en /rest/v1 weg,
  // zodat het altijd op het kale project-adres eindigt.
  u = u.trim().replace(/\/+$/,'');           // afsluitende slashes weg
  u = u.replace(/\/rest\/v1.*$/,'');          // per ongeluk meegeplakt /rest/v1 weg
  u = u.replace(/\/+$/,'');                    // nogmaals slashes opruimen
  return u;
})();
const SB_KEY = rblFixed('supabaseAnonKey');
const SB_ON  = !!(SB_URL && SB_KEY);   // staat Supabase aan?
const SB_TABLE = 'buylist_requests';

// Bewaart het ingelogde admin-token (Supabase sessie). Wordt in localStorage
// bewaard zodat je ingelogd blijft tussen paginabezoeken.
let sbToken = (() => { try { return localStorage.getItem('rbl_sb_token') || null; } catch(e) { return null; } })();
let sbRefresh = (() => { try { return localStorage.getItem('rbl_sb_refresh') || null; } catch(e) { return null; } })();

function sbHeaders(extra) {
  // Gebruik het admin-token als je ingelogd bent, anders de publieke key.
  // Lezen/bijwerken/verwijderen werkt alleen met een geldig admin-token.
  const bearer = sbToken || SB_KEY;
  return Object.assign({
    'apikey': SB_KEY,
    'Authorization': 'Bearer ' + bearer,
    'Content-Type': 'application/json',
  }, extra || {});
}

// Inloggen met e-mail + wachtwoord (het account dat je in Supabase aanmaakte).
// Geeft {ok:true} bij succes, anders {ok:false, error:'...'}.
async function sbLogin(email, password) {
  if(!SB_ON) return {ok:false, error:'Supabase niet ingesteld'};
  try {
    const r = await fetch(`${SB_URL}/auth/v1/token?grant_type=password`, {
      method:'POST',
      headers:{ 'apikey':SB_KEY, 'Content-Type':'application/json' },
      body: JSON.stringify({ email, password }),
    });
    const data = await r.json();
    if(!r.ok || !data.access_token) {
      return {ok:false, error: data.error_description || data.msg || 'Inloggen mislukt'};
    }
    sbToken = data.access_token;
    sbRefresh = data.refresh_token || null;
    try {
      localStorage.setItem('rbl_sb_token', sbToken);
      if(sbRefresh) localStorage.setItem('rbl_sb_refresh', sbRefresh);
    } catch(e){}
    return {ok:true};
  } catch(e) {
    return {ok:false, error:'Verbindingsfout'};
  }
}

// Vernieuw een verlopen token met de refresh-token (sessies verlopen na ~1u).
async function sbRefreshToken() {
  if(!SB_ON || !sbRefresh) return false;
  try {
    const r = await fetch(`${SB_URL}/auth/v1/token?grant_type=refresh_token`, {
      method:'POST',
      headers:{ 'apikey':SB_KEY, 'Content-Type':'application/json' },
      body: JSON.stringify({ refresh_token: sbRefresh }),
    });
    const data = await r.json();
    if(r.ok && data.access_token) {
      sbToken = data.access_token;
      sbRefresh = data.refresh_token || sbRefresh;
      try {
        localStorage.setItem('rbl_sb_token', sbToken);
        if(sbRefresh) localStorage.setItem('rbl_sb_refresh', sbRefresh);
      } catch(e){}
      return true;
    }
  } catch(e){}
  return false;
}

function sbLogout() {
  sbToken = null; sbRefresh = null;
  try { localStorage.removeItem('rbl_sb_token'); localStorage.removeItem('rbl_sb_refresh'); } catch(e){}
}
function sbIsLoggedIn() { return !!sbToken; }

// Eén aanvraag naar Supabase schrijven. Geeft true bij succes.
async function sbInsertRequest(req) {
  if(!SB_ON) return false;
  // Bulk-info in de notitie meenemen (geen aparte kolom nodig in de database)
  let noteWithBulk = req.note || '';
  if(req.bulkQty > 0) {
    const bulkLine = `📦 BULK: ${req.bulkQty} stuks${req.bulkType ? ' — ' + req.bulkType : ''}`;
    noteWithBulk = noteWithBulk ? `${bulkLine}\n${noteWithBulk}` : bulkLine;
  }
  const row = {
    id: req.id,
    name: req.name, first_name: req.firstName, last_name: req.lastName,
    email: req.email, phone: req.phone, payment: req.payment, note: noteWithBulk,
    total_cards: req.totalCards, status: req.status || 'new',
    cards: req.cards || [], csv: req.csv || '', csv_filename: req.csvFilename || '',
  };
  try {
    const r = await fetch(`${SB_URL}/rest/v1/${SB_TABLE}`, {
      method: 'POST', headers: sbHeaders({'Prefer':'return-minimal'}),
      body: JSON.stringify(row),
    });
    return r.ok;
  } catch(e) { return false; }
}

// Alle aanvragen ophalen (nieuwste eerst).
async function sbFetchRequests(_retried) {
  if(!SB_ON) return null;
  try {
    const r = await fetch(`${SB_URL}/rest/v1/${SB_TABLE}?select=*&order=id.desc`, {
      headers: sbHeaders(),
    });
    // Token verlopen? Eén keer vernieuwen en opnieuw proberen.
    if(r.status === 401 && !_retried && sbRefresh) {
      const ok = await sbRefreshToken();
      if(ok) return sbFetchRequests(true);
    }
    if(!r.ok) return null;
    const rows = await r.json();
    // Terug naar het interne formaat dat de admin gebruikt
    return rows.map(row => ({
      id: row.id,
      date: row.created_at ? new Date(row.created_at).toLocaleDateString('nl-NL') : '',
      time: row.created_at ? new Date(row.created_at).toLocaleTimeString('nl-NL',{hour:'2-digit',minute:'2-digit'}) : '',
      name: row.name, firstName: row.first_name, lastName: row.last_name,
      email: row.email, phone: row.phone, payment: row.payment, note: row.note,
      totalCards: row.total_cards, status: row.status, subStatus: row.sub_status,
      offerAmount: row.offer_amount, internalNotes: row.internal_notes,
      tracking: row.tracking, defects: row.defects, compensationAmount: row.compensation_amount,
      cards: row.cards || [], csv: row.csv, csvFilename: row.csv_filename,
      timestamp: row.id,
    }));
  } catch(e) { return null; }
}

// Eén aanvraag bijwerken (alleen de gewijzigde velden).
async function sbUpdateRequest(id, patch) {
  if(!SB_ON) return false;
  // Vertaal interne veldnamen → kolomnamen
  const map = {
    status:'status', subStatus:'sub_status', offerAmount:'offer_amount',
    internalNotes:'internal_notes', tracking:'tracking', defects:'defects',
    compensationAmount:'compensation_amount',
  };
  const row = {};
  Object.keys(patch).forEach(k => { if(map[k]) row[map[k]] = patch[k]; });
  if(!Object.keys(row).length) return false;
  try {
    const r = await fetch(`${SB_URL}/rest/v1/${SB_TABLE}?id=eq.${id}`, {
      method: 'PATCH', headers: sbHeaders({'Prefer':'return-minimal'}),
      body: JSON.stringify(row),
    });
    return r.ok;
  } catch(e) { return false; }
}

// Eén aanvraag verwijderen.
async function sbDeleteRequest(id) {
  if(!SB_ON) return false;
  try {
    const r = await fetch(`${SB_URL}/rest/v1/${SB_TABLE}?id=eq.${id}`, {
      method: 'DELETE', headers: sbHeaders(),
    });
    return r.ok;
  } catch(e) { return false; }
}

// ════════════════════════════════════════════════════════
// CONSTANTEN
// ════════════════════════════════════════════════════════
const CONDS = [
  {code:'NM',label:'Near Mint',   desc:'Vrijwel perfect',    condMult:1.00},
  {code:'EX',label:'Excellent',   desc:'Licht gespeeld',     condMult:0.85},
  {code:'GD',label:'Good',        desc:'Normaal gespeeld',   condMult:0.70},
  {code:'LP',label:'Light Played',desc:'Merkbaar gespeeld',  condMult:0.55},
  {code:'PL',label:'Played',      desc:'Flink gespeeld',     condMult:0.35},
  {code:'PO',label:'Poor',        desc:'Zwaar beschadigd',   condMult:0.15},
];

const LANGS = [
  {code:'EN',label:'🇬🇧 Engels',mult:1.00},
  {code:'NL',label:'🇳🇱 Nederlands',mult:0.90},
];

// Nederlands bestaat alleen voor een handvol oude Pokémon-sets.
// Voor alle andere kaarten tonen we alleen Engels.
const NL_ALLOWED_SETS = ['base set','base','jungle','fossil'];
function nlAllowedFor(card) {
  if(!card || card.game !== 'pokemon') return false;
  const s = (card.setName || '').toLowerCase().trim();
  return NL_ALLOWED_SETS.some(allowed => s === allowed || s.includes(allowed));
}
// Geeft de toegestane taalopties voor een kaart.
function langsFor(card) {
  return nlAllowedFor(card) ? LANGS : LANGS.filter(l => l.code === 'EN');
}

const PRICE_SOURCES = [
  {key:'low',       label:'CM Low',         weight:1.0, desc:'Laagste aanbieding CardMarket'},
  {key:'lowEx',     label:'Low EX+',        weight:1.1, desc:'Laagste EX of beter prijs'},
  {key:'avg7',      label:'AVG 7d',         weight:1.2, desc:'7-daags gemiddelde — meest actueel'},
  {key:'avg30',     label:'AVG 30d',        weight:0.9, desc:'30-daags gemiddelde — langetermijn trend'},
  {key:'trend',     label:'Trend',          weight:1.0, desc:'CardMarket trendprijs'},
];

const GAMES = {
  pokemon:{label:'Pokémon',  color:'#f0c040', slug:'pokemon'},
  mtg:    {label:'Magic: The Gathering',color:'#e05050', slug:'mtg'},
  onepiece:{label:'One Piece',color:'#E8391A',slug:'onepiece'},
};

// ── FINISH-ENGINE ─────────────────────────────────────
// Bepaalt per game/kaart welke finishes mogelijk zijn.
// MTG: normal/foil · Pokémon: normal/holo/reverse holo · overig: normal/foil
const FINISH_LABELS = { normal:'Normal', holo:'Holo', reverse:'Reverse Holo', foil:'Foil' };
function getFinishOptions(card) {
  const game = card.game;
  if(game === 'mtg') {
    // Scryfall levert finishes-array; toon wat de print ondersteunt
    const f = Array.isArray(card.finishes) ? card.finishes : [];
    const opts = [];
    if(!f.length || f.includes('nonfoil')) opts.push('normal');
    if(f.includes('foil') || f.includes('etched')) opts.push('foil');
    return opts.length ? opts : ['normal','foil'];
  }
  if(game === 'pokemon') {
    // Per kaart: alleen de varianten die TCGplayer meldt voor DEZE kaart.
    const keys = Array.isArray(card._variantKeys) ? card._variantKeys : null;
    if(keys && keys.length) {
      const opts = [];
      const lc = keys.map(k => k.toLowerCase());
      const hasNormal  = lc.some(k => k === 'normal');
      const hasReverse = lc.some(k => k.includes('reverse'));
      // "holofoil" zónder "reverse" ervoor = echte holo
      const hasHolo    = lc.some(k => k.includes('holofoil') && !k.includes('reverse'));
      if(hasNormal)  opts.push('normal');
      if(hasHolo)    opts.push('holo');
      if(hasReverse) opts.push('reverse');
      const uniq = [...new Set(opts)];
      return uniq.length ? uniq : ['normal'];
    }
    // Geen variant-info bekend → val terug op rarity-heuristiek.
    // Liever iets te veel keuze tonen dan te weinig.
    const rarity = (card.rarity||'').toLowerCase();
    if(/reverse/.test(rarity)) return ['reverse'];
    if(/holo/.test(rarity))    return ['holo','reverse'];
    if(/common|uncommon/.test(rarity)) return ['normal','reverse'];
    return ['normal','holo','reverse'];
  }
  return ['normal','foil'];
}
// Default finish voor een kaart (eerste optie, of holo/foil als kaart alleen zo bestaat)
function defaultFinish(card) {
  const opts = getFinishOptions(card);
  if(card.game === 'mtg' && Array.isArray(card.finishes) && card.finishes.length===1 && card.finishes[0]==='foil') return 'foil';
  if(/reverse/i.test(card.rarity||'')) return 'reverse';
  if(/holo/i.test(card.rarity||'') && opts.includes('holo')) return 'holo';
  return opts[0] || 'normal';
}

// ── BULK-DETECTIE (alleen Pokémon) ────────────────────
// Pokémon: commons/uncommons in normale finish kopen we als bulk in
//   (€3 per 800). Holo/reverse mag de klant wél los kiezen.
// Magic & overige: GEEN bulk-filter — bulk betekent daar iets heel anders,
//   dus alle kaarten zijn gewoon los toevoegbaar.
function isBulkCard(card, finish) {
  if(card.game !== 'pokemon') return false;   // alleen Pokémon kent dit bulk-begrip
  const rarity = (card.rarity||'').toLowerCase();
  const fin = finish || defaultFinish(card);
  const isCU = /common|uncommon/.test(rarity) && !/holo|rare|ex|gx|v|star|prime|secret|ultra|amazing|radiant|illustration/.test(rarity);
  if(!isCU) return false;
  return fin === 'normal';   // normale common = bulk; holo/reverse = los toevoegbaar
}




const PKM_MAP = {
  SVI:'sv1',PAL:'sv2',OBF:'sv3',MEW:'sv3pt5',PAR:'sv4',PAF:'sv4pt5',
  TEF:'sv5',TWM:'sv6',SFA:'sv6pt5',SCR:'sv7',SSP:'sv8',PRE:'sv8pt5',
  SSH:'swsh1',RCL:'swsh2',DAA:'swsh3',VIV:'swsh4',SHF:'swsh4pt5',
  BST:'swsh5',CRE:'swsh6',EVS:'swsh7',CEL:'swsh7pt5',FST:'swsh8',
  BRS:'swsh9',ASR:'swsh10',PGO:'swsh10pt5',LOR:'swsh11',SIT:'swsh12',CRZ:'swsh12pt5',
  SUM:'sm1',GRI:'sm2',BUS:'sm3',SLG:'sm35',CIN:'sm4',UPR:'sm5',FLI:'sm6',
  CES:'sm7',DRM:'sm75',LOT:'sm8',TEU:'sm9',DET:'sm9pt5',UNM:'sm10',
  UNB:'sm10plus',HIF:'sm11pt5',CEC:'sm12',
  XY:'xy1',FLF:'xy2',FFI:'xy3',PHF:'xy4',PRC:'xy5',ROS:'xy6',
  AOR:'xy7',BKT:'xy8',BKP:'xy9',FCO:'xy10',STS:'xy11',EVO:'xy12',
};

const SK = {cfg:'rbl_cfg_v2', reqs:'rbl_reqs_v2', auth:'rbl_auth', draft:'rbl_draft_v1'};

// Vertaal een Pokémon-setcode (bijv. "SVI", "ASC") naar de PokéTCG set-ID
// (bijv. "sv1"). Gebruikt EERST de live opgehaalde set-lijst (dekt ook
// nieuwe sets), en valt terug op de vaste PKM_MAP als de lijst nog niet
// geladen is. Async, want de set-lijst wordt zo nodig eerst opgehaald.
let _pkmCodeIndex = null;   // { SETCODE: setId } opgebouwd uit de live set-lijst
async function rblResolvePkmSet(code) {
  const up = (code||'').toUpperCase();
  // 1) Snelst: de vaste map (bekende oudere sets)
  if(PKM_MAP[up]) return PKM_MAP[up];
  // 2) Live index opbouwen uit de (gecachete) set-lijst
  if(!_pkmCodeIndex) {
    try {
      const sets = await fetchPokemonSets();  // is zelf al gecachet
      _pkmCodeIndex = {};
      sets.forEach(s => {
        if(s.code) _pkmCodeIndex[s.code.toUpperCase()] = s.id;
        // Ook de set-ID zelf als sleutel (soms typt iemand "sv1" direct)
        if(s.id) _pkmCodeIndex[s.id.toUpperCase()] = s.id;
      });
    } catch(e) { _pkmCodeIndex = {}; }
  }
  if(_pkmCodeIndex[up]) return _pkmCodeIndex[up];
  // 3) Laatste redmiddel: de code in kleine letters (soms is dat al de ID)
  return up.toLowerCase();
}

const RBL_STORAGE_OK = (() => {
  try {
    const t = '__rbl_test__';
    localStorage.setItem(t, '1');
    const ok = localStorage.getItem(t) === '1';
    localStorage.removeItem(t);
    return ok;
  } catch(e) { return false; }
})();

const DEFAULT_CFG = {
  email:'', formspreeId:'', formspreeConfirmId:'', ptcgKey:'', tcgCmKey:'', rapidApiKey:'', pw:'retro2024',
  minOrder:2, maxCard:200, maxOrder:500, priceValid:240, overstockThreshold:150,
  disclaimer:'Alle biedingen zijn geldig onder voorbehoud van conditiebeoordeling bij ontvangst. Wij behouden ons het recht voor een aangepast bod te doen indien de kaart niet overeenkomt met de opgegeven conditie.',
  payment:'Tikkie, Bankoverschrijving, Contant in de winkel',
  processingTime:'2-3 werkdagen na ontvangst',
  conds:{
    NM:{pct:100,on:true}, EX:{pct:85,on:true}, GD:{pct:68,on:true},
    LP:{pct:48,on:true}, PL:{pct:28,on:true}, PO:{pct:0, on:false},
  },
  langMults:{EN:1.0, NL:0.90, DE:0.90, FR:0.80, ES:0.75, IT:0.75, JP:0.65, PT:0.70},
  sourceWeights:{low:0.4, lowEx:0.5, avg7:2.5, avg30:2.0, trend:2.5},
  hotList:[],
  blackList:[],
};

// ════════════════════════════════════════════════════════
// STATE
// ════════════════════════════════════════════════════════
let cfg     = (() => { try { return JSON.parse(localStorage.getItem(SK.cfg)) || structuredClone(DEFAULT_CFG); } catch(e) { return structuredClone(DEFAULT_CFG); }})();
// Merge any missing keys from defaults
cfg = Object.assign({}, DEFAULT_CFG, cfg);
cfg.conds   = Object.assign({}, DEFAULT_CFG.conds,   cfg.conds   || {});
cfg.langMults = Object.assign({}, DEFAULT_CFG.langMults, cfg.langMults || {});
cfg.sourceWeights = Object.assign({}, DEFAULT_CFG.sourceWeights, cfg.sourceWeights || {});
// Eenmalige migratie: weging → AVG/Trend dominant (Low is vaak verouderd)
if(!cfg._weightsV3) {
  cfg.sourceWeights = Object.assign({}, DEFAULT_CFG.sourceWeights);
  cfg._weightsV3 = true;
  try { localStorage.setItem(SK.cfg, JSON.stringify(cfg)); } catch(e){}
}
// Eenmalige migratie: inkooppercentages → 100% NM (trend-basis)
if(!cfg._pctV4) {
  cfg.conds = Object.assign({}, DEFAULT_CFG.conds);
  cfg._pctV4 = true;
  try { localStorage.setItem(SK.cfg, JSON.stringify(cfg)); } catch(e){}
}
// ── Vaste instellingen uit RBL_FIXED toepassen ──
// Deze winnen altijd, zodat wachtwoord/e-mail/Formspree nooit verdwijnen.
['pw','email','formspreeId','formspreeConfirmId','formspreeInviteId','idFormUrl'].forEach(k => {
  const v = rblFixed(k);
  if(v !== null) cfg[k] = v;
});
if(!cfg.hotList)  cfg.hotList  = [];
if(!cfg.blackList)cfg.blackList= [];

let reqs    = (() => { try { return JSON.parse(localStorage.getItem(SK.reqs)) || []; } catch(e) { return []; }})();
let cart    = [];

// ════════════════════════════════════════════════════════
// DRIE GESCHEIDEN ID'S — strikt uit elkaar gehouden:
//   1. sourceCardId        → ID van de bron-API (PokéTCG card id, Scryfall id)
//   2. cardmarketProductId  → alleen prijs/mapping; MAG LEEG; NOOIT voor samenvoegen
//   3. internalKey          → onze eigen sleutel; ALTIJD voor cart/list/CSV/backoffice
//
// internalKey is PER GAME opgebouwd uit de juiste velden. Geen enkele externe
// prijs/groep-ID (oracle_id, cardmarket_id, tcgplayer_id) zit erin.
// ════════════════════════════════════════════════════════
function makeInternalKey(card, game, options = {}) {
  game = game || card.game || '';
  const lang = (options.language ?? card.language ?? card.lang ?? '').toString();
  const cond = (options.condition ?? card.condition ?? card.cond ?? '').toString();
  const slug = v => String(v ?? '').toLowerCase().trim().replace(/\s+/g,'-');

  // De BRON-kaart-id (PokéTCG card id zoals "bw9-106", of Scryfall id) is
  // gegarandeerd uniek per setversie. Dit is de ruggengraat van de key —
  // NOOIT alleen setName/setCode (die kunnen botsen tussen setversies).
  const sourceId = card.sourceCardId || card.scryfallId || card.apiId || '';

  let parts;
  switch(game) {
    case 'mtg': {
      const finish = options.finish || card.finish ||
        (Array.isArray(card.finishes) && card.finishes.includes('foil') && card.finishes.length===1 ? 'foil' : 'nonfoil');
      // mtg | scryfallId | set | collector_number | name | lang | finish | condition
      parts = ['mtg',
        sourceId,                                  // scryfall id = uniek per print
        card.setCode || card.set || '',
        card.number || card.collector_number || '',
        card.name || '',
        lang || card.lang || 'en',
        finish,
        cond];
      break;
    }
    case 'pokemon': {
      const variant = options.finish || card.variant || (/reverse/i.test(card.rarity||'') ? 'reverse' : (/holo/i.test(card.rarity||'') ? 'holo' : 'normal'));
      // pokemon | cardId | setId | number | name | variant | lang | condition
      parts = ['pokemon',
        sourceId,                                  // PokéTCG card id = uniek per setversie
        card.setId || card.set?.id || '',
        card.number || card.localId || '',
        card.name || '',
        variant,
        lang, cond];
      break;
    }
    case 'yugioh': {
      parts = ['yugioh',
        sourceId,
        card.setCode || '',
        card.number || card.cn || '',
        card.name || '',
        card.edition || (card.isFirstEd ? '1st' : 'unlimited'),
        lang, cond];
      break;
    }
    case 'onepiece':
    case 'lorcana': {
      const variant = card.variant || (/foil|holo|parallel/i.test(card.rarity||'') ? 'foil' : 'normal');
      parts = [game,
        sourceId,
        card.setCode || '',
        card.number || '',
        card.name || '',
        variant,
        lang, cond];
      break;
    }
    default: {
      parts = [game, sourceId, card.number || '', card.name || '', lang, cond];
    }
  }
  return parts.map(slug).join('|');
}

// Identiteit zonder taal/conditie — voor de "hoeveel van deze kaart"-badge
function makeCardBaseKey(card, game) {
  return makeInternalKey(card, game || card.game, { language:'', condition:'' });
}

// DEBUG: toont in console exact welke velden gebruikt zijn voor de identiteit.
// Helpt set-mismatches direct opsporen.
function rblDebugCard(where, srcCard, cartItem) {
  try {
    console.log(`[KAART-DEBUG ${where}]`, {
      game:               srcCard.game,
      name:               srcCard.name,
      setId:              srcCard.setId || srcCard.set?.id || '(geen)',
      setCode:            srcCard.setCode || '(geen)',
      setName:            srcCard.setName || '(geen)',
      collectorNumber:    srcCard.number || '(geen)',
      sourceCardId:       cartItem?.sourceCardId || srcCard.sourceCardId || srcCard.apiId || '(geen)',
      cardmarketProductId:cartItem?.cardmarketProductId ?? '(leeg)',
      oracleId:           srcCard.oracleId || '(n.v.t.)',
      internalKey:        cartItem?.internalKey || '(geen)',
    });
  } catch(e) {}
}




let gameMode= 'all';
let acTimer = null;
let adminOn = false;
let reqFil  = 'all';
let selCard = null;
let selLang = 'EN';
const _cache= {};

// ── ROBUUSTE FETCH: timeout + automatische retry ─────────────────────
// De externe API's (PokéTCG, Scryfall) reageren soms traag of falen even.
// Zonder retry lijkt een kaart dan "niet gevonden", terwijl een tweede
// poging meestal wél lukt. Deze helper probeert het tot 3× met een
// oplopende wachttijd, en breekt af als het te lang duurt (timeout).
async function rblFetch(url, opts, cfg2) {
  cfg2 = cfg2 || {};
  const tries   = cfg2.tries || 3;      // aantal pogingen
  const timeout = cfg2.timeout || 8000; // max wachttijd per poging (ms)
  let lastErr;
  for(let i = 0; i < tries; i++) {
    try {
      const ctrl = new AbortController();
      const timer = setTimeout(() => ctrl.abort(), timeout);
      const r = await fetch(url, Object.assign({}, opts, { signal: ctrl.signal }));
      clearTimeout(timer);
      // 429 (rate limit) of 5xx (serverfout) → opnieuw proberen
      if(r.status === 429 || r.status >= 500) {
        lastErr = new Error('HTTP ' + r.status);
      } else {
        return r; // ok of een "echte" fout (bv 404) → teruggeven
      }
    } catch(e) {
      lastErr = e; // timeout of netwerkfout → opnieuw proberen
    }
    // Even wachten voor de volgende poging (350ms, 700ms, ...)
    if(i < tries - 1) await new Promise(res => setTimeout(res, 350 * (i + 1)));
  }
  throw lastErr || new Error('fetch mislukt');
}

// ── ZOEKRESULTAAT-CACHE (per sessie) ─────────────────────
// Onthoudt zoekresultaten zodat dezelfde zoekopdracht de tweede keer
// direct verschijnt, zonder opnieuw de trage API te bevragen.
const _searchCache = new Map();
function _scGet(key) {
  const hit = _searchCache.get(key);
  if(!hit) return null;
  // 10 minuten geldig
  if(Date.now() - hit.t > 10 * 60 * 1000) { _searchCache.delete(key); return null; }
  return hit.v;
}
function _scSet(key, val) {
  _searchCache.set(key, { v: val, t: Date.now() });
  // Cache niet oneindig laten groeien
  if(_searchCache.size > 200) {
    const first = _searchCache.keys().next().value;
    _searchCache.delete(first);
  }
}

// ── BACKOFFICE WORKFLOW-STATUSSEN ─────────────────────
// Volgorde van de keten + label, kleur en de volgende stap.
const REQ_STAGES = [
  { key:'new',       label:'Nieuw',           color:'#3b82f6', next:'reviewing' },
  { key:'reviewing', label:'Wordt beoordeeld', color:'#8b5cf6', next:'offer' },
  { key:'offer',     label:'Bod naar klant',   color:'#f59e0b', next:'shipping' },
  { key:'shipping',  label:'Verzending',       color:'#06b6d4', next:'checking' },
  { key:'checking',  label:'Controle',         color:'#ec4899', next:'done' },
  { key:'done',      label:'Afgerond',         color:'#16a34a', next:null },
  { key:'rejected',  label:'Afgewezen',        color:'#ef4444', next:null },
];
const REQ_STAGE = Object.fromEntries(REQ_STAGES.map(s => [s.key, s]));
// Sub-statussen binnen een fase (vrije keuze door winkelier)
const OFFER_SUB = ['Bod staat klaar','Bod verzonden','Klant akkoord','Bod afgeslagen'];
const SHIP_SUB  = ['Label toegevoegd','Verzonden naar Retro Empire','Kaarten ontvangen'];
const CHECK_SUB = ['Beoordeeld & akkoord','Mankement gemeld','Compensatie voorgesteld','Klant akkoord met compensatie'];
// Oude statussen → nieuwe keten (zodat bestaande aanvragen blijven werken)
const LEGACY_STATUS = { pending:'reviewing', approved:'done' };
function normalizeStatus(s) { return REQ_STAGE[s] ? s : (LEGACY_STATUS[s] || 'new'); }


// ════════════════════════════════════════════════════════
// FAIR BUY PRICE ALGORITME
// ════════════════════════════════════════════════════════
/**
 * Berekent de Fair Buy Price op basis van meerdere CardMarket bronnen.
 * 
 * Logica:
 * 1. Bepaal betrouwbaarheid van elke bron (gewogen)
 * 2. Pas marktdiepte correctie toe (weinig listings = onbetrouwbaar)
 * 3. Pas liquiditeit correctie toe (weinig verkopen = lagere prijs)
 * 4. Pas voorraadcorrectie toe (overstock = lagere prijs)
 * 5. Geef eerlijk bod terug met onderbouwing
 */
function calcFairBuyPrice(prices, options = {}) {
  const {
    listingCount   = null,   // aantal aanbiedingen op CM
    soldLast30     = null,   // verkopen afgelopen 30 dagen
    stockLevel     = null,   // huidige voorraad in winkel
    targetStock    = null,   // gewenste voorraad
    isHotList      = false,  // staat op hot list
    hotBonus       = 0,      // % bonus als hot list
    cardName       = '',
  } = options;

  const { low, lowEx, avg7, avg30, trend } = prices;
  const weights = cfg.sourceWeights;

  // ── Stap 1: Beschikbare bronnen beoordelen ──────────────
  const sources = [];
  const reasoning = [];
  let warnings = [];

  if(low    != null && low    > 0) sources.push({key:'low',    val:low,    w:weights.low});
  if(lowEx  != null && lowEx  > 0) sources.push({key:'lowEx',  val:lowEx,  w:weights.lowEx});
  if(avg7   != null && avg7   > 0) sources.push({key:'avg7',   val:avg7,   w:weights.avg7});
  if(avg30  != null && avg30  > 0) sources.push({key:'avg30',  val:avg30,  w:weights.avg30});
  if(trend  != null && trend  > 0) sources.push({key:'trend',  val:trend,  w:weights.trend});

  if(sources.length === 0) {
    return { fbp: null, source: 'none', reasoning: 'Geen prijsdata beschikbaar', warnings:[], breakdown:{} };
  }

  // ── Stap 1b: Uitschieters verwijderen ──────────────────
  // PokéTCG vervuilt soms trend/avg30 met een dure variant.
  // Bij een goedkope kaart trekt dat het gemiddelde absurd omhoog
  // (bv. bulk Charmander die plots €54 "kost").
  // Oplossing: bereken de mediaan, gooi bronnen weg die >3× of
  // <0.33× de mediaan zijn.
  if(sources.length >= 3) {
    const vals = sources.map(s => s.val).sort((a,b) => a-b);
    const median = vals[Math.floor(vals.length/2)];
    if(median > 0) {
      const kept = sources.filter(s => s.val <= median*3 && s.val >= median*0.33);
      const removed = sources.length - kept.length;
      if(kept.length >= 2 && removed > 0) {
        sources.length = 0;
        kept.forEach(s => sources.push(s));
        warnings.push(`⚠ ${removed} afwijkende prijsbron(nen) genegeerd (mogelijk verkeerde variant)`);
        reasoning.push('Uitschieters t.o.v. mediaan verwijderd');
      }
    }
  }

  // ── Extra vangnet: als low heel laag is maar trend/avg extreem
  // hoger, vertrouw dan de LOW (dat is de echte goedkope kaart) ──
  if(low != null && low > 0) {
    const others = sources.filter(s => s.key !== 'low').map(s => s.val);
    if(others.length && Math.min(...others) > low * 5) {
      // Alle andere bronnen zijn 5×+ hoger dan low → low is de echte kaart
      sources.length = 0;
      sources.push({key:'low', val:low, w:1.0});
      if(lowEx != null && lowEx > 0 && lowEx <= low*2) sources.push({key:'lowEx', val:lowEx, w:0.8});
      warnings.push('⚠ Hoge varianten genegeerd — Low prijs gebruikt (echte kaartwaarde)');
      reasoning.push('Low veel lager dan rest → variant-vervuiling gecorrigeerd');
    }
  }

  // ── Stap 2: Marktdiepte correctie ─────────────────────
  // Weinig listings → low prijs onbetrouwbaar (één dure seller zet de toon)
  let depthFactor = 1.0;
  if(listingCount !== null) {
    if(listingCount < 3) {
      depthFactor = 0.80;
      warnings.push('⚠ Minder dan 3 aanbiedingen — prijs onbetrouwbaar, voorzichtig bieden');
      // Verlaag gewicht van 'low' drastisch
      sources.forEach(s => { if(s.key === 'low' || s.key === 'lowEx') s.w *= 0.5; });
      // AVG bronnen zijn nu betrouwbaarder
      sources.forEach(s => { if(s.key === 'avg7' || s.key === 'avg30') s.w *= 1.4; });
      reasoning.push(`Lage marktdiepte (${listingCount} listings) → AVG bronnen zwaarder gewogen`);
    } else if(listingCount >= 20) {
      // Diepe markt → low prijs is realistischer
      sources.forEach(s => { if(s.key === 'low' || s.key === 'lowEx') s.w *= 1.15; });
      reasoning.push(`Diepe markt (${listingCount} listings) → Low prijs betrouwbaarder`);
    }
  }

  // ── Stap 3: Liquiditeitsanalyse ────────────────────────
  // Weinig verkopen → kaart is moeilijk te verkopen → lagere inkoop
  let liquidityFactor = 1.0;
  if(soldLast30 !== null) {
    if(soldLast30 === 0) {
      liquidityFactor = 0.70;
      warnings.push('⚠ Geen verkopen afgelopen 30 dagen — lage liquiditeit');
      reasoning.push('Nul verkopen 30d → liquiditeitsfactor 0.70');
    } else if(soldLast30 <= 2) {
      liquidityFactor = 0.85;
      warnings.push('⚠ Lage liquiditeit — ' + soldLast30 + ' verkopen in 30 dagen');
      reasoning.push(`Lage verkopen (${soldLast30}/30d) → liquiditeitsfactor 0.85`);
    } else if(soldLast30 >= 10) {
      liquidityFactor = 1.05; // Populaire kaart → kan iets hoger bieden
      reasoning.push(`Hoge liquiditeit (${soldLast30}/30d) → lichte bonus`);
    }
  }

  // ── Stap 4: Prijstrend analyse ─────────────────────────
  // Als avg7 >> avg30 → prijs stijgt → hoger bieden
  // Als avg7 << avg30 → prijs daalt → lager bieden
  let trendFactor = 1.0;
  if(avg7 && avg30 && avg30 > 0) {
    const trendDelta = (avg7 - avg30) / avg30;
    if(trendDelta > 0.15) {
      trendFactor = 1.08;
      reasoning.push(`Stijgende trend (+${(trendDelta*100).toFixed(0)}%) → lichte bonus`);
    } else if(trendDelta < -0.15) {
      trendFactor = 0.88;
      warnings.push(`⚠ Dalende trend (${(trendDelta*100).toFixed(0)}%) — wees voorzichtig`);
      reasoning.push(`Dalende trend (${(trendDelta*100).toFixed(0)}%) → voorzichtiger bod`);
    }
  }

  // ── Stap 5: Gewogen gemiddelde berekenen ───────────────
  const totalWeight = sources.reduce((s, x) => s + x.w, 0);
  const weightedAvg = sources.reduce((s, x) => s + (x.val * x.w), 0) / totalWeight;

  // ── Stap 6: Voorraadcorrectie ──────────────────────────
  let stockFactor = 1.0;
  if(stockLevel !== null && targetStock !== null && targetStock > 0) {
    const stockRatio = stockLevel / targetStock * 100;
    const threshold  = cfg.overstockThreshold || 150;
    if(stockRatio >= threshold) {
      stockFactor = 0.75;
      warnings.push(`⚠ Overstock (${stockRatio.toFixed(0)}% van target) → prijs verlaagd`);
      reasoning.push(`Overstock ${stockRatio.toFixed(0)}% → stockfactor 0.75`);
    } else if(stockRatio < 50) {
      stockFactor = 1.10;
      reasoning.push(`Laag voorraad (${stockRatio.toFixed(0)}% van target) → stock bonus`);
    }
  }

  // ── Stap 7: Hot List bonus ─────────────────────────────
  let hotFactor = 1.0;
  if(isHotList && hotBonus > 0) {
    hotFactor = 1 + (hotBonus / 100);
    reasoning.push(`🔥 Hot List bonus +${hotBonus}% → we zoeken extra naar deze kaart`);
  }

  // ── Stap 8: Finale berekening ──────────────────────────
  let fbp = weightedAvg * depthFactor * liquidityFactor * trendFactor * stockFactor * hotFactor;

  // Bepaal dominante bron (hoogste gewicht na correcties)
  const dominantSource = sources.sort((a,b) => b.w - a.w)[0];
  const sourceLabels = {low:'CM Low', lowEx:'Low EX+', avg7:'AVG 7d', avg30:'AVG 30d', trend:'Trend'};

  // Geef ook 'aanbevolen bron' terug voor transparantie
  let recommendedSource = 'Gewogen gemiddelde';
  if(sources.length === 1) recommendedSource = sourceLabels[sources[0].key] || sources[0].key;
  else if(listingCount !== null && listingCount < 3) recommendedSource = 'AVG 30d (lage marktdiepte)';
  else if(avg7 && avg30) recommendedSource = 'AVG 7d + Trend gewogen';

  return {
    fbp:        Math.round(fbp * 100) / 100,
    source:     recommendedSource,
    reasoning:  reasoning.join(' · ') || 'Standaard gewogen gemiddelde van alle bronnen',
    warnings,
    breakdown: {
      low:    low    ? `€${low.toFixed(2)}`    : '—',
      lowEx:  lowEx  ? `€${lowEx.toFixed(2)}`  : '—',
      avg7:   avg7   ? `€${avg7.toFixed(2)}`   : '—',
      avg30:  avg30  ? `€${avg30.toFixed(2)}`  : '—',
      trend:  trend  ? `€${trend.toFixed(2)}`  : '—',
    },
    dominantKey: dominantSource?.key || 'avg7',
    factors: { depthFactor, liquidityFactor, trendFactor, stockFactor, hotFactor },
  };
}

// Bereken inkoopprijs voor een specifieke conditie + taal
function calcBuyPrice(fbp, condCode, langCode) {
  if(!fbp || fbp <= 0) return null;
  const cond = cfg.conds[condCode];
  if(!cond || !cond.on || !cond.pct) return null;
  const condMult = CONDS.find(c => c.code === condCode)?.condMult || 1.0;
  const langMult = cfg.langMults[langCode] || 1.0;
  const price = fbp * (cond.pct / 100) * langMult;
  return Math.round(price * 100) / 100;
}

// ════════════════════════════════════════════════════════
// INIT
// ════════════════════════════════════════════════════════
// ── Admin knop verborgen: alleen zichtbaar via ?beheer=1 in de URL ──
// of via 5× snel klikken op de hero titel
(function adminUnlock(){
  const params = new URLSearchParams(location.search);
  if(params.get('beheer') === '1' || sessionStorage.getItem('rbl_admin_visible')) {
    document.querySelector('#rbl .admin-bar')?.classList.add('unlocked');
    sessionStorage.setItem('rbl_admin_visible','1');
  }
  // Geheime klik: 5× op de hero titel binnen 3 seconden
  let clicks = 0, timer = null;
  const hero = document.querySelector('#rbl .hero h2');
  if(hero) hero.addEventListener('click', () => {
    clicks++;
    clearTimeout(timer);
    timer = setTimeout(() => clicks = 0, 3000);
    if(clicks >= 5) {
      document.querySelector('#rbl .admin-bar')?.classList.add('unlocked');
      sessionStorage.setItem('rbl_admin_visible','1');
      clicks = 0;
    }
  });
  // Waarschuw als opslag niet werkt (anders verdwijnt alles bij refresh)
  if(!RBL_STORAGE_OK) {
    const bar = document.querySelector('#rbl .admin-bar');
    if(bar && !document.getElementById('rblStorageWarn')) {
      const w = document.createElement('div');
      w.id = 'rblStorageWarn';
      w.style.cssText = 'background:#7f1d1d;color:#fff;padding:10px 14px;border-radius:8px;margin:8px 0;font-size:14px;line-height:1.5';
      w.innerHTML = '⚠ <strong>Let op:</strong> opslag werkt niet in deze weergave. Instellingen en aanvragen blijven niet bewaard bij verversen. Open deze pagina rechtstreeks op je eigen domein (niet in de Shopify-voorbeeldweergave/theme-editor) en niet in een incognitovenster.';
      bar.parentNode?.insertBefore(w, bar.nextSibling);
    }
  }
})();

// Haalt de aanvragen centraal op uit Supabase en ververst de admin-lijst.
// Wordt aangeroepen bij het laden en kan handmatig herhaald worden (🔄 knop).
async function rblSyncFromSupabase() {
  if(!SB_ON) return;
  const rows = await sbFetchRequests();
  if(rows) {
    reqs = rows;
    try { localStorage.setItem(SK.reqs, JSON.stringify(reqs)); } catch(e){}
    try { renderReqs(); updateBadge(); } catch(e){}
  }
}
window.rblSyncFromSupabase = rblSyncFromSupabase;
// Bij het laden alleen synchroniseren als je al ingelogd bent (lezen vereist login)
if(SB_ON && sbIsLoggedIn()) { rblSyncFromSupabase().catch(()=>{}); }

// Handmatig vernieuwen via de 🔄 knop in de Aanvragen-tab
window.rblManualSync = async function(btn) {
  if(!SB_ON) { rblToast('Supabase is niet ingesteld', true); return; }
  const orig = btn ? btn.textContent : '';
  if(btn) { btn.textContent = '⏳ Bezig…'; btn.disabled = true; }
  await rblSyncFromSupabase();
  if(btn) { btn.textContent = orig; btn.disabled = false; }
  rblToast('Aanvragen vernieuwd');
};

try { buildCondTable(); } catch(e) { console.warn('buildCondTable', e); }
try { buildAlgoTable(); } catch(e) { console.warn('buildAlgoTable', e); }
try { buildLangPcts(); } catch(e) { console.warn('buildLangPcts', e); }
try { buildPreview(); } catch(e) { console.warn('buildPreview', e); }
try { loadCfgForm(); } catch(e) { console.warn('loadCfgForm', e); }
try { buildHotListAdmin(); } catch(e) { console.warn('buildHotListAdmin', e); }
try { buildBlackListAdmin(); } catch(e) { console.warn('buildBlackListAdmin', e); }
try { renderHotListDisplay(); } catch(e) { console.warn('renderHotListDisplay', e); }
try { renderReqs(); } catch(e) { console.warn('renderReqs', e); }
try { updateBadge(); } catch(e) { console.warn('updateBadge', e); }
try { rblRenderResumeBanner(); } catch(e) { console.warn('resumeBanner', e); }

// ════════════════════════════════════════════════════════
// ADMIN
// ════════════════════════════════════════════════════════
window.rblToggleAdmin = function() {
  adminOn = !adminOn;
  const btn   = document.getElementById('rblBtnAdmin');
  const panel = document.getElementById('rblAdminPanel');
  btn.textContent = adminOn ? '✕ Sluiten' : '⚙ Admin';
  btn.classList.toggle('on', adminOn);
  panel.classList.toggle('show', adminOn);
  if(adminOn && sessionStorage.getItem(SK.auth)) {
    document.getElementById('rblPwCheck').style.display = 'none';
    document.getElementById('rblAdminContent').style.display = 'block';
  }
};

window.rblCheckPw = function() {
  if(document.getElementById('rblPwInp').value === cfg.pw) {
    sessionStorage.setItem(SK.auth, '1');
    document.getElementById('rblPwCheck').style.display = 'none';
    document.getElementById('rblAdminContent').style.display = 'block';
  } else {
    rblToast('Verkeerd wachtwoord', true);
  }
};

window.rblAdminTab = function(name, el) {
  document.querySelectorAll('#rbl .atab').forEach(b => b.classList.remove('on'));
  document.querySelectorAll('#rbl .atab-panel').forEach(p => p.classList.remove('on'));
  el.classList.add('on');
  document.getElementById('rblTab' + name.charAt(0).toUpperCase() + name.slice(1)).classList.add('on');
  // Aanvragen-tab vereist een Supabase-login (beveiliging van klantgegevens)
  if(name === 'requests') rblRenderReqGate();
};

// Toont óf de login, óf de aanvragenlijst — afhankelijk van of je ingelogd bent.
function rblRenderReqGate() {
  const gate = document.getElementById('rblReqGate');
  const content = document.getElementById('rblReqContent');
  if(!gate || !content) return;
  if(!SB_ON) {
    // Geen Supabase ingesteld → toon gewoon de lokale lijst (geen beveiliging mogelijk)
    gate.style.display = 'none';
    content.style.display = '';
    return;
  }
  if(sbIsLoggedIn()) {
    gate.style.display = 'none';
    content.style.display = '';
    rblSyncFromSupabase().catch(()=>{});
  } else {
    gate.style.display = '';
    content.style.display = 'none';
  }
}

window.rblDoSbLogin = async function() {
  const email = document.getElementById('rblSbEmail')?.value.trim() || '';
  const pw    = document.getElementById('rblSbPw')?.value || '';
  const errEl = document.getElementById('rblSbLoginErr');
  if(errEl) { errEl.textContent = ''; errEl.style.display = 'none'; }
  if(!email || !pw) { if(errEl){errEl.textContent='Vul e-mail en wachtwoord in';errEl.style.display='block';} return; }
  const btn = document.getElementById('rblSbLoginBtn');
  if(btn){ btn.textContent='⏳ Bezig…'; btn.disabled=true; }
  const res = await sbLogin(email, pw);
  if(btn){ btn.textContent='Inloggen'; btn.disabled=false; }
  if(res.ok) {
    rblToast('Ingelogd ✓');
    rblRenderReqGate();
  } else {
    if(errEl){ errEl.textContent = res.error || 'Inloggen mislukt'; errEl.style.display='block'; }
  }
};

window.rblDoSbLogout = function() {
  sbLogout();
  reqs = [];
  try { renderReqs(); updateBadge(); } catch(e){}
  rblRenderReqGate();
  rblToast('Uitgelogd');
};

function buildCondTable() {
  const tb = document.getElementById('rblCondTbody');
  if(!tb) return;
  tb.innerHTML = CONDS.map(c => {
    const s = cfg.conds[c.code] || {pct:0, on:false};
    return `<tr>
      <td><div class="ct-nm">${c.code}</div></td>
      <td><div class="ct-dc">${c.desc}</div></td>
      <td><input class="pct-inp" type="number" id="rblPct_${c.code}" value="${s.pct}" min="0" max="100" step="5" oninput="rblLivePreview()"> %</td>
      <td><input type="checkbox" id="rblOn_${c.code}" ${s.on?'checked':''} onchange="rblLivePreview()"></td>
    </tr>`;
  }).join('');
}

function buildAlgoTable() {
  const tb = document.getElementById('rblAlgoTbody');
  if(!tb) return;
  tb.innerHTML = PRICE_SOURCES.map(s => {
    const w = cfg.sourceWeights[s.key] ?? s.weight;
    return `<tr>
      <td><div class="ct-nm">${s.label}</div></td>
      <td><div class="ct-dc">${s.desc}</div></td>
      <td><input class="pct-inp" type="number" id="rblW_${s.key}" value="${w}" min="0.1" max="3" step="0.1" style="width:70px" oninput="rblSyncWeights()"></td>
    </tr>`;
  }).join('');
}

function rblSyncWeights() {
  PRICE_SOURCES.forEach(s => {
    const el = document.getElementById('rblW_'+s.key);
    if(el) cfg.sourceWeights[s.key] = parseFloat(el.value) || s.weight;
  });
}

function buildLangPcts() {
  const wrap = document.getElementById('rblLangPcts');
  if(!wrap) return;
  wrap.innerHTML = LANGS.map(l => {
    const m = cfg.langMults[l.code] ?? l.mult;
    return `<div class="lang-pct-cell">
      <label>${l.label}</label>
      <input class="pct-inp" type="number" id="rblLm_${l.code}" value="${m}" min="0.1" max="2" step="0.05" style="width:100%">
    </div>`;
  }).join('');
}

window.rblLivePreview = function() {
  CONDS.forEach(c => {
    const p = document.getElementById('rblPct_'+c.code);
    const o = document.getElementById('rblOn_'+c.code);
    if(p) cfg.conds[c.code].pct = parseInt(p.value)||0;
    if(o) cfg.conds[c.code].on  = o.checked;
  });
  buildPreview();
};

function buildPreview() {
  const g = document.getElementById('rblPvGrid');
  if(!g) return;
  const fbp = 10;
  g.innerHTML = CONDS.map(c => {
    const s = cfg.conds[c.code] || {pct:0,on:false};
    const price = s.on && s.pct > 0 ? (fbp * s.pct/100).toFixed(2) : null;
    return `<div class="pv-cell${price?'':' off'}">
      <div class="pv-code">${c.code}</div>
      ${price ? `<div class="pv-price">€${price}</div><div class="pv-pct">${s.pct}%</div>` : '<div style="font-size:12px;color:var(--txt4);font-style:italic">Niet</div>'}
    </div>`;
  }).join('');
}

function loadCfgForm() {
  ['cfgEmail','cfgPtcg','cfgPw','cfgDisclaimer','cfgPayment','cfgTime'].forEach(id => {
    const el = document.getElementById('rbl'+id.charAt(0).toUpperCase()+id.slice(1));
    if(!el) return;
    const map = {cfgEmail:'email',cfgPtcg:'ptcgKey',cfgPw:'',cfgDisclaimer:'disclaimer',cfgPayment:'payment',cfgTime:'processingTime'};
    if(map[id]) el.value = cfg[map[id]] || '';
  });
  const eMax = document.getElementById('rblMaxCard'); if(eMax) eMax.value = cfg.maxCard||200;
  const eMaxO= document.getElementById('rblMaxOrder');if(eMaxO)eMaxO.value = cfg.maxOrder||500;
  const eMin = document.getElementById('rblMinOrder');if(eMin) eMin.value = cfg.minOrder||2;
  const ePV  = document.getElementById('rblPriceValid');if(ePV) ePV.value = cfg.priceValid||240;
  const eOs  = document.getElementById('rblOverstock');if(eOs) eOs.value = cfg.overstockThreshold||150;
  const eTcg = document.getElementById('rblCfgTcgCm'); if(eTcg) eTcg.value = cfg.tcgCmKey||'';
  const eRap = document.getElementById('rblCfgRapid'); if(eRap) eRap.value = cfg.rapidApiKey||'';
  const eFs  = document.getElementById('rblCfgFormspree'); if(eFs) eFs.value = cfg.formspreeId||'';
  const eFsC = document.getElementById('rblCfgFormspreeConfirm'); if(eFsC) eFsC.value = cfg.formspreeConfirmId||'';
}

window.rblSaveSettings = function() {
  rblLivePreview();
  rblSyncWeights();
  LANGS.forEach(l => {
    const el = document.getElementById('rblLm_'+l.code);
    if(el) cfg.langMults[l.code] = parseFloat(el.value) || l.mult;
  });
  cfg.email              = document.getElementById('rblCfgEmail')?.value.trim()||'';
  cfg.formspreeId        = document.getElementById('rblCfgFormspree')?.value.trim()||'';
  cfg.formspreeConfirmId = document.getElementById('rblCfgFormspreeConfirm')?.value.trim()||'';
  cfg.ptcgKey            = document.getElementById('rblCfgPtcg')?.value.trim()||'';
  cfg.tcgCmKey           = document.getElementById('rblCfgTcgCm')?.value.trim()||'';
  cfg.rapidApiKey        = document.getElementById('rblCfgRapid')?.value.trim()||'';
  cfg.disclaimer         = document.getElementById('rblCfgDisclaimer')?.value.trim()||DEFAULT_CFG.disclaimer;
  cfg.payment            = document.getElementById('rblCfgPayment')?.value.trim()||'';
  cfg.processingTime     = document.getElementById('rblCfgTime')?.value.trim()||'';
  cfg.maxCard            = parseFloat(document.getElementById('rblMaxCard')?.value)||200;
  cfg.maxOrder           = parseFloat(document.getElementById('rblMaxOrder')?.value)||500;
  cfg.minOrder           = parseFloat(document.getElementById('rblMinOrder')?.value)||2;
  cfg.priceValid         = parseInt(document.getElementById('rblPriceValid')?.value)||240;
  cfg.overstockThreshold = parseInt(document.getElementById('rblOverstock')?.value)||150;
  const newPw = document.getElementById('rblCfgPw')?.value.trim();
  if(newPw) cfg.pw = newPw;
  localStorage.setItem(SK.cfg, JSON.stringify(cfg));
  renderHotListDisplay();
  rblToast('Instellingen opgeslagen ✓');
};

// ── API VERBINDINGSTEST ──────────────────────
window.rblTestApis = async function() {
  // Sla eerst de huidige keys op zodat we de actuele waarden testen
  const ptcgKey  = document.getElementById('rblCfgPtcg')?.value.trim() || '';
  const tcgCmKey = document.getElementById('rblCfgTcgCm')?.value.trim() || '';
  const rapidKey = document.getElementById('rblCfgRapid')?.value.trim() || '';
  cfg.ptcgKey  = ptcgKey;
  cfg.tcgCmKey = tcgCmKey;
  cfg.rapidApiKey = rapidKey;

  const box = document.getElementById('rblApiTestResult');
  box.innerHTML = '⏳ Testen…';
  const lines = [];

  // Test 1: PokéTCG — bekende kaart Charizard met prijzen
  try {
    const hdrs = ptcgKey ? { 'X-Api-Key': ptcgKey } : {};
    const r = await fetch('https://api.pokemontcg.io/v2/cards/base1-4', { headers: hdrs });
    if(r.ok) {
      const d = await r.json();
      const cm = d.data?.cardmarket?.prices;
      if(cm && (cm.lowPrice || cm.trendPrice || cm.averageSellPrice)) {
        const price = cm.trendPrice || cm.averageSellPrice || cm.lowPrice;
        lines.push(`<div style="color:var(--grn3)">✅ <strong>PokéTCG</strong> werkt — prijzen komen binnen (Charizard ≈ €${price})${ptcgKey?' [met key]':' [zonder key]'}</div>`);
      } else {
        lines.push(`<div style="color:var(--ylw)">⚠ <strong>PokéTCG</strong> bereikbaar maar GEEN prijzen in response.${ptcgKey?' Key werkt, maar prijzen ontbreken.':' <strong>Vul een API key in</strong> — zonder key geeft PokéTCG geen prijzen!'}</div>`);
      }
    } else if(r.status === 403) {
      lines.push(`<div style="color:var(--red)">❌ <strong>PokéTCG</strong> — API key geweigerd (403). Controleer de key.</div>`);
    } else if(r.status === 429) {
      lines.push(`<div style="color:var(--red)">❌ <strong>PokéTCG</strong> — rate limit (429). Vul een API key in voor meer requests.</div>`);
    } else {
      lines.push(`<div style="color:var(--red)">❌ <strong>PokéTCG</strong> — fout ${r.status}</div>`);
    }
  } catch(e) {
    lines.push(`<div style="color:var(--red)">❌ <strong>PokéTCG</strong> — geen verbinding (${e.message}). Mogelijk geblokkeerd door je netwerk.</div>`);
  }
  box.innerHTML = lines.join('') + '<div style="color:var(--txt3)">⏳ TCGdex testen…</div>';

  // Test 2: TCGdex — geen key nodig
  try {
    const r = await fetch('https://api.tcgdex.net/v2/en/cards?name=Charizard');
    if(r.ok) {
      const list = await r.json();
      if(Array.isArray(list) && list.length) {
        // Detail ophalen voor prijscheck
        const dr = await fetch(`https://api.tcgdex.net/v2/en/cards/${list[0].id}`);
        const d = await dr.json();
        const cm = d.pricing?.cardmarket;
        if(cm && (cm.low || cm.trend || cm.avg30)) {
          lines.push(`<div style="color:var(--grn3)">✅ <strong>TCGdex</strong> werkt — prijzen beschikbaar (geen key nodig)</div>`);
        } else {
          lines.push(`<div style="color:var(--ylw)">⚠ <strong>TCGdex</strong> bereikbaar maar deze kaart heeft geen prijsdata</div>`);
        }
      } else {
        lines.push(`<div style="color:var(--ylw)">⚠ <strong>TCGdex</strong> bereikbaar maar geen zoekresultaat</div>`);
      }
    } else {
      lines.push(`<div style="color:var(--red)">❌ <strong>TCGdex</strong> — fout ${r.status}</div>`);
    }
  } catch(e) {
    lines.push(`<div style="color:var(--red)">❌ <strong>TCGdex</strong> — geblokkeerd (${e.message})</div>`);
  }
  box.innerHTML = lines.join('') + '<div style="color:var(--txt3)">⏳ Scryfall testen…</div>';

  // Test 3: Scryfall (MTG) — geen key nodig
  try {
    const r = await fetch('https://api.scryfall.com/cards/named?exact=Lightning+Bolt');
    if(r.ok) {
      const d = await r.json();
      lines.push(d.prices?.eur
        ? `<div style="color:var(--grn3)">✅ <strong>Scryfall (MTG)</strong> werkt — EUR prijzen beschikbaar</div>`
        : `<div style="color:var(--ylw)">⚠ <strong>Scryfall</strong> werkt maar geen EUR prijs voor testkaart</div>`);
    } else {
      lines.push(`<div style="color:var(--red)">❌ <strong>Scryfall</strong> — fout ${r.status}</div>`);
    }
  } catch(e) {
    lines.push(`<div style="color:var(--red)">❌ <strong>Scryfall</strong> — geblokkeerd (${e.message})</div>`);
  }

  // Test 4: tcg-cardmarket-api.com (alleen als key ingevuld)
  if(tcgCmKey) {
    try {
      const r = await fetch('https://tcg-api-production-5148.up.railway.app/cards/search?game=one-piece&name=luffy&limit=1', {
        headers: { 'X-API-Key': tcgCmKey }
      });
      if(r.ok)            lines.push(`<div style="color:var(--grn3)">✅ <strong>tcg-cardmarket-api</strong> werkt (One Piece/Lorcana)</div>`);
      else if(r.status===401) lines.push(`<div style="color:var(--red)">❌ <strong>tcg-cardmarket-api</strong> — key ongeldig (401)</div>`);
      else if(r.status===429) lines.push(`<div style="color:var(--red)">❌ <strong>tcg-cardmarket-api</strong> — daglimiet bereikt (429)</div>`);
      else                lines.push(`<div style="color:var(--red)">❌ <strong>tcg-cardmarket-api</strong> — fout ${r.status}</div>`);
    } catch(e) {
      lines.push(`<div style="color:var(--red)">❌ <strong>tcg-cardmarket-api</strong> — geblokkeerd (${e.message})</div>`);
    }
  }

  // Test 5: pokemon-api.com via RapidAPI (de accurate bron)
  if(rapidKey) {
    try {
      const r = await fetch('https://pokemon-tcg-api.p.rapidapi.com/cards?search=charizard&sort=price_highest', {
        headers: { 'x-rapidapi-key': rapidKey, 'x-rapidapi-host': 'pokemon-tcg-api.p.rapidapi.com' }
      });
      if(r.ok) {
        const d = await r.json();
        const arr = d.data || d.cards || (Array.isArray(d)?d:[]);
        const cm = arr[0]?.prices?.cardmarket;
        if(cm && (cm.lowest_near_mint || cm['30d_average'])) {
          lines.push(`<div style="color:var(--grn3)">✅ <strong>⭐ CardMarket Prijs-API</strong> werkt — accurate EU prijzen! (dit lost je prijsprobleem op)</div>`);
        } else {
          lines.push(`<div style="color:var(--ylw)">⚠ <strong>CardMarket Prijs-API</strong> bereikbaar maar geen prijzen in response</div>`);
        }
      }
      else if(r.status===401||r.status===403) lines.push(`<div style="color:var(--red)">❌ <strong>CardMarket Prijs-API</strong> — key ongeldig (${r.status}). Check je RapidAPI key.</div>`);
      else if(r.status===429) lines.push(`<div style="color:var(--red)">❌ <strong>CardMarket Prijs-API</strong> — daglimiet bereikt (429). Upgrade plan of wacht.</div>`);
      else lines.push(`<div style="color:var(--red)">❌ <strong>CardMarket Prijs-API</strong> — fout ${r.status}</div>`);
    } catch(e) {
      lines.push(`<div style="color:var(--red)">❌ <strong>CardMarket Prijs-API</strong> — geblokkeerd (${e.message})</div>`);
    }
  } else {
    lines.push(`<div style="color:var(--txt3)">⚪ <strong>CardMarket Prijs-API</strong> — geen key ingevuld (aanbevolen voor accurate prijzen)</div>`);
  }

  box.innerHTML = lines.join('') +
    `<div style="margin-top:8px;padding-top:8px;border-top:1px solid var(--bdr);color:var(--txt3);font-size:12px">
      Vergeet niet op <strong>💾 Opslaan</strong> te klikken om de keys te bewaren.
    </div>`;
};

// ── PRIJS-CACHE LEGEN ────────────────────────
window.rblClearPriceCache = function() {
  PriceCache.clear();
  // Ook de set-kaarten sessie-cache legen
  try {
    Object.keys(sessionStorage).filter(k => k.startsWith('rbl_sc_')).forEach(k => sessionStorage.removeItem(k));
  } catch(e){}
  rblToast('Prijs-cache geleegd ✓ — prijzen worden opnieuw opgehaald');
  setTimeout(() => location.reload(), 800);
};

// ── HOT LIST ─────────────────────────────────
function buildHotListAdmin() {
  const wrap = document.getElementById('rblHotListItems');
  if(!wrap) return;
  if(!cfg.hotList.length) { wrap.innerHTML = '<p style="font-size:16px;color:var(--txt3);margin-bottom:8px">Nog geen hot list items.</p>'; return; }
  wrap.innerHTML = cfg.hotList.map((item,i) => `
    <div class="bl-item">
      <span>🔥 <strong>${item.name}</strong> <span style="color:var(--grn3)">+${item.bonus}%</span> <span style="color:var(--txt3);font-size:15px">— ${item.reason||''}</span></span>
      <button class="bl-del" onclick="rblDelHot(${i})">✕</button>
    </div>`).join('');
}

window.rblAddHotItem = function() {
  const name   = document.getElementById('rblHlName').value.trim();
  const bonus  = parseInt(document.getElementById('rblHlBonus').value)||10;
  const reason = document.getElementById('rblHlReason').value.trim();
  if(!name) { rblToast('Vul een kaartnaam in', true); return; }
  cfg.hotList.push({name, bonus, reason});
  document.getElementById('rblHlName').value='';
  document.getElementById('rblHlBonus').value='';
  document.getElementById('rblHlReason').value='';
  buildHotListAdmin();
  renderHotListDisplay();
  localStorage.setItem(SK.cfg, JSON.stringify(cfg));
  rblToast(`${name} toegevoegd aan Hot List ✓`);
};

window.rblDelHot = function(i) {
  cfg.hotList.splice(i,1);
  buildHotListAdmin();
  renderHotListDisplay();
  localStorage.setItem(SK.cfg, JSON.stringify(cfg));
};

function renderHotListDisplay() {
  const wrap = document.getElementById('rblHotListShowItems');
  const box  = document.getElementById('rblHotListDisplay');
  if(!wrap||!box) return;
  if(!cfg.hotList.length) { box.style.display='none'; return; }
  box.style.display='block';
  wrap.innerHTML = cfg.hotList.map(item => `
    <div class="hot-item">
      <span class="hot-badge">🔥 HOT</span>
      <span class="hot-name">${item.name}</span>
      <span class="hot-price">+${item.bonus}%</span>
      ${item.reason?`<span style="font-size:14px;color:var(--txt3)">${item.reason}</span>`:''}
    </div>`).join('');
}

// ── BLACK LIST ───────────────────────────────
function buildBlackListAdmin() {
  const wrap = document.getElementById('rblBlackList');
  if(!wrap) return;
  if(!cfg.blackList.length) { wrap.innerHTML='<p style="font-size:16px;color:var(--txt3);padding:8px 0">Geen geblokkeerde kaarten.</p>'; return; }
  wrap.innerHTML = cfg.blackList.map((item,i) => `
    <div class="bl-item">
      <span>🚫 <strong>${item.name}</strong> <span style="color:var(--txt3);font-size:15px">— ${item.reason||''}</span></span>
      <button class="bl-del" onclick="rblDelBl(${i})">✕</button>
    </div>`).join('');
}

window.rblAddBl = function() {
  const name   = document.getElementById('rblBlInp').value.trim();
  const reason = document.getElementById('rblBlReason').value.trim();
  if(!name) { rblToast('Vul een kaartnaam in', true); return; }
  if(cfg.blackList.find(x => x.name.toLowerCase()===name.toLowerCase())) { rblToast('Al in blacklist', true); return; }
  cfg.blackList.push({name, reason});
  document.getElementById('rblBlInp').value='';
  document.getElementById('rblBlReason').value='';
  buildBlackListAdmin();
  localStorage.setItem(SK.cfg, JSON.stringify(cfg));
  rblToast(`${name} geblokkeerd ✓`);
};

window.rblDelBl = function(i) {
  cfg.blackList.splice(i,1);
  buildBlackListAdmin();
  localStorage.setItem(SK.cfg, JSON.stringify(cfg));
};

function isBlacklisted(name) {
  return cfg.blackList.some(x => name.toLowerCase().includes(x.name.toLowerCase()));
}

function getHotItem(name) {
  return cfg.hotList.find(x => name.toLowerCase().includes(x.name.toLowerCase()));
}

// ════════════════════════════════════════════════════════
// SET BROWSER  (zoeken + bladeren naast elkaar)
// ════════════════════════════════════════════════════════
const SetCache = {
  KEY: 'rbl_set_cache_v1',
  TTL_MS: 7 * 24 * 60 * 60 * 1000,  // sets wijzigen zelden: 7 dagen
  get(k){ try{ const s=JSON.parse(localStorage.getItem(this.KEY))||{}; const e=s[k];
    if(!e || Date.now()-e.ts>this.TTL_MS) return null; return e.data; }catch(x){ return null; } },
  set(k,data){ try{ const s=JSON.parse(localStorage.getItem(this.KEY))||{};
    s[k]={ts:Date.now(),data}; localStorage.setItem(this.KEY,JSON.stringify(s)); }
    catch(x){ localStorage.removeItem(this.KEY); } },
};
// Kaarten per set: sessionStorage (groter, mag per sessie vervallen)
const SetCardsCache = {
  get(k){ try{ const e=JSON.parse(sessionStorage.getItem('rbl_sc_'+k)); return e||null; }catch(x){ return null; } },
  set(k,data){ try{ sessionStorage.setItem('rbl_sc_'+k, JSON.stringify(data)); }catch(x){} },
};

let browseMode = 'search';   // 'search' | 'browse'
let browseGame = null;       // huidige spel in browser
let browseSet  = null;       // huidige set {id,name,...}
let browsePage = 1;          // paginering binnen set

window.rblSetBrowseMode = function(mode) {
  browseMode = mode;
  document.getElementById('rblBtSearch')?.classList.toggle('on', mode==='search');
  document.getElementById('rblBtBrowse')?.classList.toggle('on', mode==='browse');
  const so = document.getElementById('rblSearchOuter');
  if(so) so.style.display = mode==='search' ? '' : 'none';
  const st = document.getElementById('rblSearchTip');
  if(st) st.style.display = mode==='search' ? '' : 'none';
  const sb = document.getElementById('rblSetBrowser');
  if(!sb) return;
  sb.classList.toggle('show', mode==='browse');
  if(mode==='browse') {
    document.getElementById('rblResultArea').innerHTML = '';
    renderSetBrowser();
  } else if(mode==='search') {
    sb.innerHTML = '';
  }
};

// ── Sets ophalen per spel ────────────────────────────
async function fetchPokemonSets() {
  const cached = SetCache.get('pokemon_sets');
  if(cached) return cached;
  const hdrs = cfg.ptcgKey ? {'X-Api-Key':cfg.ptcgKey} : {};
  const r = await rblFetch('https://api.pokemontcg.io/v2/sets?orderBy=-releaseDate&pageSize=250', {headers:hdrs});
  if(!r.ok) throw new Error('PokéTCG sets fout: '+r.status);
  const d = await r.json();
  const sets = (d.data||[]).map(s => ({
    id:s.id, name:s.name, code:s.ptcgoCode||'', series:s.series||'Overig',
    total:s.printedTotal||s.total||0, logo:s.images?.logo||'', date:s.releaseDate||'',
  }));
  SetCache.set('pokemon_sets', sets);
  return sets;
}

async function fetchMTGSets() {
  const cached = SetCache.get('mtg_sets');
  if(cached) return cached;
  const r = await rblFetch('https://api.scryfall.com/sets');
  if(!r.ok) throw new Error('Scryfall sets fout: '+r.status);
  const d = await r.json();
  const sets = (d.data||[])
    .filter(s => ['core','expansion','masters','draft_innovation','commander'].includes(s.set_type) && s.card_count>0)
    .map(s => ({
      id:s.code, name:s.name, code:s.code.toUpperCase(), series:(s.released_at||'').slice(0,4)||'Overig',
      total:s.card_count, logo:s.icon_svg_uri||'', date:s.released_at||'',
    }));
  SetCache.set('mtg_sets', sets);
  return sets;
}

// ── Set browser renderen ─────────────────────────────
window.renderSetBrowser = async function() {
  const sb = document.getElementById('rblSetBrowser');
  const game = browseGame || (gameMode!=='all' ? gameMode : 'pokemon');
  browseGame = game;
  browseSet = null;

  sb.innerHTML = '<div class="sb-loading">⏳ Sets laden…</div>';
  try {
    let sets;
    if(game==='pokemon')      sets = await fetchPokemonSets();
    else if(game==='mtg')     sets = await fetchMTGSets();
    else {
      sb.innerHTML = `<div class="sb-loading">📚 Set browser voor ${GAMES[game]?.label||game} is nog niet beschikbaar (geen publieke set-API).<br>Gebruik de zoekfunctie hierboven.</div>`;
      return;
    }

    // Groepeer op serie
    const bySeries = {};
    sets.forEach(s => { (bySeries[s.series] = bySeries[s.series]||[]).push(s); });

    sb.innerHTML = Object.entries(bySeries).map(([series, list]) => `
      <div class="sb-series">${series}</div>
      <div class="sb-grid">
        ${list.map(s => `
          <div class="sb-set" onclick="rblOpenSet('${s.id}')">
            ${s.logo ? `<img src="${s.logo}" loading="lazy" alt="">` : ''}
            <div class="sb-set-name">${s.name}</div>
            <div class="sb-set-meta">${s.code?s.code+' · ':''}${s.total} kaarten</div>
          </div>`).join('')}
      </div>`).join('');
    // Bewaar sets voor rblOpenSet lookup
    sb._sets = sets;
  } catch(e) {
    sb.innerHTML = `<div class="sb-loading">⚠ Sets laden mislukt: ${e.message}</div>`;
  }
};

// ── Kaarten van een set ophalen (met paginering) ─────
async function fetchCardsBySet(game, setId, page=1) {
  const ck = `${game}_${setId}_${page}`;
  const cached = SetCardsCache.get(ck);
  if(cached) return cached;

  let result = { cards:[], hasMore:false };
  if(game==='pokemon') {
    const hdrs = cfg.ptcgKey ? {'X-Api-Key':cfg.ptcgKey} : {};
    const r = await rblFetch(`https://api.pokemontcg.io/v2/cards?q=set.id:${setId}&orderBy=number&page=${page}&pageSize=60`, {headers:hdrs});
    if(!r.ok) throw new Error('Kaarten laden fout: '+r.status);
    const d = await r.json();
    result.cards = (d.data||[]).map(c => ({
      name:c.name, img:c.images?.small||'', imgL:c.images?.large||'',
      code:(c.set?.ptcgoCode||c.set?.id?.toUpperCase()||'')+'-'+c.number,
      number:c.number, rarity:c.rarity||'', setName:c.set?.name||'',
      setId:c.set?.id||'', setCode:c.set?.ptcgoCode||'',
      game:'pokemon', apiId:c.id, sourceCardId:c.id,
      // Beschikbare varianten uit TCGplayer (keys: normal, holofoil, reverseHolofoil, ...)
      _variantKeys: c.tcgplayer?.prices ? Object.keys(c.tcgplayer.prices) : null,
      // Prijzen die PokéTCG al meelevert — direct meenemen
      _ptcgPrices: c.cardmarket?.prices || null,
    }));
    result.hasMore = (d.page*d.pageSize) < d.totalCount;
  } else if(game==='mtg') {
    const r = await rblFetch(`https://api.scryfall.com/cards/search?q=set:${setId}&order=set&page=${page}`);
    if(!r.ok) throw new Error('Kaarten laden fout: '+r.status);
    const d = await r.json();
    result.cards = (d.data||[]).map(c => ({
      name:c.name,
      img:c.image_uris?.small||c.card_faces?.[0]?.image_uris?.small||'',
      imgL:c.image_uris?.normal||c.card_faces?.[0]?.image_uris?.normal||'',
      code:(c.set||'').toUpperCase()+'-'+c.collector_number,
      number:c.collector_number, rarity:c.rarity||'', setName:c.set_name||'', setCode:(c.set||'').toUpperCase(),
      game:'mtg', apiId:c.id,
      scryfallId:c.id, oracleId:c.oracle_id||'',
      cardmarketProductId:c.cardmarket_id||null,
      finishes:c.finishes||[], lang:c.lang||'en',
      _mtgEur: parseFloat(c.prices?.eur)||null,
    }));
    result.hasMore = !!d.has_more;
  }
  SetCardsCache.set(ck, result);
  return result;
}

// ── Kaarten grid renderen ────────────────────────────
window.rblOpenSet = async function(setId) {
  const sb  = document.getElementById('rblSetBrowser');
  const set = (sb._sets||[]).find(s => s.id===setId);
  browseSet  = set;
  browsePage = 1;
  await renderSetCardsGrid(true);
};

// Herbruikbare grid-kaart (zelfde layout voor set-browser én zoekresultaten)
function rblGridCardHTML(c) {
  const key = rblCache(c);
  const qty = rblCartQty(c);
  const bulk = isBulkCard(c, defaultFinish(c));
  return { key, html: `<div class="sb-card" id="sbc_${key}">
    <div style="position:relative" onclick="rblPickCard('${key}')">
      ${c.img ? `<img src="${c.img}" loading="lazy" alt="">` : '<div style="aspect-ratio:63/88;background:var(--bg3);display:flex;align-items:center;justify-content:center;opacity:.3;font-size:42px">🃏</div>'}
      <div class="sb-qty-badge" id="qty_${key}" style="position:absolute;top:6px;right:6px;background:var(--grn3);color:#fff;font-weight:700;font-size:15px;min-width:26px;height:26px;border-radius:13px;display:${qty>0?'flex':'none'};align-items:center;justify-content:center;padding:0 6px;box-shadow:0 2px 6px rgba(0,0,0,.3)">${qty}</div>
    </div>
    <div class="sb-card-body">
      <div class="sb-card-name" title="${c.name}">${c.name}</div>
      <div class="sb-card-meta">${c.setName||''}${c.setCode?' · '+c.setCode:''}${c.number?' · #'+c.number:''}</div>
      ${c.rarity ? `<div class="sb-card-rare">${c.rarity}</div>` : ''}
      ${bulk
        ? `<div style="width:100%;margin-top:8px;padding:8px;background:var(--bg3);color:var(--txt3);border:1px dashed var(--bdr);border-radius:8px;font-weight:600;font-size:13px;text-align:center;cursor:help" title="Commons en uncommons kopen wij als bulk in (€3 per 800 kaarten). Klik de kaart voor holo/reverse/foil.">📦 Bulk — klik voor holo/foil</div>`
        : `<button class="sb-add-btn" id="add_${key}" onclick="event.stopPropagation();rblPickCard('${key}')"
        style="width:100%;margin-top:8px;padding:8px;background:var(--grn);color:#fff;border:none;border-radius:8px;font-weight:700;font-size:15px;cursor:pointer">+ Kies &amp; voeg toe</button>`}
    </div>
  </div>` };
}

window.renderSetCardsGrid = async function(reset) {
  const sb = document.getElementById('rblSetBrowser');
  if(reset) sb.innerHTML = `
    <div style="display:flex;justify-content:space-between;align-items:center;gap:10px;flex-wrap:wrap;margin-bottom:10px">
      <button class="sb-back" onclick="renderSetBrowser()">← Terug naar sets</button>
      <button class="btn-cs" onclick="rblOpenSubmit()" style="white-space:nowrap">✉ Verkooplijst indienen →</button>
    </div>
    <div style="font-size:20px;font-weight:700;margin-bottom:10px">${browseSet?.name||''} <span style="font-size:15px;color:var(--txt3)">${browseSet?.code||''}</span></div>
    <div class="sb-cards" id="rblSbCards"></div>
    <div id="rblSbMore"></div>
    <div class="sb-loading" id="rblSbLoading">⏳ Kaarten laden…</div>`;

  try {
    const {cards, hasMore} = await fetchCardsBySet(browseGame, browseSet.id, browsePage);
    document.getElementById('rblSbLoading')?.remove();
    const grid = document.getElementById('rblSbCards');
    grid.insertAdjacentHTML('beforeend', cards.map(c => rblGridCardHTML(c).html).join(''));

    const moreWrap = document.getElementById('rblSbMore');
    moreWrap.innerHTML = hasMore ? `<button class="sb-loadmore">Meer kaarten laden ↓</button>` : '';
    if(hasMore) moreWrap.querySelector('.sb-loadmore').onclick = () => { browsePage++; renderSetCardsGrid(false); };
  } catch(e) {
    const l = document.getElementById('rblSbLoading');
    if(l) l.textContent = '⚠ '+e.message;
  }
};

// ════════════════════════════════════════════════════════
// ZOEKEN → GRID (toont ALLE prints/sets, niet gededupliceerd)
// Rendert in dezelfde grid-layout als de set-browser.
// ════════════════════════════════════════════════════════
async function rblSearchToGrid(q) {
  const sb = document.getElementById('rblSetBrowser');
  if(!sb) return;
  sb.classList.add('show');   // ← container zichtbaar maken (stond op display:none)
  const game = gameMode==='all' ? 'pokemon' : gameMode;
  sb.innerHTML = `
    <div style="display:flex;justify-content:space-between;align-items:center;gap:10px;flex-wrap:wrap;margin-bottom:10px">
      <div style="font-size:18px;font-weight:700">🔍 Resultaten voor "${q}"</div>
      <button class="btn-cs" onclick="rblOpenSubmit()" style="white-space:nowrap">✉ Verkooplijst indienen →</button>
    </div>
    <div class="sb-cards" id="rblSbCards"></div>
    <div class="sb-loading" id="rblSbLoading">⏳ Alle versies zoeken…</div>`;

  try {
    let cards = [];
    if(game === 'mtg')      cards = await rblSearchAllPrintsMTG(q);
    else                    cards = await rblSearchAllPrintsPKM(q);

    document.getElementById('rblSbLoading')?.remove();
    const grid = document.getElementById('rblSbCards');
    if(!cards.length) {
      sb.querySelector('#rblSbCards').innerHTML =
        `<div class="sb-loading" style="grid-column:1/-1">Geen kaarten gevonden voor "<strong>${q}</strong>"</div>`;
      return;
    }
    grid.insertAdjacentHTML('beforeend', cards.map(c => rblGridCardHTML(c).html).join(''));
    // Teller onderaan
    grid.insertAdjacentHTML('afterend',
      `<div style="text-align:center;color:var(--txt3);font-size:14px;margin-top:12px">${cards.length} versie${cards.length!==1?'s':''} gevonden</div>`);
  } catch(e) {
    const l = document.getElementById('rblSbLoading');
    if(l) l.textContent = '⚠ '+e.message;
  }
}
window.rblSearchToGrid = rblSearchToGrid;

// MTG: alle prints via Scryfall (unique=prints)
async function rblSearchAllPrintsMTG(q) {
  const query = (q||'').trim();

  // Herken "set + kaartnummer" zoektocht, bv. "DOM 123", "dom-123", "mh2 0234".
  // Patroon: een setcode (2-5 letters/cijfers) gevolgd door een nummer.
  const setNumMatch = query.match(/^([a-z0-9]{2,5})[\s\-\/]+([0-9]+[a-z]?★?)$/i);
  if(setNumMatch) {
    const setCode = setNumMatch[1].toLowerCase();
    const num = setNumMatch[2].toLowerCase();
    // Scryfall heeft een exacte lookup op set + collector number
    try {
      const r = await fetch(`https://api.scryfall.com/cards/${encodeURIComponent(setCode)}/${encodeURIComponent(num)}`);
      if(r.ok) {
        const c = await r.json();
        return [{
          name:c.name,
          img:c.image_uris?.small||c.card_faces?.[0]?.image_uris?.small||'',
          imgL:c.image_uris?.normal||c.card_faces?.[0]?.image_uris?.normal||'',
          code:(c.set||'').toUpperCase()+'-'+c.collector_number,
          number:c.collector_number, rarity:c.rarity||'', setName:c.set_name||'', setCode:(c.set||'').toUpperCase(),
          game:'mtg', apiId:c.id, scryfallId:c.id, sourceCardId:c.id, oracleId:c.oracle_id||'',
          cardmarketProductId:c.cardmarket_id||null,
          finishes:c.finishes||[], lang:c.lang||'en',
        }];
      }
    } catch(e) { /* val terug op gewone zoektocht hieronder */ }
  }

  // Gewone zoektocht: exacte naam → alle prints; anders naam-zoektocht
  const url = `https://api.scryfall.com/cards/search?q=${encodeURIComponent('!"'+query+'" or '+query)}&unique=prints&order=released`;
  const r = await fetch(url);
  if(!r.ok) return [];
  const d = await r.json();
  let all = d.data || [];
  // Paginering: haal extra pagina's op (max ~3 om het behapbaar te houden)
  let next = d.has_more, nextUrl = d.next_page, pages = 0;
  while(next && nextUrl && pages < 2) {
    const rr = await fetch(nextUrl); if(!rr.ok) break;
    const dd = await rr.json(); all = all.concat(dd.data||[]);
    next = dd.has_more; nextUrl = dd.next_page; pages++;
  }
  return all.map(c => ({
    name:c.name,
    img:c.image_uris?.small||c.card_faces?.[0]?.image_uris?.small||'',
    imgL:c.image_uris?.normal||c.card_faces?.[0]?.image_uris?.normal||'',
    code:(c.set||'').toUpperCase()+'-'+c.collector_number,
    number:c.collector_number, rarity:c.rarity||'', setName:c.set_name||'', setCode:(c.set||'').toUpperCase(),
    game:'mtg', apiId:c.id, scryfallId:c.id, sourceCardId:c.id, oracleId:c.oracle_id||'',
    cardmarketProductId:c.cardmarket_id||null,
    finishes:c.finishes||[], lang:c.lang||'en',
  }));
}

// Pokémon: alle prints via PokéTCG (naam, alle sets, gesorteerd op datum)
async function rblSearchAllPrintsPKM(q) {
  const hdrs = cfg.ptcgKey ? {'X-Api-Key':cfg.ptcgKey} : {};
  const qt = q.trim();
  // setcode+nummer? (bijv ASC-294 of SVI 001)
  const m = qt.toUpperCase().match(/^([A-Z]{2,6}(?:-[A-Z]{1,4})?)[-\s](\d{1,4})$/);
  let url;
  if(m) {
    const setId = await rblResolvePkmSet(m[1]);
    url = `https://api.pokemontcg.io/v2/cards?q=set.id:${setId}%20number:${parseInt(m[2])}&pageSize=20`;
  } else {
    // Exacte naam-match, alle sets, gesorteerd op releasedatum (nieuwste eerst)
    url = `https://api.pokemontcg.io/v2/cards?q=name:"${qt}"&pageSize=60&orderBy=-set.releaseDate`;
  }
  let r = await rblFetch(url, {headers:hdrs});
  let d = await r.json();
  // Setcode+nummer maar niets gevonden? Probeer op ptcgoCode (soms wijkt de ID af)
  if(!d.data?.length && m) {
    const codeClean = m[1].replace(/-/g,'');
    r = await rblFetch(`https://api.pokemontcg.io/v2/cards?q=set.ptcgoCode:${codeClean}%20number:${parseInt(m[2])}&pageSize=20`, {headers:hdrs});
    d = await r.json();
  }
  // Geen exacte match? probeer wildcard
  if(!d.data?.length && !m) {
    r = await rblFetch(`https://api.pokemontcg.io/v2/cards?q=name:${encodeURIComponent(qt)}*&pageSize=60&orderBy=-set.releaseDate`, {headers:hdrs});
    d = await r.json();
  }
  return (d.data||[]).map(c => ({
    name:c.name, img:c.images?.small||'', imgL:c.images?.large||'',
    code:(c.set?.ptcgoCode||c.set?.id?.toUpperCase()||'')+'-'+c.number,
    number:c.number, rarity:c.rarity||'', setName:c.set?.name||'',
    setId:c.set?.id||'', setCode:c.set?.ptcgoCode||'',
    game:'pokemon', apiId:c.id, sourceCardId:c.id,
    _variantKeys: c.tcgplayer?.prices ? Object.keys(c.tcgplayer.prices) : null,
    _ptcgPrices: c.cardmarket?.prices || null,
  }));
}

// Tel hoeveel van deze kaart (alle condities/talen) al in de lijst staat.
function rblCartQty(card) {
  const baseKey = makeCardBaseKey(card, card.game);
  return cart.filter(c => (c._baseKey||'') === baseKey).reduce((s,c)=>s+(c.quantity||1),0);
}

// Snel toevoegen vanuit het grid: default finish + NM + Engels, +1 per klik.
window.rblQuickAdd = async function(key) {
  const card = _cache[key];
  if(!card) return;
  const btn = document.getElementById('add_'+key);
  const finish = defaultFinish(card);

  // Bulk-block: common/uncommon normal → niet los toevoegen
  if(isBulkCard(card, finish)) {
    rblToast('📦 Commons/uncommons kopen wij als bulk in (€3 per 800) — klik de kaart voor holo/reverse/foil', true);
    return;
  }

  const isRev = finish === 'reverse';
  const isFoilHolo = finish === 'foil' || finish === 'holo';
  // Volledige regel-key incl. finish + taal + conditie
  const lineKey = makeInternalKey(card, card.game, { language:'EN', condition:'NM', finish });
  const baseKey = makeCardBaseKey(card, card.game);

  // Bestaat deze exacte regel al? → quantity ophogen
  const existing = cart.find(c => c.internalKey === lineKey);
  if(existing) {
    existing.quantity = (existing.quantity||1) + 1;
    rblBumpQtyBadge(key);
    rblUpdateCart();
    rblRenderMiniCart();
    rblOpenMiniCart();
    return;
  }

  // Nieuw item → cardmarketProductId opzoeken (alleen voor prijs/mapping)
  if(btn) { btn.disabled = true; btn.textContent = '⏳…'; }
  let cmInfo = null;
  try { cmInfo = await CmIdResolver.resolve(card); } catch(e) {}
  if(btn) { btn.disabled = false; btn.textContent = '+ Toevoegen'; }

  // Voor MTG levert Scryfall de cardmarket_id al direct mee op de kaart.
  const cmProductId = card.cardmarketProductId || cmInfo?.cardmarketId || null;

  cart.push({
    internalKey: lineKey,
    _baseKey: baseKey,
    sourceCardId: card.sourceCardId || card.scryfallId || card.apiId || card.code || null,
    cardmarketProductId: cmProductId,
    cardmarketId: cmProductId,
    _idUncertain: !!cmInfo?._uncertain,
    name: card.name, img: card.img||'', code: card.code||'',
    game: card.game,
    setName: card.setName||'',          // ← kaart is leidend
    setId:   card.setId||'',
    setCode: card.setCode||'',
    rarity: card.rarity||'',
    cn: card.number || (card.code||'').split('-')[1] || '',
    finish,
    isReverseHolo: isRev,
    isFoilHolo,
    cond: 'NM', lang: 'EN', quantity: 1,
    timestamp: Date.now(),
  });
  rblBumpQtyBadge(key);
  rblUpdateCart();
  rblRenderMiniCart();
  rblOpenMiniCart();
  const idNote = cmInfo?.cardmarketId ? '' : ' ⚠ geen CardMarket-ID';
  rblDebugCard('QuickAdd', card, cart[cart.length-1]);
  rblToast(`${card.name} toegevoegd ✓${idNote}`);
};

function rblBumpQtyBadge(key) {
  const card = _cache[key];
  if(!card) return;
  const badge = document.getElementById('qty_'+key);
  if(!badge) return;
  const qty = rblCartQty(card);
  badge.textContent = qty;
  badge.style.display = qty>0 ? 'flex' : 'none';
}

// Oude grid-prijsfunctie uitgeschakeld (geen prijzen meer in klantflow)
async function rblLoadGridPrice_DISABLED(key, card) {
  const el = document.getElementById('sbp_'+key);
  if(!el) return;

  let md = null;

  // ── Stap 0: eigen prijslijst (Powertools CSV) — hoogste prioriteit ──
  const own = PriceList.lookup(card);
  if(own) {
    md = {low:own.low??null, lowEx:own.lowEx??null, avg7:own.avg7??null,
          avg30:own.avg30??null, trend:own.trend??null,
          listingCount:null, soldLast30:null, source:own.source, confidence:1.0, needsManualReview:false};
  }

  // ── Stap 1: prijzen die AL in de set-data zitten ──
  if(!md && card.game==='pokemon' && card._ptcgPrices) {
    const cm = card._ptcgPrices;
    const low=cm.lowPrice??null, trend=cm.trendPrice??null;
    const avg30=cm.avg30??cm.averageSellPrice??null;
    const avg7=cm.avg7??((trend&&low)?(trend+low)/2:(trend||low));
    if(low||trend||avg7||avg30) md={low,lowEx:cm.lowPriceExPlus??null,avg7,avg30,trend,
      listingCount:null,soldLast30:null,source:'PokéTCG',confidence:0.8,needsManualReview:false};
  } else if(!md && card.game==='mtg' && card._mtgEur) {
    md={low:card._mtgEur,lowEx:null,avg7:null,avg30:null,trend:card._mtgEur,
      listingCount:null,soldLast30:null,source:'Scryfall',confidence:0.55,needsManualReview:false};
  }

  // ── Stap 2: geen prijs → op aanvraag ──
  if(!md) {
    el.innerHTML = `<span class="sbp-manual">📋 Op aanvraag</span>`;
    return;
  }

  card.marketData = md;
  try {
    const fbp = calcFairBuyPrice(
      {low:md.low, lowEx:md.lowEx, avg7:md.avg7, avg30:md.avg30, trend:md.trend},
      {isHotList:!!getHotItem(card.name), hotBonus:getHotItem(card.name)?.bonus||0}
    );
    if(fbp.fbp && fbp.fbp > 0) {
      const nmBuy = calcBuyPrice(fbp.fbp, 'NM', 'EN');
      card._gridFbp = fbp.fbp;
      el.innerHTML = nmBuy
        ? `<span class="sbp-buy">tot €${nmBuy.toFixed(2)}</span>`
        : `<span class="sbp-manual">📋 Op aanvraag</span>`;
    } else {
      el.innerHTML = `<span class="sbp-manual">📋 Op aanvraag</span>`;
    }
  } catch(e) {
    el.innerHTML = `<span class="sbp-manual">📋 Op aanvraag</span>`;
  }
}



// ════════════════════════════════════════════════════════
// ZOEKEN
// ════════════════════════════════════════════════════════
// ── TCG-KEUZE FLOW ────────────────────────────────────
// Klant kiest eerst een spel; daarna verschijnt zoeken/bladeren.
window.rblChooseGame = function(game) {
  gameMode = game;
  browseGame = game;
  const picker = document.getElementById('rblGamePicker');
  const zone   = document.getElementById('rblSearchZone');
  if(picker) picker.style.display = 'none';
  if(zone)   zone.style.display = '';
  const lbl = document.getElementById('rblChosenGameLbl');
  if(lbl) lbl.textContent = GAMES[game]?.label || game;
  // Reset zoek/grid
  const inp = document.getElementById('rblSearchInp');
  if(inp) {
    inp.value='';
    if(game === 'mtg') inp.placeholder = 'Zoek op naam, of op set + nummer (bijv. DOM 123)…';
    else inp.placeholder = `Zoek een ${GAMES[game]?.label||game} kaart op naam…`;
  }
  // Zoek-tip aanpassen per spel
  const tip = document.getElementById('rblSearchTip');
  if(tip) {
    if(game === 'mtg') tip.innerHTML = '💡 Zoek op <strong>naam</strong>, of op <strong>set + kaartnummer</strong> (bijv. <strong>DOM 123</strong>) en druk <strong>Enter</strong>';
    else tip.innerHTML = '💡 Typ een naam en druk <strong>Enter</strong> om alle versies uit alle sets te zien';
  }
  const sb = document.getElementById('rblSetBrowser');
  if(sb) { sb.innerHTML = ''; sb.classList.remove('show'); }
  document.getElementById('rblResultArea').innerHTML = '';
  rblHideAc();
  // Begin in zoekmodus
  browseMode = 'search';
  document.getElementById('rblBtSearch')?.classList.add('on');
  document.getElementById('rblBtBrowse')?.classList.remove('on');
};

window.rblBackToGamePicker = function() {
  const picker = document.getElementById('rblGamePicker');
  const zone   = document.getElementById('rblSearchZone');
  if(picker) picker.style.display = '';
  if(zone)   zone.style.display = 'none';
  const sb = document.getElementById('rblSetBrowser');
  if(sb) { sb.innerHTML = ''; sb.classList.remove('show'); }
  document.getElementById('rblResultArea').innerHTML = '';
  rblHideAc();
};

// ════════════════════════════════════════════════════════
// KLANT-CSV UPLOAD  —  ⚠ TIJDELIJK UITGESCHAKELD
// De UI (tab + paneel) is uit de liquid gehaald, dus deze functies
// zijn niet bereikbaar. Code blijft staan zodat we 'm later weer
// kunnen aanzetten door de tab/paneel in buylist.liquid terug te zetten.
// Verwachte kolommen (flexibel): naam, set, nummer, taal, conditie, aantal
// ════════════════════════════════════════════════════════
let _csvRows = [];

window.rblCsvFileChosen = function(ev) {
  const file = ev.target.files?.[0];
  if(!file) { rblToast('Geen bestand gekozen', true); return; }
  const reader = new FileReader();
  reader.onload = () => {
    const txt = String(reader.result||'');
    if(!txt.trim()) { rblToast('Bestand is leeg', true); return; }
    rblCsvParse(txt);
    rblToast('Bestand ingelezen ✓');
  };
  reader.onerror = () => rblToast('Bestand lezen mislukt', true);
  reader.readAsText(file);
};

window.rblCsvParsePaste = function() {
  const ta = document.getElementById('rblCsvPaste');
  const txt = ta ? ta.value : '';
  if(!txt || !txt.trim()) { rblToast('Plak of typ eerst een lijst', true); return; }
  rblCsvParse(txt);
};

function rblCsvParse(text) {
  // Splits regels, detecteer delimiter (komma/puntkomma/tab)
  const lines = text.split(/\r?\n/).map(l=>l.replace(/\r$/,'').trim()).filter(Boolean);
  if(!lines.length) { rblToast('Lege lijst', true); return; }
  const delim = (lines[0].match(/;/g)||[]).length > (lines[0].match(/,/g)||[]).length ? ';'
              : (lines[0].includes('\t') ? '\t' : ',');

  const splitRow = (line) => line.split(delim).map(s=>s.trim().replace(/^"|"$/g,''));

  // ── Kolommen herkennen via de header ──────────────────
  // Synoniemen per veld zodat allerlei CSV-formaten werken.
  const FIELD_ALIASES = {
    name:   ['name','naam','kaart','card','cardname','kaartnaam'],
    set:    ['set','setnaam','setname','editie','edition','expansion'],
    number: ['number','nummer','no','num','card number','cardnumber','collector','collectornumber','cn','#'],
    lang:   ['lang','language','taal'],
    cond:   ['cond','condition','conditie','staat','grade'],
    qty:    ['qty','quantity','aantal','amount','count'],
    rarity: ['rarity','rariteit','zeldzaamheid'],
  };
  const headerCols = splitRow(lines[0]).map(h => h.toLowerCase().trim());
  // Map: veld → kolomindex
  const colIdx = {};
  headerCols.forEach((h, i) => {
    for(const [field, aliases] of Object.entries(FIELD_ALIASES)) {
      if(aliases.includes(h) && colIdx[field] === undefined) colIdx[field] = i;
    }
  });
  // Is dit echt een header? (minstens 'name' of 2 velden herkend)
  const hasHeader = colIdx.name !== undefined || Object.keys(colIdx).length >= 2;
  const startIdx = hasHeader ? 1 : 0;

  // Geen header herkend → val terug op vaste volgorde: naam,set,nummer,taal,conditie,aantal
  // MÉT header: gebruik alleen de herkende kolommen (geen positionele fallback,
  // anders pakt 'set' per ongeluk de nummer-kolom als er geen set-kolom is).
  const get = (cols, field, posFallback) => {
    if(hasHeader) return colIdx[field] !== undefined ? (cols[colIdx[field]] || '') : '';
    return posFallback !== undefined ? (cols[posFallback] || '') : '';
  };

  _csvRows = [];
  for(let i=startIdx; i<lines.length; i++) {
    const cols = splitRow(lines[i]);
    const name = get(cols, 'name', 0);
    if(!name) continue;
    // Nummer kan "4/102" zijn → pak het deel vóór de slash
    let number = get(cols, 'number', 2);
    if(number.includes('/')) number = number.split('/')[0].trim();
    _csvRows.push({
      name,
      set:    get(cols, 'set', 1),
      number,
      rarity: get(cols, 'rarity'),
      lang:  (get(cols, 'lang', 3) || 'EN').toUpperCase().slice(0,2),
      cond:  (get(cols, 'cond', 4) || 'NM').toUpperCase(),
      qty:    Math.max(1, parseInt(get(cols, 'qty', 5)) || 1),
      _ok: true,
    });
  }
  if(!_csvRows.length) { rblToast('Geen kaarten herkend in de lijst', true); return; }
  rblCsvRenderPreview();
}

function rblCsvRenderPreview() {
  const wrap = document.getElementById('rblCsvPreview');
  if(!wrap) return;
  if(!_csvRows.length) { wrap.innerHTML = '<div class="ac-msg">Geen rijen herkend</div>'; return; }
  const condOpts = CONDS.map(c=>c.code);
  const langOpts = LANGS.map(l=>l.code);
  const missingSet = _csvRows.some(r => !r.set);
  wrap.innerHTML = `
    <div style="font-weight:700;font-size:16px;margin-bottom:8px">Controleer je lijst (${_csvRows.length} kaarten)</div>
    ${missingSet ? `
    <div style="background:var(--bg3);border:1px solid var(--ylw,#e0a020);border-radius:8px;padding:12px;margin-bottom:12px">
      <div style="font-size:14px;margin-bottom:6px">📋 Je lijst heeft geen set-kolom. Uit welke set komen deze kaarten?</div>
      <div style="display:flex;gap:8px;flex-wrap:wrap">
        <input id="rblCsvSetAll" placeholder="bijv. Base Set" style="flex:1;min-width:160px;padding:8px;border:1px solid var(--bdr);border-radius:6px">
        <button onclick="rblCsvFillSet()" style="padding:8px 16px;background:var(--red);color:#fff;border:none;border-radius:6px;font-weight:700;cursor:pointer">Toepassen op alle rijen</button>
      </div>
    </div>` : ''}
    <div style="overflow-x:auto"><table style="width:100%;border-collapse:collapse;font-size:14px">
      <thead><tr style="text-align:left;border-bottom:2px solid var(--bdr)">
        <th style="padding:6px">Naam</th><th style="padding:6px">Set</th><th style="padding:6px">#</th>
        ${_csvRows.some(r=>r.rarity)?'<th style="padding:6px">Rariteit</th>':''}
        <th style="padding:6px">Taal</th><th style="padding:6px">Conditie</th><th style="padding:6px">Aantal</th><th></th>
      </tr></thead>
      <tbody>
        ${_csvRows.map((r,i)=>`<tr style="border-bottom:1px solid var(--bg3)">
          <td style="padding:5px"><input value="${(r.name||'').replace(/"/g,'&quot;')}" onchange="rblCsvEdit(${i},'name',this.value)" style="width:130px;padding:4px;border:1px solid var(--bdr);border-radius:4px"></td>
          <td style="padding:5px"><input value="${(r.set||'').replace(/"/g,'&quot;')}" onchange="rblCsvEdit(${i},'set',this.value)" style="width:110px;padding:4px;border:1px solid var(--bdr);border-radius:4px"></td>
          <td style="padding:5px"><input value="${r.number||''}" onchange="rblCsvEdit(${i},'number',this.value)" style="width:50px;padding:4px;border:1px solid var(--bdr);border-radius:4px"></td>
          ${_csvRows.some(r2=>r2.rarity)?`<td style="padding:5px;font-size:13px;color:var(--txt3)">${r.rarity||''}</td>`:''}
          <td style="padding:5px"><select onchange="rblCsvEdit(${i},'lang',this.value)" style="padding:4px;border:1px solid var(--bdr);border-radius:4px">${langOpts.map(l=>`<option ${r.lang===l?'selected':''}>${l}</option>`).join('')}</select></td>
          <td style="padding:5px"><select onchange="rblCsvEdit(${i},'cond',this.value)" style="padding:4px;border:1px solid var(--bdr);border-radius:4px">${condOpts.map(c=>`<option ${r.cond===c?'selected':''}>${c}</option>`).join('')}</select></td>
          <td style="padding:5px"><input type="number" min="1" value="${r.qty}" onchange="rblCsvEdit(${i},'qty',this.value)" style="width:50px;padding:4px;border:1px solid var(--bdr);border-radius:4px"></td>
          <td style="padding:5px"><button onclick="rblCsvRemoveRow(${i})" style="background:none;border:none;color:var(--red);cursor:pointer;font-size:16px">✕</button></td>
        </tr>`).join('')}
      </tbody>
    </table></div>
    <div style="margin-top:12px;display:flex;gap:8px;flex-wrap:wrap">
      <button onclick="rblCsvAddAll()" style="padding:10px 18px;background:var(--grn);color:#fff;border:none;border-radius:8px;font-weight:700;cursor:pointer">✓ Alles toevoegen aan verkooplijst</button>
      <button onclick="rblCsvClear()" style="padding:10px 16px;background:transparent;border:1px solid var(--bdr);border-radius:8px;cursor:pointer">Wissen</button>
    </div>
    <div style="font-size:13px;color:var(--txt4);margin-top:8px">⚠ Let op: deze kaarten krijgen pas een CardMarket-ID als wij ze verwerken. Set en nummer helpen ons de juiste kaart te vinden.</div>`;
}

window.rblCsvFillSet = function() {
  const v = document.getElementById('rblCsvSetAll')?.value.trim();
  if(!v) { rblToast('Vul eerst een setnaam in', true); return; }
  _csvRows.forEach(r => { if(!r.set) r.set = v; });
  rblCsvRenderPreview();
  rblToast(`Set "${v}" toegepast`);
};

window.rblCsvEdit = function(i, field, val) {
  if(!_csvRows[i]) return;
  _csvRows[i][field] = field==='qty' ? Math.max(1,parseInt(val)||1) : val;
};
window.rblCsvRemoveRow = function(i) { _csvRows.splice(i,1); rblCsvRenderPreview(); };
function rblCsvClear() {
  _csvRows = [];
  const p = document.getElementById('rblCsvPaste'); if(p) p.value='';
  const f = document.getElementById('rblCsvFile'); if(f) f.value='';
  rblCsvRenderPreview();
}
window.rblCsvClear = rblCsvClear;

window.rblCsvAddAll = async function() {
  if(!_csvRows.length) return;
  const game = gameMode==='all' ? 'pokemon' : gameMode;
  const rows = _csvRows.filter(r => r.name);
  if(!rows.length) return;

  // Laadbalk tonen
  const wrap = document.getElementById('rblCsvPreview');
  const total = rows.length;
  const renderProgress = (done, matched) => {
    if(!wrap) return;
    const pct = Math.round(done/total*100);
    wrap.innerHTML = `
      <div style="text-align:center;padding:24px">
        <div style="font-weight:700;font-size:17px;margin-bottom:10px">🔎 Kaarten opzoeken… ${done}/${total}</div>
        <div style="background:var(--bg3);border-radius:10px;height:18px;overflow:hidden;max-width:420px;margin:0 auto">
          <div style="background:var(--grn);height:100%;width:${pct}%;transition:width .2s"></div>
        </div>
        <div style="font-size:14px;color:var(--txt3);margin-top:10px">${matched} kaart(en) gematcht met CardMarket ✓</div>
        <div style="font-size:13px;color:var(--txt4);margin-top:4px">Even geduld — we controleren elke kaart op de juiste set</div>
      </div>`;
  };
  renderProgress(0, 0);

  let added = 0, matched = 0, uncertain = 0;
  for(let i=0; i<rows.length; i++) {
    const r = rows[i];
    const setSlug = (r.set||'').toLowerCase().replace(/\s+/g,'-');
    const finish = 'normal';
    const card = {
      name: r.name, game, setName: r.set, setCode: r.set, setId: setSlug,
      number: r.number, rarity: r.rarity||'', img:'',
      sourceCardId:'', cardmarketProductId:null,
    };

    // ── Automatische lookup MÉT set-verificatie (dezelfde resolver) ──
    let cmId = null, idUncertain = true;
    try {
      const info = await CmIdResolver.resolve(card);
      if(info && info.cardmarketId && !info._uncertain) {
        cmId = info.cardmarketId; idUncertain = false; matched++;
      } else {
        uncertain++;   // geen zekere match → geen ID, blijft "controleren"
      }
    } catch(e) { uncertain++; }

    const lineKey = makeInternalKey(card, game, { language:r.lang||'EN', condition:r.cond||'NM', finish });
    const existing = cart.find(c => c.internalKey===lineKey);
    if(existing) {
      existing.quantity += r.qty;
      if(cmId && !existing.cardmarketId) { existing.cardmarketId = cmId; existing.cardmarketProductId = cmId; existing._idUncertain = false; }
    } else {
      cart.push({
        internalKey: lineKey,
        _baseKey: makeCardBaseKey(card, game),
        sourceCardId: null,
        cardmarketProductId: cmId,
        cardmarketId: cmId,
        _idUncertain: idUncertain,
        _fromCsv: true,
        name: r.name, img:'', code: r.number?`${r.set}-${r.number}`:'',
        game, setName: r.set, setId: setSlug, setCode: r.set, rarity: r.rarity||'',
        cn: r.number||'',
        finish, isReverseHolo:false, isFoilHolo:false,
        cond: r.cond||'NM', lang: r.lang||'EN', quantity: r.qty,
        timestamp: Date.now(),
      });
    }
    added++;
    renderProgress(i+1, matched);
  }

  rblUpdateCart(); rblRenderCart(); rblRenderMiniCart();
  rblCsvClear();
  const msg = uncertain
    ? `✓ ${added} kaarten toegevoegd — ${matched} automatisch gematcht, ${uncertain} handmatig na te kijken`
    : `✓ ${added} kaarten toegevoegd — allemaal automatisch gematcht ✓`;
  rblToast(msg);
  rblOpenMiniCart();
};

window.rblOnSearch = function(val) {
  clearTimeout(acTimer);
  const q = val.trim();
  const drop = document.getElementById('rblAcDrop');
  if(!drop) return;
  if(q.length < 2) { drop.classList.remove('show'); return; }
  drop.classList.add('show');
  drop.innerHTML = '<div class="ac-msg">⏳ Zoeken…</div>';
  acTimer = setTimeout(() => rblDoSearch(q), 350);
};

// Enter in zoekbalk → toon ALLE versies in het grid
window.rblOnSearchKey = function(ev, val) {
  if(ev.key === 'Enter') {
    ev.preventDefault();
    const q = (val||'').trim();
    if(q.length < 2) return;
    rblHideAc();
    rblSearchToGrid(q);
  } else if(ev.key === 'Escape') {
    rblHideAc();
  }
};

async function rblDoSearch(q) {
  const drop = document.getElementById('rblAcDrop');
  const game = gameMode==='all' ? 'pokemon' : gameMode;   // game is al gekozen
  try {
    if(game==='mtg') await rblSearchMTG(q, drop);
    else if(game==='onepiece') rblShowManual(q, drop);
    else await rblSearchPKM(q, drop);
    // Knop onderaan: toon ALLE versies in het grid
    if(game!=='onepiece' && drop.innerHTML && !drop.innerHTML.includes('Geen')) {
      const qEsc = q.replace(/'/g,"\\'");
      drop.insertAdjacentHTML('beforeend',
        `<div onclick="rblHideAc();rblSearchToGrid('${qEsc}')" style="padding:12px;text-align:center;cursor:pointer;background:var(--bg3);border-top:1px solid var(--bdr);font-weight:700;color:var(--grn3)">📋 Toon alle versies van "${q}" in raster →</div>`);
    }
  } catch(e) {
    drop.innerHTML = `<div class="ac-msg">⚠ Zoekfout: ${e.message}</div>`;
  }
}


async function rblSearchPKM(q, drop) {
  // Zoekresultaat al eens opgehaald? → direct tonen (geen trage API-call)
  const cacheKey = 'pkm:' + q.trim().toLowerCase();
  const cachedHtml = _scGet(cacheKey);
  if(cachedHtml !== null) { drop.innerHTML = cachedHtml; return; }

  const q2 = q.trim().toUpperCase();
  const mD = q2.match(/^([A-Z]{2,6}(?:-[A-Z]{1,4})?)-(\d{1,4})$/);
  const mS = q2.match(/^([A-Z]{2,6}(?:-[A-Z]{1,4})?)\s+(\d{1,4})$/);
  const mN = q2.match(/^\d{1,4}(\/\d+)?$/);
  const mNN= q.trim().match(/^(.+?)\s+(\d{1,4})$/);
  let url='';

  if(mD||mS) {
    const m=mD||mS, setId= await rblResolvePkmSet(m[1]);
    url=`https://api.pokemontcg.io/v2/cards?q=set.id:${setId}%20number:${parseInt(m[2])}&pageSize=8`;
  } else if(mN) {
    url=`https://api.pokemontcg.io/v2/cards?q=number:${parseInt(q2)}&pageSize=10&orderBy=-set.releaseDate`;
  } else if(mNN) {
    url=`https://api.pokemontcg.io/v2/cards?q=name:"${mNN[1]}"%20number:${parseInt(mNN[2])}&pageSize=8`;
  } else {
    url=`https://api.pokemontcg.io/v2/cards?q=name:"${q.trim()}*"&pageSize=12&orderBy=-set.releaseDate`;
  }

  const hdrs = cfg.ptcgKey ? {'X-Api-Key':cfg.ptcgKey} : {};
  let r = await rblFetch(url, {headers:hdrs});
  let d = await r.json();

  if(!d.data?.length && (mD||mS)) {
    const m=mD||mS;
    r=await rblFetch(`https://api.pokemontcg.io/v2/cards?q=set.ptcgoCode:${m[1].replace(/-/g,'')}%20number:${parseInt(m[2])}&pageSize=8`,{headers:hdrs});
    d=await r.json();
  }
  if(!d.data?.length) {
    r=await rblFetch(`https://api.pokemontcg.io/v2/cards?q=name:${encodeURIComponent(q.trim())}*&pageSize=12&orderBy=-set.releaseDate`,{headers:hdrs});
    d=await r.json();
  }

  if(!d.data?.length) {
    drop.innerHTML=`<div class="ac-msg">Geen kaarten gevonden voor "<strong>${q}</strong>"<br><small>Probeer: naam · ASC-294 · SVI 001</small></div>`;
    return;  // lege resultaten NIET cachen — misschien lag het aan de API
  }

  const html = d.data.map(c => {
    const sc   = c.set?.ptcgoCode||c.set?.id?.toUpperCase()||'';
    const code = c.number ? `${sc}-${c.number}` : '';
    const cmP  = c.cardmarket?.prices||{};
    return rblAcHTML({
      name:c.name, img:c.images?.small||'', imgL:c.images?.large||'',
      code, number:c.number||'', rarity:c.rarity||'', setName:c.set?.name||'',
      setId:c.set?.id||'', setCode:c.set?.ptcgoCode||'',
      game:'pokemon', apiId:c.id, sourceCardId:c.id,
      _variantKeys: c.tcgplayer?.prices ? Object.keys(c.tcgplayer.prices) : null,
      rawPrices:{low:cmP.lowPrice||null, lowEx:cmP.lowPriceExPlus||null,
        avg7:cmP.avg7||null, avg30:cmP.avg30||null, trend:cmP.trendPrice||null},
    });
  }).join('');
  _scSet(cacheKey, html);   // resultaat onthouden voor de volgende keer
  drop.innerHTML = html;
}

async function rblSearchMTG(q, drop) {
  const query = (q||'').trim();

  // Set + kaartnummer herkennen (bijv. "DOM 123", "mh2-234") → exacte lookup
  const setNumMatch = query.match(/^([a-z0-9]{2,5})[\s\-\/]+([0-9]+[a-z]?★?)$/i);
  if(setNumMatch) {
    const setCode = setNumMatch[1].toLowerCase();
    const num = setNumMatch[2].toLowerCase();
    try {
      const rr = await rblFetch(`https://api.scryfall.com/cards/${encodeURIComponent(setCode)}/${encodeURIComponent(num)}`);
      if(rr.ok) {
        const c = await rr.json();
        const img  = c.image_uris?.small||c.card_faces?.[0]?.image_uris?.small||'';
        const imgL = c.image_uris?.normal||c.card_faces?.[0]?.image_uris?.normal||img;
        const code = c.collector_number ? `${(c.set||'').toUpperCase()}-${c.collector_number}` : '';
        drop.innerHTML = rblAcHTML({
          name:c.name, img, imgL, code, number:c.collector_number||'', rarity:c.rarity||'', setName:c.set_name||'',
          setCode:(c.set||'').toUpperCase(),
          game:'mtg', apiId:c.id, sourceCardId:c.id, scryfallId:c.id, oracleId:c.oracle_id||'',
          cardmarketProductId:c.cardmarket_id||null,
          finishes:c.finishes||[], lang:c.lang||'en',
          rawPrices:{low:parseFloat(c.prices?.eur)||null, avg7:null, avg30:null,
            trend:parseFloat(c.prices?.eur)||null, lowEx:null},
        });
        return;
      }
      // Niet gevonden op set+nummer → toon nette melding met hint
      drop.innerHTML = '<div class="ac-msg">Geen kaart gevonden voor die set + nummer. Controleer de setcode (bijv. DOM, MH2) of zoek op naam.</div>';
      return;
    } catch(e) {
      drop.innerHTML = '<div class="ac-msg">Geen kaart gevonden voor die set + nummer. Controleer de setcode of zoek op naam.</div>';
      return;
    }
  }

  const mtgCacheKey = 'mtg:' + query.toLowerCase();
  const mtgCached = _scGet(mtgCacheKey);
  if(mtgCached !== null) { drop.innerHTML = mtgCached; return; }

  const r = await rblFetch(`https://api.scryfall.com/cards/search?q=${encodeURIComponent(query)}&limit=10`);
  const d = await r.json();
  if(!d.data?.length) { drop.innerHTML='<div class="ac-msg">Geen MTG kaarten gevonden</div>'; return; }
  const mtgHtml = d.data.map(c => {
    const img  = c.image_uris?.small||c.card_faces?.[0]?.image_uris?.small||'';
    const imgL = c.image_uris?.normal||c.card_faces?.[0]?.image_uris?.normal||img;
    const code = c.collector_number ? `${(c.set||'').toUpperCase()}-${c.collector_number}` : '';
    return rblAcHTML({
      name:c.name, img, imgL, code, number:c.collector_number||'', rarity:c.rarity||'', setName:c.set_name||'',
      setCode:(c.set||'').toUpperCase(),
      game:'mtg', apiId:c.id, sourceCardId:c.id, scryfallId:c.id, oracleId:c.oracle_id||'',
      cardmarketProductId:c.cardmarket_id||null,
      finishes:c.finishes||[], lang:c.lang||'en',
      rawPrices:{low:parseFloat(c.prices?.eur)||null, avg7:null, avg30:null,
        trend:parseFloat(c.prices?.eur)||null, lowEx:null},
    });
  }).join('');
  _scSet(mtgCacheKey, mtgHtml);
  drop.innerHTML = mtgHtml;
}

function rblShowManual(q, drop) {
  const card = {name:q,img:'',imgL:'',code:'',rarity:'',setName:'',game:'onepiece',apiId:'',rawPrices:{}};
  const key  = rblCache(card);
  drop.innerHTML = `<div class="ac-msg" style="text-align:left">
    <strong>One Piece — handmatig toevoegen</strong><br>
    <small style="color:#aaa;display:block;margin:4px 0 10px">Geen publieke API. Voer marktprijs handmatig in na selectie.</small>
    <button onclick="rblPickCard('${key}')"
      style="background:var(--red);border:none;border-radius:6px;color:#fff;padding:7px 14px;cursor:pointer;font-weight:700;font-size:17px">
      + "${q}" selecteren
    </button>
  </div>`;
}

function rblCache(card) {
  const key = 'rk_'+Math.random().toString(36).slice(2,10);
  _cache[key] = card; return key;
}

function rblAcHTML(card) {
  const key  = rblCache(card);
  const gc   = GAMES[card.game]?.color||'#888';
  return `<div class="ac-item" onclick="rblPickCard('${key}')">
    ${card.img ? `<img class="ac-thumb" src="${card.img}" loading="lazy">` : '<div class="ac-ph">🃏</div>'}
    <div class="ac-info">
      <div class="ac-name">${card.name}</div>
      <div class="ac-meta">
        ${card.code   ? `<span class="pill pill-code">${card.code}</span>` : ''}
        ${card.rarity ? `<span class="pill pill-rare">${card.rarity}</span>` : ''}
        <span class="pill" style="background:${gc}18;border:1px solid ${gc}55;color:${gc}">${GAMES[card.game]?.label||card.game}</span>
        ${card.setName? `<span class="pill pill-set">${card.setName}</span>` : ''}
      </div>
    </div>
  </div>`;
}

function rblHideAc() { const d = document.getElementById('rblAcDrop'); if(d) d.classList.remove('show'); }
window.rblHideAc = rblHideAc;
document.addEventListener('click', e => { if(!e.target.closest('#rbl .search-outer')) rblHideAc(); });

// ════════════════════════════════════════════════════════
// MARKET PRICE FETCHER
// Verantwoordelijk voor het ophalen en normaliseren van
// prijsdata naar het standaard formaat voordat de FBP
// engine draait.
//
// Output formaat:
// {
//   low: number|null,        CM laagste prijs
//   lowEx: number|null,      CM laagste EX+ prijs
//   avg7: number|null,       7-daags gemiddelde
//   avg30: number|null,      30-daags gemiddelde
//   trend: number|null,      CM trendprijs
//   listingCount: number|null,  aantal aanbiedingen
//   soldLast30: number|null,    verkopen afgelopen 30d
//   source: string,          welke API geeft de data
//   confidence: number,      0-1 betrouwbaarheidsscore
//   needsManualReview: bool, naar handmatige beoordeling
//   reviewReason: string,    waarom handmatig
// }
// ════════════════════════════════════════════════════════

// ════════════════════════════════════════════════════════
// CARDMARKET PRICE CACHE  (Fase 1)
// Slaat genormaliseerde prijsdata 24 uur op in localStorage.
// Key: prijsbron + kaart-id. Max 500 entries (oudste eruit).
// Shopify pages hebben geen backend; dit is de client-side
// cache. Upgrade-pad: Shopify App Proxy + metafields (zie docs
// in chat) — de interface van PriceCache blijft dan gelijk.
// ════════════════════════════════════════════════════════
// ════════════════════════════════════════════════════════
// EIGEN PRIJSLIJST (CSV uit Powertools/CardMarket)
// Opgeslagen in localStorage. Gematcht op cardmarketId of
// set+kaartnummer. Primaire bron vóór TCGdex.
// ════════════════════════════════════════════════════════
const PriceList = {
  KEY_BYID: 'rbl_pl_byid_v1',
  KEY_BYSET: 'rbl_pl_byset_v1',
  KEY_META: 'rbl_pl_meta_v1',

  _byId: null,
  _bySet: null,

  load() {
    if(this._byId) return;
    try { this._byId  = JSON.parse(localStorage.getItem(this.KEY_BYID))  || {}; } catch(e){ this._byId = {}; }
    try { this._bySet = JSON.parse(localStorage.getItem(this.KEY_BYSET)) || {}; } catch(e){ this._bySet = {}; }
  },

  meta() {
    try { return JSON.parse(localStorage.getItem(this.KEY_META)) || null; } catch(e){ return null; }
  },

  // Zoek prijs voor een kaart
  lookup(card) {
    this.load();
    // 1. Op cardmarketId (betrouwbaarst)
    const cmId = card.cardmarketId || card._cardmarketId;
    if(cmId && this._byId[cmId]) return this._byId[cmId];
    // 2. Op setCode + kaartnummer (bijv. ROS-20)
    const num = (card.number || (card.code||'').split('-')[1] || '').toString().replace(/^0+/,'');
    const setCode = (card.setCode || (card.code||'').split('-')[0] || '').toLowerCase().trim();
    if(setCode && num) {
      const k2 = `${setCode}|${num}`;
      if(this._bySet[k2]) return this._bySet[k2];
    }
    // 3. Op volledige setnaam + kaartnummer
    const setName = (card.setName||'').toLowerCase().trim();
    if(setName && num) {
      const k = `${setName}|${num}`;
      if(this._bySet[k]) return this._bySet[k];
    }
    return null;
  },

  count() { this.load(); return Object.keys(this._byId).length + Object.keys(this._bySet).length; },

  clear() {
    localStorage.removeItem(this.KEY_BYID);
    localStorage.removeItem(this.KEY_BYSET);
    localStorage.removeItem(this.KEY_META);
    this._byId = null; this._bySet = null;
  },
};

// CSV parser (simpel, ondersteunt komma en puntkomma)
function rblParseCsv(text) {
  // Verwijder BOM
  text = text.replace(/^\uFEFF/, '');
  const lines = text.split(/\r?\n/).filter(l => l.trim());
  if(!lines.length) return { headers:[], rows:[] };
  // Detecteer scheidingsteken
  const delim = (lines[0].split(';').length > lines[0].split(',').length) ? ';' : ',';
  const parse = (line) => {
    const out = []; let cur = ''; let inQ = false;
    for(let i=0;i<line.length;i++){
      const ch = line[i];
      if(ch === '"'){ inQ = !inQ; }
      else if(ch === delim && !inQ){ out.push(cur); cur = ''; }
      else cur += ch;
    }
    out.push(cur);
    return out.map(s => s.trim());
  };
  const headers = parse(lines[0]).map(h => h.toLowerCase().trim());
  const rows = lines.slice(1).map(parse);
  return { headers, rows };
}

window.rblImportCsv = function() {
  const fileInput = document.getElementById('rblCsvFile');
  const result = document.getElementById('rblCsvResult');
  const file = fileInput?.files?.[0];
  if(!file) { result.innerHTML = '<span style="color:var(--red)">Kies eerst een CSV-bestand</span>'; return; }

  result.innerHTML = '⏳ Inlezen…';
  const reader = new FileReader();
  reader.onload = function(e) {
    try {
      const { headers, rows } = rblParseCsv(e.target.result);
      if(!headers.length) { result.innerHTML = '<span style="color:var(--red)">Leeg of ongeldig bestand</span>'; return; }

      // Kolom-indexen vinden (flexibel)
      const col = (names) => {
        for(const n of names) {
          const i = headers.indexOf(n);
          if(i >= 0) return i;
        }
        return -1;
      };
      const iId    = col(['cardmarketid','cardmarket id','cmid','idproduct']);
      const iName  = col(['name','kaartnaam','cardname']);
      const iSet   = col(['set','expansion','setname','set name']);
      const iSetC  = col(['setcode','set code','ptcgocode']);
      const iNum   = col(['cn','number','collectornumber','collector number','cardnumber','nr']);
      const iPrice = col(['price','marketprice','market price','prijs']);
      const iTrend = col(['trend','trendprice','price trend']);
      const iAvg7  = col(['avg7','7d_average','7-days average','avg 7']);
      const iAvg30 = col(['avg30','30d_average','30-days average','avg 30']);
      const iLow   = col(['low','lowprice','from','lowest_near_mint']);

      if(iId < 0 && (iSet < 0 || iNum < 0)) {
        result.innerHTML = '<span style="color:var(--red)">⚠ CSV mist een <code>cardmarketId</code> kolom OF <code>set</code>+<code>cn</code> kolommen. Kan kaarten niet matchen.</span>';
        return;
      }
      // Minstens één prijskolom nodig
      if(iPrice < 0 && iTrend < 0 && iAvg30 < 0 && iLow < 0) {
        result.innerHTML = '<span style="color:var(--red)">⚠ Geen prijskolom gevonden (price/trend/avg30/low). Deze export bevat geen prijzen — kies een Powertools-export mét prijsdata.</span>';
        return;
      }

      const byId = {}; const bySet = {};
      let imported = 0;
      const num = (v) => { const f = parseFloat(String(v).replace(',','.')); return isFinite(f) && f > 0 ? f : null; };

      for(const r of rows) {
        const low   = iLow   >= 0 ? num(r[iLow])   : null;
        const trend = iTrend >= 0 ? num(r[iTrend]) : null;
        const avg7  = iAvg7  >= 0 ? num(r[iAvg7])  : null;
        const avg30 = iAvg30 >= 0 ? num(r[iAvg30]) : null;
        const price = iPrice >= 0 ? num(r[iPrice]) : null;
        // Als alleen 'price' bestaat, gebruik die als trend (marktprijs)
        const entry = {
          low:   low,
          lowEx: null,
          avg7:  avg7  ?? (price && !trend ? price : null),
          avg30: avg30 ?? null,
          trend: trend ?? price ?? null,
          source: 'Eigen prijslijst (CardMarket)',
          confidence: 1.0,
        };
        if(!(entry.low || entry.trend || entry.avg7 || entry.avg30)) continue;

        if(iId >= 0 && r[iId] && String(r[iId]).trim()) {
          byId[String(r[iId]).trim()] = entry;
          imported++;
        }
        const cnVal = iNum >= 0 && r[iNum] ? String(r[iNum]).trim().replace(/^0+/,'') : '';
        if(iSetC >= 0 && r[iSetC] && cnVal) {
          bySet[`${r[iSetC].toLowerCase().trim()}|${cnVal}`] = entry;
          imported++;
        }
        if(iSet >= 0 && r[iSet] && cnVal) {
          bySet[`${r[iSet].toLowerCase().trim()}|${cnVal}`] = entry;
          imported++;
        }
      }

      localStorage.setItem(PriceList.KEY_BYID, JSON.stringify(byId));
      localStorage.setItem(PriceList.KEY_BYSET, JSON.stringify(bySet));
      localStorage.setItem(PriceList.KEY_META, JSON.stringify({
        date: new Date().toLocaleString('nl-NL'),
        rows: rows.length,
        byId: Object.keys(byId).length,
        bySet: Object.keys(bySet).length,
        cols: { id:iId>=0, price:iPrice>=0, trend:iTrend>=0, avg7:iAvg7>=0, avg30:iAvg30>=0, low:iLow>=0 },
      }));
      PriceList._byId = byId; PriceList._bySet = bySet;
      // Cache legen zodat nieuwe prijzen meteen gelden
      PriceCache.clear();

      result.innerHTML = `<span style="color:var(--grn3)">✅ ${Object.keys(byId).length} kaarten geïmporteerd op CardMarket-ID${Object.keys(bySet).length?`, ${Object.keys(bySet).length} op set+nummer`:''}.</span>`;
      rblRenderPriceListStatus();
    } catch(err) {
      result.innerHTML = `<span style="color:var(--red)">Fout bij inlezen: ${err.message}</span>`;
    }
  };
  reader.readAsText(file);
};

window.rblClearPriceList = function() {
  PriceList.clear();
  PriceCache.clear();
  rblRenderPriceListStatus();
  rblToast('Prijslijst gewist');
};

function rblRenderPriceListStatus() {
  const el = document.getElementById('rblPriceListStatus');
  if(!el) return;
  const m = PriceList.meta();
  if(!m) { el.innerHTML = '<span style="color:var(--txt3)">Nog geen prijslijst geïmporteerd. Het systeem gebruikt nu TCGdex.</span>'; return; }
  el.innerHTML = `
    <div>📅 Geïmporteerd: <strong>${m.date}</strong></div>
    <div>🃏 Kaarten op CardMarket-ID: <strong>${m.byId}</strong></div>
    <div>🔖 Kaarten op set+nummer: <strong>${m.bySet}</strong></div>
    <div style="margin-top:6px;color:var(--grn3)">✅ Deze prijzen worden als primaire bron gebruikt.</div>
    <div style="margin-top:4px;color:var(--txt3);font-size:13px">Tip: upload wekelijks een verse export voor actuele prijzen.</div>`;
}

// ── PRICE VALIDATION UI ───────────────────────
window.rblValAdd = function() {
  const name = document.getElementById('rblValName')?.value.trim();
  const game = document.getElementById('rblValGame')?.value || 'pokemon';
  const num  = document.getElementById('rblValNum')?.value.trim();
  const ref  = parseFloat(document.getElementById('rblValRef')?.value);
  const type = document.getElementById('rblValType')?.value || 'mid';
  if(!name) { rblToast('Vul een kaartnaam in'); return; }
  PriceValidator.add({ name, game, num, type, ref: isFinite(ref)?ref:null, result:null });
  document.getElementById('rblValName').value='';
  document.getElementById('rblValNum').value='';
  document.getElementById('rblValRef').value='';
  rblValRender();
};

window.rblValClear = function() {
  PriceValidator.clearAll();
  rblValRender();
};

window.rblValSeed = function() {
  PriceValidator.load();
  const seed = [
    // chase = dure rares/SAR/illustration; mid = mid-range; bulk = commons/uncommons; new = recente set
    {name:"Misty's Lapras", game:'pokemon', num:'194', type:'chase', ref:40},
    {name:'Charizard ex', game:'pokemon', num:'', type:'chase', ref:null},
    {name:'Iono', game:'pokemon', num:'', type:'chase', ref:null},
    {name:'Mew ex', game:'pokemon', num:'', type:'chase', ref:null},
    {name:'Gardevoir ex', game:'pokemon', num:'', type:'mid', ref:null},
    {name:'Roaring Moon ex', game:'pokemon', num:'', type:'mid', ref:null},
    {name:'Snorlax', game:'pokemon', num:'', type:'mid', ref:null},
    {name:'Lugia V', game:'pokemon', num:'', type:'mid', ref:null},
    {name:'Charmander', game:'pokemon', num:'4', type:'bulk', ref:null},
    {name:'Pikachu', game:'pokemon', num:'', type:'bulk', ref:null},
    {name:'Bidoof', game:'pokemon', num:'', type:'bulk', ref:null},
    {name:'Rattata', game:'pokemon', num:'', type:'bulk', ref:null},
  ];
  seed.forEach(s => PriceValidator.cards.push({...s, result:null}));
  PriceValidator.save();
  rblValRender();
  rblToast(`${seed.length} voorbeeldkaarten toegevoegd — vul echte CM-prijzen in en klik "Alle ophalen"`);
};

window.rblValRunAll = async function() {
  PriceValidator.load();
  if(!PriceValidator.cards.length) { rblToast('Geen kaarten om te meten'); return; }
  const btn = event?.target;
  if(btn) { btn.disabled = true; btn.textContent = '⏳ Ophalen…'; }
  for(let i=0;i<PriceValidator.cards.length;i++) {
    const c = PriceValidator.cards[i];
    try { c.result = await PriceValidator.fetchRaw(c); }
    catch(e) { c.result = { primary:null, error:e.message }; }
    rblValRender(); // live update
    await new Promise(r => setTimeout(r, 250)); // rate limit vriendelijk
  }
  PriceValidator.save();
  if(btn) { btn.disabled = false; btn.textContent = '▶ Alle kaarten ophalen & meten'; }
  rblValRender();
};

window.rblValSetRef = function(idx, val) {
  PriceValidator.load();
  const ref = parseFloat(val);
  if(PriceValidator.cards[idx]) { PriceValidator.cards[idx].ref = isFinite(ref)?ref:null; PriceValidator.save(); rblValRender(); }
};

window.rblValDel = function(idx) {
  PriceValidator.load();
  PriceValidator.cards.splice(idx,1);
  PriceValidator.save();
  rblValRender();
};

function rblValFmt(v) { return v==null ? '<span style="color:var(--txt3)">—</span>' : '€'+Number(v).toFixed(2); }

function rblValCell(val, ref) {
  if(val==null) return '<td style="padding:6px;color:var(--txt3)">—</td>';
  const dev = PriceValidator.dev(val, ref);
  if(dev==null) return `<td style="padding:6px">€${val.toFixed(2)}</td>`;
  const v = PriceValidator.verdict(dev);
  const sign = dev>0?'+':'';
  return `<td style="padding:6px"><div>€${val.toFixed(2)}</div><div style="font-size:11px;color:${v.color}">${sign}${dev.toFixed(0)}%</div></td>`;
}

function rblValRender() {
  PriceValidator.load();
  const tb = document.getElementById('rblValTbody');
  if(!tb) return;
  if(!PriceValidator.cards.length) {
    tb.innerHTML = '<tr><td colspan="11" style="padding:14px;color:var(--txt3)">Nog geen testkaarten. Voeg er handmatig toe of klik "25 voorbeeldkaarten laden".</td></tr>';
    document.getElementById('rblValSummary').innerHTML='';
    return;
  }

  // Aggregatie voor de conclusie per veld (totaal + per type)
  const agg = { low:[], trend:[], avg7:[], avg30:[] };
  const TYPES = {chase:'Chase/Rare', mid:'Mid-range', bulk:'Bulk', new:'Nieuwe set'};
  const TYPE_COLORS = {chase:'#9b59b6', mid:'var(--blu)', bulk:'var(--txt3)', new:'var(--ora2)'};
  const aggByType = {}; // {type: {low:[],trend:[],avg7:[],avg30:[]}}

  tb.innerHTML = PriceValidator.cards.map((c, idx) => {
    const res = c.result;
    const p = res?.primary;
    const setInfo = p ? `${p.setName||'—'}${c.num?(' / '+c.num):''}` : (c.num||'—');
    const src = p ? p.source : (res ? '<span style="color:var(--red)">geen data</span>' : '<span style="color:var(--txt3)">niet opgehaald</span>');
    const id = p?.id || '—';
    const ctype = c.type || 'mid';

    // Verzamel afwijkingen voor aggregatie (totaal + per type)
    if(p && c.ref) {
      if(!aggByType[ctype]) aggByType[ctype] = {low:[],trend:[],avg7:[],avg30:[]};
      ['low','trend','avg7','avg30'].forEach(f => {
        const dv = PriceValidator.dev(p[f], c.ref);
        if(dv!=null) { agg[f].push(Math.abs(dv)); aggByType[ctype][f].push(Math.abs(dv)); }
      });
    }

    // Beste veld = kleinste absolute afwijking
    let best='—', bestColor='var(--txt3)';
    if(p && c.ref) {
      let bf=null, ba=Infinity;
      ['low','trend','avg7','avg30'].forEach(f=>{
        const dv=PriceValidator.dev(p[f],c.ref);
        if(dv!=null && Math.abs(dv)<ba){ba=Math.abs(dv);bf=f;}
      });
      if(bf){best=bf.toUpperCase();bestColor=PriceValidator.verdict(ba).color;}
    }

    const typeBadge = `<span style="display:inline-block;font-size:10px;padding:1px 6px;border-radius:8px;background:${TYPE_COLORS[ctype]};color:#fff;margin-top:3px">${TYPES[ctype]||ctype}</span>`;

    // Toon ook tweede bron (PokéTCG) als die afwijkt
    let altRow = '';
    if(res?.tcgdex && res?.ptcg) {
      const a = res.ptcg;
      altRow = `<tr style="font-size:11px;color:var(--txt3);border-bottom:1px solid var(--bdr)">
        <td style="padding:3px 6px" colspan="2">↳ vergelijk: PokéTCG</td>
        <td style="padding:3px 6px">PokéTCG</td><td style="padding:3px 6px">${a.id||'—'}</td>
        <td style="padding:3px 6px"></td>
        <td style="padding:3px 6px">${a.low!=null?'€'+a.low.toFixed(2):'—'}</td>
        <td style="padding:3px 6px">${a.trend!=null?'€'+a.trend.toFixed(2):'—'}</td>
        <td style="padding:3px 6px">—</td>
        <td style="padding:3px 6px">${a.avg30!=null?'€'+a.avg30.toFixed(2):'—'}</td>
        <td colspan="2"></td></tr>`;
    }

    return `<tr style="border-bottom:1px solid var(--bdr)">
      <td style="padding:6px"><strong>${c.name}</strong><br>${typeBadge}</td>
      <td style="padding:6px">${setInfo}</td>
      <td style="padding:6px">${src}</td>
      <td style="padding:6px;font-size:11px">${id}</td>
      <td style="padding:6px"><input type="number" step="0.01" value="${c.ref??''}" placeholder="€" style="width:75px" onchange="rblValSetRef(${idx}, this.value)"></td>
      ${rblValCell(p?.low, c.ref)}
      ${rblValCell(p?.trend, c.ref)}
      ${rblValCell(p?.avg7, c.ref)}
      ${rblValCell(p?.avg30, c.ref)}
      <td style="padding:6px;color:${bestColor};font-weight:600">${best}</td>
      <td style="padding:6px"><button onclick="rblValDel(${idx})" style="background:none;border:none;color:var(--red);cursor:pointer;font-size:16px">×</button></td>
    </tr>${altRow}`;
  }).join('');

  // Conclusie per veld (totaal)
  const summary = ['low','trend','avg7','avg30'].map(f => {
    const arr = agg[f];
    if(!arr.length) return `<div style="padding:8px 12px;background:var(--bg2);border-radius:8px"><strong>${f.toUpperCase()}</strong>: geen data</div>`;
    const avgDev = arr.reduce((s,x)=>s+x,0)/arr.length;
    const v = PriceValidator.verdict(avgDev);
    return `<div style="padding:8px 12px;background:var(--bg2);border-radius:8px;border-left:4px solid ${v.color}">
      <strong>${f.toUpperCase()}</strong><br>
      <span style="font-size:13px">gem. afwijking <strong>${avgDev.toFixed(0)}%</strong></span><br>
      <span style="color:${v.color};font-size:13px;font-weight:600">${v.label}</span>
      <span style="color:var(--txt3);font-size:11px"> (${arr.length} kaarten)</span>
    </div>`;
  }).join('');

  // Conclusie per kaarttype — waar loopt Trend weg?
  let byTypeHtml = '';
  const typeKeys = Object.keys(aggByType);
  if(typeKeys.length) {
    const rows = typeKeys.map(t => {
      const cells = ['low','trend','avg7','avg30'].map(f => {
        const arr = aggByType[t][f];
        if(!arr.length) return '<td style="padding:5px 8px;color:var(--txt3)">—</td>';
        const d = arr.reduce((s,x)=>s+x,0)/arr.length;
        const v = PriceValidator.verdict(d);
        return `<td style="padding:5px 8px;color:${v.color};font-weight:600">${d.toFixed(0)}%</td>`;
      }).join('');
      return `<tr style="border-bottom:1px solid var(--bdr)">
        <td style="padding:5px 8px"><span style="display:inline-block;font-size:11px;padding:1px 6px;border-radius:8px;background:${TYPE_COLORS[t]};color:#fff">${TYPES[t]||t}</span></td>
        ${cells}</tr>`;
    }).join('');
    byTypeHtml = `
      <div style="margin-top:16px">
        <div style="font-size:15px;font-weight:600;margin-bottom:8px">🔍 Afwijking per kaarttype (hier zie je wáár het misgaat)</div>
        <table style="width:100%;border-collapse:collapse;font-size:13px">
          <thead><tr style="background:var(--bg2);text-align:left">
            <th style="padding:5px 8px">Type</th><th style="padding:5px 8px">Low</th>
            <th style="padding:5px 8px">Trend</th><th style="padding:5px 8px">AVG7</th><th style="padding:5px 8px">AVG30</th>
          </tr></thead>
          <tbody>${rows}</tbody>
        </table>
        <div style="margin-top:6px;font-size:12px;color:var(--txt3)">Als Trend bij 'Bulk' of 'Nieuwe set' rood is maar bij 'Chase' groen, dan weet je: Trend is alleen betrouwbaar voor bepaalde kaarttypes.</div>
      </div>`;
  }

  document.getElementById('rblValSummary').innerHTML = `
    <div style="margin:14px 0">
      <div style="font-size:15px;font-weight:600;margin-bottom:8px">📊 Conclusie per veld — totaal (lager % = betrouwbaarder)</div>
      <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:8px">${summary}</div>
      <div style="margin-top:8px;font-size:12px;color:var(--txt3)">≤10% = betrouwbaar, ≤25% = twijfel, >25% = onbetrouwbaar.</div>
      ${byTypeHtml}
    </div>`;
}

const PriceCache = {
  KEY: 'rbl_price_cache_v1',
  TTL_MS: 24 * 60 * 60 * 1000,   // 24 uur — dagelijkse sync
  MAX_ENTRIES: 500,

  _load() {
    try { return JSON.parse(localStorage.getItem(this.KEY)) || {}; }
    catch(e) { return {}; }
  },
  _save(store) {
    try { localStorage.setItem(this.KEY, JSON.stringify(store)); }
    catch(e) {
      // localStorage vol → cache leegmaken en opnieuw
      localStorage.removeItem(this.KEY);
    }
  },

  get(cardKey) {
    const store = this._load();
    const entry = store[cardKey];
    if(!entry) return null;
    if(Date.now() - entry.ts > this.TTL_MS) {
      delete store[cardKey];
      this._save(store);
      return null; // verlopen → opnieuw fetchen
    }
    return entry.data;
  },

  set(cardKey, data) {
    const store = this._load();
    store[cardKey] = { ts: Date.now(), data };
    // Cap: verwijder oudste entries boven MAX_ENTRIES
    const keys = Object.keys(store);
    if(keys.length > this.MAX_ENTRIES) {
      keys.sort((a,b) => store[a].ts - store[b].ts)
          .slice(0, keys.length - this.MAX_ENTRIES)
          .forEach(k => delete store[k]);
    }
    this._save(store);
  },

  // Voor admin/debug: cache status
  stats() {
    const store = this._load();
    const keys = Object.keys(store);
    const fresh = keys.filter(k => Date.now() - store[k].ts <= this.TTL_MS);
    return { total: keys.length, fresh: fresh.length, stale: keys.length - fresh.length };
  },

  clear() { localStorage.removeItem(this.KEY); },
};

// ── Publieke wrapper: één entry point voor prijsdata ──
// Wordt gebruikt door zowel rblPickCard als de set-grid.
// Retourneert altijd het genormaliseerde formaat.
async function fetchMarketPrices(card) {
  return await MarketPriceFetcher.fetch(card);
}

// ════════════════════════════════════════════════════════
// CARDMARKET ID RESOLVER (voor Powertools CSV-export)
// PokéTCG geeft GEEN cardmarketId. TCGdex wél — als "idProduct"
// in het pricing.cardmarket blok. We zoeken op naam+nummer,
// halen de kaart-detail op, en lezen idProduct uit.
// Resultaten worden gecachet (set blijft stabiel).
// ════════════════════════════════════════════════════════
const CmIdResolver = {
  KEY: 'rbl_cmid_cache_v1',
  _cache: null,
  _load() {
    if(this._cache) return;
    try { this._cache = JSON.parse(localStorage.getItem(this.KEY)) || {}; }
    catch(e) { this._cache = {}; }
  },
  _save() { try { localStorage.setItem(this.KEY, JSON.stringify(this._cache)); } catch(e){} },

  // Haalt cardmarketId (idProduct) + setCode + cn op voor een kaart.
  // Retourneert {cardmarketId, cn, setName, setCode} of null.
  async resolve(card) {
    this._load();
    const ck = `${card.game}:${card.setName||''}:${card.setCode||''}:${card.number||card.code||''}:${card.name}`.toLowerCase();
    if(this._cache[ck] !== undefined) return this._cache[ck];

    let out = null;
    try {
      if(card.game === 'pokemon') out = await this._pokemon(card);
      else if(card.game === 'mtg') out = await this._mtg(card);
      // Yu-Gi-Oh/One Piece/Lorcana: TCGdex dekt deze (nog) niet betrouwbaar
    } catch(e) { /* stil */ }

    this._cache[ck] = out;  // ook null cachen (voorkomt herhaalde mislukte calls)
    this._save();
    return out;
  },

  async _pokemon(card) {
    const name = card.name;
    const num = (card.number || (card.code||'').split('-')[1] || '').toString().replace(/^0+/,'');
    // Normaliseer setnaam voor vergelijking (zowel TCGdex als onze data hebben de naam)
    const norm = (s) => (s||'').toLowerCase().replace(/[^a-z0-9]/g,'').trim();
    const wantSetName = norm(card.setName);
    const wantNum = num;

    // Helper: lees kaartdetail + idProduct uit een TCGdex kaart-id
    const readCard = async (id) => {
      try {
        const dr = await fetch(`https://api.tcgdex.net/v2/en/cards/${id}`);
        if(!dr.ok) return null;
        const d = await dr.json();
        const cmId = d.pricing?.cardmarket?.idProduct ?? null;
        return {
          cardmarketId: cmId,                       // mag null zijn
          cn: (d.localId!=null?String(d.localId):'') || num || '',
          setName: d.set?.name || card.setName || '',
          setCode: d.set?.id || card.setCode || '',
          _setName: norm(d.set?.name),
          _localId: (d.localId!=null?String(d.localId):'').replace(/^0+/,''),
        };
      } catch(e) { return null; }
    };

    // Verifieer dat een kandidaat ECHT bij deze kaart hoort:
    // setnaam moet matchen EN (indien bekend) het nummer.
    const setMatches = (res) => wantSetName && res._setName === wantSetName;
    const numMatches = (res) => !wantNum || !res._localId || res._localId === wantNum;

    // ── Strategie 1: directe apiId, MAAR alleen accepteren als set klopt ──
    if(card.apiId) {
      const direct = await readCard(card.apiId);
      if(direct && direct.cardmarketId && setMatches(direct) && numMatches(direct)) {
        return direct;
      }
      // set klopt niet → apiId is onbetrouwbaar, ga door naar zoeken
    }

    // ── Strategie 2: zoek op naam, kies kandidaat met kloppende SET + NUMMER ──
    let url = `https://api.tcgdex.net/v2/en/cards?name=${encodeURIComponent(name)}`;
    if(num) url += `&localId=${parseInt(num)}`;
    const r = await fetch(url);
    if(!r.ok) return null;
    const list = await r.json();
    if(!Array.isArray(list) || !list.length) return null;

    const candidates = list.slice(0, 12);
    let exact = null, setOnly = null, fallback = null;
    for(const c of candidates) {
      if(!c?.id) continue;
      const res = await readCard(c.id);
      if(!res || !res.cardmarketId) continue;
      if(!fallback) fallback = res;
      const sm = setMatches(res), nm = numMatches(res);
      if(sm && nm) { exact = res; break; }      // perfecte match: set + nummer
      if(sm && !setOnly) setOnly = res;          // alleen set klopt
    }

    // Voorkeur: exact (set+nummer) > setOnly > niets.
    // We gebruiken GEEN willekeurige fallback meer — liever geen ID dan een foute.
    const chosen = exact || setOnly;
    if(!chosen) {
      // Geen set-match gevonden → geef geen (foute) ID terug, markeer onzeker.
      return fallback ? { ...fallback, cardmarketId: null, _uncertain: true,
        setName: card.setName||fallback.setName, setCode: card.setCode||fallback.setCode } : null;
    }
    if(!exact && setOnly) chosen._uncertain = true;  // set klopt maar nummer niet zeker
    return chosen;
  },

  async _mtg(card) {
    // Scryfall geeft cardmarket_id direct
    try {
      const r = await fetch(`https://api.scryfall.com/cards/named?fuzzy=${encodeURIComponent(card.name)}`);
      if(!r.ok) return null;
      const d = await r.json();
      const cmId = d.cardmarket_id ?? null;
      if(!cmId) return null;
      return { cardmarketId: cmId, cn: d.collector_number||'', setName: d.set_name||'', setCode:(d.set||'').toUpperCase() };
    } catch(e) { return null; }
  },

  clear() { this._cache = null; localStorage.removeItem(this.KEY); },
};

// ── Powertools taal- en conditie-notatie ──────────────
const PT_LANG = { EN:'English', NL:'Dutch', DE:'German', FR:'French', ES:'Spanish', IT:'Italian', JP:'Japanese', PT:'Portuguese' };
// Powertools condities: MT, NM, EX, GD, LP, PL, PO — buylist gebruikt dezelfde codes.
const PT_COND = { MT:'MT', NM:'NM', EX:'EX', GD:'GD', LP:'LP', PL:'PL', PO:'PO' };

// ════════════════════════════════════════════════════════
// PRICE VALIDATION DEBUG MODE
// Meet-instrument. Haalt RUWE prijzen per bron op (geen cache,
// geen PriceList, geen Fair Buy Engine) en vergelijkt elk veld
// met de handmatig ingevulde echte CardMarket-prijs.
// Doel: bewijzen welk veld (Low/Trend/AVG7/AVG30) betrouwbaar is.
// ════════════════════════════════════════════════════════
const PriceValidator = {
  KEY: 'rbl_val_cards_v1',
  cards: [],

  load() {
    try { this.cards = JSON.parse(localStorage.getItem(this.KEY)) || []; }
    catch(e) { this.cards = []; }
  },
  save() { try { localStorage.setItem(this.KEY, JSON.stringify(this.cards)); } catch(e){} },

  add(c) { this.load(); this.cards.push(c); this.save(); },
  clearAll() { this.cards = []; this.save(); },

  // Haal ruwe prijzen op uit de bron voor één kaart — ZONDER cache/PriceList.
  async fetchRaw(card) {
    const game = card.game || 'pokemon';
    if(game === 'pokemon') return await this._rawPokemon(card);
    if(game === 'mtg')     return await this._rawMtg(card);
    if(game === 'yugioh')  return await this._rawYugioh(card);
    return { source:'—', id:'—', low:null, trend:null, avg7:null, avg30:null, note:'Spel niet ondersteund' };
  },

  // Pokémon: probeer TCGdex (op naam+nummer) én PokéTCG, rapporteer beide.
  async _rawPokemon(card) {
    const name = card.name, num = (card.num||'').toString().replace(/^0+/,'');
    // TCGdex zoeken op naam
    let tcgdex = null;
    try {
      let url = `https://api.tcgdex.net/v2/en/cards?name=${encodeURIComponent(name)}`;
      if(num) url += `&localId=${parseInt(num)}`;
      const r = await fetch(url);
      if(r.ok) {
        const list = await r.json();
        const hit = Array.isArray(list) ? list[0] : null;
        if(hit?.id) {
          const dr = await fetch(`https://api.tcgdex.net/v2/en/cards/${hit.id}`);
          if(dr.ok) {
            const d = await dr.json();
            const cm = d.pricing?.cardmarket;
            if(cm) tcgdex = {
              source:'TCGdex', id:hit.id,
              low:cm.low??null, trend:cm.trend??null,
              avg7:cm.avg7??cm.avg1??null, avg30:cm.avg30??cm.avg??null,
              setName:d.set?.name||'', setCode:d.set?.id||'',
            };
          }
        }
      }
    } catch(e) {}

    // PokéTCG zoeken (met key indien aanwezig)
    let ptcg = null;
    try {
      const hdrs = cfg.ptcgKey ? {'X-Api-Key':cfg.ptcgKey} : {};
      let q = `name:"${name}"`;
      if(num) q += ` number:${num}`;
      const r = await fetch(`https://api.pokemontcg.io/v2/cards?q=${encodeURIComponent(q)}&pageSize=5`, {headers:hdrs});
      if(r.ok) {
        const d = await r.json();
        const hit = (d.data||[])[0];
        const cm = hit?.cardmarket?.prices;
        if(cm) ptcg = {
          source:'PokéTCG', id:hit.id,
          low:cm.lowPrice??null, trend:cm.trendPrice??null,
          avg7:null, avg30:cm.averageSellPrice??null,
          setName:hit.set?.name||'', setCode:hit.set?.ptcgoCode||'',
        };
      }
    } catch(e) {}

    // Rapporteer beide bronnen apart zodat je ze kunt vergelijken
    return { tcgdex, ptcg, primary: tcgdex || ptcg };
  },

  async _rawMtg(card) {
    try {
      const r = await fetch(`https://api.scryfall.com/cards/named?fuzzy=${encodeURIComponent(card.name)}`);
      if(r.ok) {
        const d = await r.json();
        const eur = parseFloat(d.prices?.eur)||null;
        const prim = { source:'Scryfall', id:d.id, low:eur, trend:eur, avg7:null, avg30:null,
          setName:d.set_name||'', setCode:(d.set||'').toUpperCase() };
        return { tcgdex:null, ptcg:null, primary:prim, scryfall:prim };
      }
    } catch(e) {}
    return { primary:null };
  },

  async _rawYugioh(card) {
    try {
      const r = await fetch(`https://db.ygoprodeck.com/api/v7/cardinfo.php?name=${encodeURIComponent(card.name)}`);
      if(r.ok) {
        const d = await r.json();
        const hit = (d.data||[])[0];
        const cm = parseFloat(hit?.card_prices?.[0]?.cardmarket_price)||null;
        const prim = { source:'YGOPRODeck', id:hit?.id, low:cm, trend:cm, avg7:null, avg30:null,
          setName:(hit?.card_sets?.[0]?.set_name)||'', setCode:(hit?.card_sets?.[0]?.set_code)||'' };
        return { tcgdex:null, ptcg:null, primary:prim };
      }
    } catch(e) {}
    return { primary:null };
  },

  // Afwijking in % t.o.v. referentie
  dev(val, ref) {
    if(val == null || !ref) return null;
    return ((val - ref) / ref) * 100;
  },

  // Oordeel per veld op basis van afwijking
  verdict(devPct) {
    if(devPct == null) return {label:'—', color:'var(--txt3)'};
    const a = Math.abs(devPct);
    if(a <= 10) return {label:'betrouwbaar', color:'var(--grn3)'};
    if(a <= 25) return {label:'twijfel', color:'var(--ylw)'};
    return {label:'onbetrouwbaar', color:'var(--red)'};
  },
};

const MarketPriceFetcher = {

  // ── Hoofd entry point ──────────────────────────────
  async fetch(card) {
    const { game, name, apiId, code } = card;

    // ── Bron #1 (HOOGSTE prioriteit): eigen prijslijst (Powertools CSV) ──
    // Jouw eigen CardMarket-prijzen — accuraat en gratis.
    const own = PriceList.lookup(card);
    if(own) {
      return {
        low: own.low ?? null, lowEx: own.lowEx ?? null,
        avg7: own.avg7 ?? null, avg30: own.avg30 ?? null, trend: own.trend ?? null,
        listingCount: null, soldLast30: null,
        source: own.source || 'Eigen prijslijst',
        confidence: 1.0,
        needsManualReview: false, reviewReason: null,
      };
    }

    // ── Cache (24u) ──
    const cacheKey = `${game}:${apiId || code || name}`.toLowerCase();
    const cached = PriceCache.get(cacheKey);
    if(cached) {
      return { ...cached, source: cached.source + ' (cache)', fromCache: true };
    }

    let result = null;

    try {
      switch(game) {
        case 'pokemon':
          result = await this.fetchPokemon(apiId, name, code, card._ptcgPrices);
          break;
        case 'mtg':
          result = await this.fetchMTG(apiId, code, name);
          break;
        case 'yugioh':
          result = await this.fetchYugioh(name, code);
          break;
        case 'onepiece':
        case 'lorcana':
          result = await this.fetchTCGCardmarketAPI(game, name, code);
          break;
        default:
          result = this.manualReview(`Onbekend spel: ${game}`);
      }
    } catch(e) {
      console.warn(`[MarketPriceFetcher] ${game} fetch fout:`, e);
      result = this.manualReview(`Fetch fout: ${e.message}`);
    }

    // Valideer het resultaat — als confidence te laag of
    // kritieke velden ontbreken → handmatige beoordeling
    const validated = this.validate(result, card);

    // Alleen betrouwbare resultaten cachen (geen manual reviews)
    if(!validated.needsManualReview) {
      PriceCache.set(cacheKey, validated);
    }
    return validated;
  },

  // ── Pokémon — Fase 1 architectuur ──────────────────
  // PokéTCG = ALLEEN kaartdata/zoeken/afbeeldingen.
  // Marktprijzen komen uit TCGdex: een aparte bron die
  // dagelijks CardMarket EUR prijzen synct (low/trend/avg).
  // PokéTCG cardmarket.prices is alleen nog een noodfallback.
  async fetchPokemon(apiId, name, code, preFetchedPrices) {
    if(!apiId && !code) return this.manualReview('Geen card ID of setcode beschikbaar');

    // ── Bron 0 (PRIMAIR als key aanwezig): pokemon-api.com via RapidAPI ──
    // Echte CardMarket EUR prijzen, meermaals per dag ververst.
    // Dit is de accurate bron (zelfde data als concurrenten).
    if(cfg.rapidApiKey) {
      try {
        const num = (code||'').split('-')[1] || apiId?.split('-')[1] || '';
        const q = num ? `${name} ${num}` : name;
        const r = await fetch(
          `https://pokemon-tcg-api.p.rapidapi.com/cards?search=${encodeURIComponent(q)}&sort=price_highest`,
          { headers: {
              'x-rapidapi-key': cfg.rapidApiKey,
              'x-rapidapi-host': 'pokemon-tcg-api.p.rapidapi.com'
          }}
        );
        if(r.ok) {
          const d = await r.json();
          const arr = d.data || d.cards || (Array.isArray(d) ? d : []);
          // Zoek beste match op nummer
          let hit = arr.find(c => String(c.card_number||'').replace(/^0+/,'') === String(num).replace(/^0+/,''));
          if(!hit) hit = arr[0];
          const cm = hit?.prices?.cardmarket;
          if(cm) {
            // Landkeuze: NL/DE markt → gebruik DE prijs indien aanwezig, anders algemeen low
            const low   = cm.lowest_near_mint_DE ?? cm.lowest_near_mint ?? null;
            const avg30 = cm['30d_average'] ?? null;
            const avg7  = cm['7d_average'] ?? null;
            const trend = avg7 ?? avg30 ?? low;
            if(low || avg7 || avg30) {
              let confidence = 0;
              if(low) confidence += 0.45; if(avg7) confidence += 0.30; if(avg30) confidence += 0.25;
              return {
                low, lowEx:low, avg7, avg30, trend,
                listingCount:null, soldLast30:null,
                source:'CardMarket EU (actueel, betaald)',
                confidence:Math.min(confidence,1.0),
                needsManualReview:false, reviewReason:null,
              };
            }
          }
        } else if(r.status === 429) {
          console.warn('[Fetcher] RapidAPI daglimiet bereikt');
        } else if(r.status === 401 || r.status === 403) {
          console.warn('[Fetcher] RapidAPI key ongeldig');
        }
      } catch(e) { console.warn('[Fetcher] pokemon-api.com fout:', e); }
    }

    const usePtcg = (cm, label) => {
      if(!cm) return null;
      const low   = cm.lowPrice         ?? null;
      const lowEx = cm.lowPriceExPlus   ?? null;
      const trend = cm.trendPrice       ?? null;
      const avg30 = cm.avg30 ?? cm.averageSellPrice ?? null;
      const avg7  = cm.avg7  ?? ((trend && low) ? parseFloat(((trend+low)/2).toFixed(2)) : (trend||low));
      if(!(low || trend || avg7 || avg30)) return null;
      let confidence = 0;
      if(low) confidence += 0.30; if(lowEx) confidence += 0.10;
      if(trend) confidence += 0.25; if(avg7) confidence += 0.15; if(avg30) confidence += 0.20;
      return {
        low, lowEx, avg7, avg30, trend,
        listingCount:null, soldLast30:null,
        source: label || 'PokéTCG → CardMarket prices',
        confidence:Math.min(confidence,1.0),
        needsManualReview:false, reviewReason:null,
      };
    };

    // ── Bron 1 (PRIMAIR): TCGdex — actueelste CardMarket sync ──
    // PokéTCG-prijzen lopen vaak dagen/weken achter. TCGdex is actueler.
    // We zoeken op naam+nummer (set-ID's verschillen tussen de twee API's).
    if(name) {
      try {
        const num = (code||'').split('-')[1] || apiId?.split('-')[1] || '';
        let url = `https://api.tcgdex.net/v2/en/cards?name=${encodeURIComponent(name)}`;
        if(num) url += `&localId=${parseInt(num)}`;
        const r = await fetch(url);
        if(r.ok) {
          const list = await r.json();
          const hit = Array.isArray(list) ? list[0] : null;
          if(hit?.id) {
            const dr = await fetch(`https://api.tcgdex.net/v2/en/cards/${hit.id}`);
            if(dr.ok) {
              const d  = await dr.json();
              const cm = d.pricing?.cardmarket;
              if(cm) {
                const low   = cm.low    ?? null;
                const trend = cm.trend  ?? null;
                const avg7  = cm.avg7   ?? cm.avg1 ?? null;
                const avg30 = cm.avg30  ?? cm.avg  ?? null;
                const lowEx = (cm['low-holo'] && cm['low-holo'] > (low||0)) ? cm['low-holo'] : null;
                if(low || trend || avg7 || avg30) {
                  let confidence = 0;
                  if(low) confidence += 0.35; if(trend) confidence += 0.25;
                  if(avg7) confidence += 0.20; if(avg30) confidence += 0.20;
                  return {
                    low, lowEx, avg7, avg30, trend,
                    listingCount:null, soldLast30:null,
                    source:'TCGdex → CardMarket (actueel)',
                    confidence:Math.min(confidence,1.0),
                    needsManualReview:false, reviewReason:null,
                  };
                }
              }
            }
          }
        }
      } catch(e) { /* stil: val door naar PokéTCG */ }
    }

    // ── Bron 2: prijzen uit zoek/set-respons (PokéTCG, kan verouderd zijn) ──
    const pre = usePtcg(preFetchedPrices, 'PokéTCG → CardMarket (kan achterlopen)');
    if(pre) return pre;

    // ── Bron 3: losse PokéTCG detail-call ──
    if(apiId) {
      try {
        const hdrs = cfg.ptcgKey ? { 'X-Api-Key': cfg.ptcgKey } : {};
        const r = await fetch(`https://api.pokemontcg.io/v2/cards/${apiId}`, { headers: hdrs });
        if(r.ok) {
          const d  = await r.json();
          const detail = usePtcg(d.data?.cardmarket?.prices, 'PokéTCG → CardMarket (kan achterlopen)');
          if(detail) return detail;
        }
      } catch(e) { console.warn('[Fetcher] PokéTCG detail fout:', e); }
    }

    // ── Alle bronnen leeg → handmatige review ──
    const keyHint = cfg.ptcgKey ? '' : ' (Tip: stel een PokéTCG API key in via Admin → Instellingen voor automatische prijzen)';
    return this.manualReview('Geen automatische marktprijs gevonden via deze databron. Deze kaart kan nog steeds op Cardmarket staan.' + keyHint);
  },

  // ── MTG via Scryfall ──────────────────────────────
  async fetchMTG(apiId, code, name) {
    // Scryfall geeft EUR prijzen via CardMarket
    // Maar: geeft alleen huidige low prijs, geen historisch gemiddelde
    let scryfallData = null;

    // Probeer eerst via set+collector number (meest accuraat)
    if(apiId || code) {
      const codeStr = apiId || code;
      const parts   = codeStr.split('-');
      const setCode = parts[0]?.toLowerCase();
      const num     = parts.slice(1).join('/');

      if(setCode && num) {
        const r = await fetch(`https://api.scryfall.com/cards/${setCode}/${num}`);
        if(r.ok) scryfallData = await r.json();
      }
    }

    // Fallback: zoek op naam
    if(!scryfallData && name) {
      const r = await fetch(
        `https://api.scryfall.com/cards/named?fuzzy=${encodeURIComponent(name)}`
      );
      if(r.ok) scryfallData = await r.json();
    }

    if(!scryfallData?.prices) {
      return this.manualReview('Scryfall: geen prijsdata gevonden');
    }

    const eurLow  = parseFloat(scryfallData.prices.eur)       || null;
    const eurFoil = parseFloat(scryfallData.prices.eur_foil)  || null;
    const usd     = parseFloat(scryfallData.prices.usd)       || null;

    if(!eurLow && !usd) {
      return this.manualReview('Geen automatische marktprijs gevonden via deze databron. Deze kaart kan nog steeds op Cardmarket staan.');
    }

    // Scryfall geeft alleen één EUR prijs (huidige low)
    // Geen avg7/avg30 beschikbaar — lagere confidence
    // We gebruiken het als low EN trend (zelfde bron)
    const low = eurLow;

    return {
      low,
      lowEx:        null,   // niet beschikbaar via Scryfall
      avg7:         null,   // niet beschikbaar via Scryfall
      avg30:        null,   // niet beschikbaar via Scryfall
      trend:        low,    // Scryfall EUR = huidige marktprijs ≈ trend
      listingCount: null,
      soldLast30:   null,
      source:       'Scryfall → CardMarket EUR',
      confidence:   low ? 0.55 : 0.20,  // Lager omdat geen historische data
      needsManualReview: false,
      reviewReason: null,
      _foilPrice:   eurFoil, // bewaar voor later gebruik
    };
  },

  // ── Yu-Gi-Oh via YGOPRODeck ───────────────────────
  async fetchYugioh(name, code) {
    // YGOPRODeck geeft CardMarket prijs terug
    // Maar: alleen één prijs (geen avg7/avg30/trend spreiding)
    let endpoint = '';

    if(code) {
      // Zoek op exacte kaartnummer code
      endpoint = `https://db.ygoprodeck.com/api/v7/cardinfo.php?cardcode=${encodeURIComponent(code)}`;
    } else if(name) {
      endpoint = `https://db.ygoprodeck.com/api/v7/cardinfo.php?name=${encodeURIComponent(name)}`;
    } else {
      return this.manualReview('Yu-Gi-Oh: geen naam of code beschikbaar');
    }

    const r = await fetch(endpoint);
    if(!r.ok) return this.manualReview(`YGOPRODeck API fout: ${r.status}`);

    const d      = await r.json();
    const prices = d.data?.[0]?.card_prices?.[0];

    if(!prices) return this.manualReview('YGOPRODeck: geen prijsdata gevonden');

    const cmPrice = parseFloat(prices.cardmarket_price) || null;
    if(!cmPrice || cmPrice <= 0) {
      return this.manualReview('YGOPRODeck: CardMarket prijs is 0 of niet beschikbaar');
    }

    // YGOPRODeck geeft alleen één CM prijs — lage confidence
    // omdat geen spreiding van bronnen beschikbaar is
    return {
      low:          cmPrice,
      lowEx:        null,
      avg7:         null,
      avg30:        null,
      trend:        cmPrice,   // zelfde bron, geen trend data
      listingCount: null,
      soldLast30:   null,
      source:       'YGOPRODeck → CardMarket price',
      confidence:   0.50,      // één bron, geen historische data
      needsManualReview: false,
      reviewReason: null,
    };
  },

  // ── One Piece / Lorcana via tcg-cardmarket-api.com ─
  // Dit vereist een API key van tcg-cardmarket-api.com
  // Gratis tier: 100 requests/dag
  async fetchTCGCardmarketAPI(game, name, code) {
    const apiKey = cfg.tcgCmKey || null;

    if(!apiKey) {
      // Geen API key → handmatige beoordeling
      return this.manualReview(
        `${game === 'onepiece' ? 'One Piece' : 'Lorcana'}: tcg-cardmarket-api.com key vereist — `+
        `stel in via Admin → Instellingen → TCG CardMarket API Key`
      );
    }

    const gameSlug = game === 'onepiece' ? 'one-piece' : 'lorcana';
    const searchName = code || name;

    const r = await fetch(
      `https://tcg-api-production-5148.up.railway.app/cards/search?game=${gameSlug}&name=${encodeURIComponent(searchName)}&limit=5`,
      { headers: { 'X-API-Key': apiKey } }
    );

    if(r.status === 401) return this.manualReview('tcg-cardmarket-api.com: ongeldige API key');
    if(r.status === 429) return this.manualReview('tcg-cardmarket-api.com: dagelijks limiet bereikt (100 req/dag)');
    if(!r.ok)            return this.manualReview(`tcg-cardmarket-api.com API fout: ${r.status}`);

    const d = await r.json();
    if(!d.data?.length)  return this.manualReview(`${game}: geen kaart gevonden voor "${name}"`);

    // Zoek beste match op naam
    const card = d.data.find(c =>
      c.name?.toLowerCase() === name.toLowerCase()
    ) || d.data[0];

    const p = card.price;
    if(!p) return this.manualReview('tcg-cardmarket-api.com: geen prijsobject in response');

    const low   = p.low    ?? null;
    const trend = p.trend  ?? null;
    const avg7  = p.avg7   ?? null;
    const avg30 = p.avg30  ?? null;

    if(!low && !trend && !avg7 && !avg30) {
      return this.manualReview(`${game}: alle prijsvelden zijn null`);
    }

    // Confidence op basis van beschikbare velden
    let confidence = 0;
    if(low)   confidence += 0.25;
    if(trend) confidence += 0.25;
    if(avg7)  confidence += 0.25;
    if(avg30) confidence += 0.25;

    return {
      low,
      lowEx:        p.sell  ?? null,  // 'sell' als EX+ proxy
      avg7,
      avg30,
      trend,
      listingCount: null,
      soldLast30:   null,
      source:       `tcg-cardmarket-api.com → ${gameSlug}`,
      confidence:   Math.min(confidence, 1.0),
      needsManualReview: false,
      reviewReason: null,
    };
  },

  // ── Validatie na fetch ────────────────────────────
  validate(result, card) {
    if(!result) return this.manualReview('Fetch gaf geen resultaat terug');
    if(result.needsManualReview) return result;

    const { low, trend, avg7, avg30, confidence } = result;

    // Minimale drempel: minstens één prijs moet beschikbaar zijn
    const hasAnyPrice = [low, trend, avg7, avg30].some(v => v && v > 0);
    if(!hasAnyPrice) {
      return this.manualReview('Geen enkele prijsbron heeft een waarde > 0');
    }

    // Confidence te laag → toch handmatige beoordeling
    if(confidence < 0.25) {
      return {
        ...result,
        needsManualReview: true,
        reviewReason: `Lage betrouwbaarheid (${(confidence*100).toFixed(0)}%) — te weinig prijsbronnen`,
      };
    }

    // Prijssanity check: extreme uitschieters flaggen
    // Als low > 5× avg30 of avg30 > 5× low → data inconsistentie
    if(low && avg30 && (low > avg30 * 5 || avg30 > low * 5)) {
      return {
        ...result,
        needsManualReview: true,
        reviewReason: `Prijs inconsistentie: Low €${low} vs AVG30 €${avg30} — te groot verschil`,
      };
    }

    return result;
  },

  // ── Helper: handmatige beoordeling ───────────────
  manualReview(reason) {
    return {
      low: null, lowEx: null, avg7: null, avg30: null, trend: null,
      listingCount: null, soldLast30: null,
      source: 'Geen automatische data',
      confidence: 0,
      needsManualReview: true,
      reviewReason: reason,
    };
  },
};

// ════════════════════════════════════════════════════════
// KAART SELECTEREN + FAIR BUY PRICE
// ════════════════════════════════════════════════════════
window.rblCloseCardDetail = function() {
  const ov = document.getElementById('rblOvCardDetail');
  if(ov) ov.classList.remove('show');
  const area = document.getElementById('rblResultArea');
  if(area) area.innerHTML = '';
  selCard = null;
};

window.rblPickCard = async function(key) {
  const card = _cache[key];
  if(!card) return;
  try { if(typeof rblHideAc==='function') rblHideAc(); } catch(e){}
  const si = document.getElementById('rblSearchInp');
  if(si) si.value = '';

  // Blacklist check
  if(isBlacklisted(card.name)) {
    rblShowBlocked(card);
    document.getElementById('rblOvCardDetail')?.classList.add('show');
    return;
  }

  // Toon detail als overlay (altijd in beeld, of je nu zoekt of bladert).
  rblShowCardDetail(card, null);
  document.getElementById('rblOvCardDetail')?.classList.add('show');
  // Resolve cardmarketProductId op de achtergrond (alleen prijs/mapping).
  let cmInfo = null;
  try { cmInfo = await CmIdResolver.resolve(card); } catch(e) {}
  card._cmInfo = cmInfo;
  rblShowCardDetail(card, cmInfo);
};

function rblShowBlocked(card) {
  const bl = cfg.blackList.find(x => card.name.toLowerCase().includes(x.name.toLowerCase()));
  document.getElementById('rblResultArea').innerHTML = `
    <div class="rcard">
      <div class="rcard-top">
        ${card.img ? `<img class="rcard-img" src="${card.img}">` : '<div class="rcard-ph">🚫</div>'}
        <div class="rcard-info">
          <div class="rcard-name">${card.name}</div>
          <div class="fbp-box blocked">
            <div class="fbp-hdr"><span class="fbp-lbl" style="color:var(--red)">🚫 Wij kopen deze kaart momenteel niet in</span></div>
            ${bl?.reason ? `<div style="font-size:16px;color:var(--txt2);margin-top:4px">Reden: ${bl.reason}</div>` : ''}
          </div>
        </div>
      </div>
    </div>`;
}

// Prijsloos kaartdetail: taal, conditie, aantal → toevoegen aan verkooplijst
function rblShowCardDetail(card, cmInfo) {
  const area = document.getElementById('rblResultArea');
  if(!area) return;
  const gc = GAMES[card.game]?.color||'#888';
  const finishes = getFinishOptions(card);
  const defFin = defaultFinish(card);
  // Forceer Engels als deze kaart geen Nederlands toestaat
  if(!nlAllowedFor(card) && (selLang||'EN') !== 'EN') selLang = 'EN';
  selCard = { card, cond:'NM', lang: nlAllowedFor(card) ? (selLang||'EN') : 'EN', quantity:1, finish:defFin, cmInfo };

  // Bulk-melding als de kaart in 'normal' finish bulk is
  const bulkWarn = isBulkCard(card, 'normal')
    ? `<div style="background:var(--bg3);border:1px solid var(--bdr);border-radius:8px;padding:10px 12px;margin:8px 0;font-size:14px;color:var(--txt2);line-height:1.5">
        📦 <strong>Commons & uncommons</strong> kopen wij als <strong>bulk</strong> in (€3 per 800 kaarten) — die hoef je niet los toe te voegen.
        Alleen <strong>holo / reverse holo / foil</strong> versies kun je hieronder los toevoegen.
      </div>`
    : '';

  area.innerHTML = `<div class="rcard" id="rblRcard">
    <div class="rcard-top">
      <div style="flex-shrink:0">
        ${card.img ? `<img class="rcard-img" src="${card.img}" alt="">` : '<div class="rcard-ph">🃏</div>'}
      </div>
      <div class="rcard-info">
        <div class="rcard-name">${card.name}</div>
        <div class="rcard-pills">
          ${card.code   ? `<span class="pill pill-code">${card.code}</span>` : ''}
          ${card.rarity ? `<span class="pill pill-rare">${card.rarity}</span>` : ''}
          <span class="pill" style="background:${gc}18;border:1px solid ${gc}55;color:${gc}">${GAMES[card.game]?.label||card.game}</span>
          ${card.setName? `<span class="pill pill-set">${card.setName}</span>` : ''}
          ${card.number? `<span class="pill">#${card.number}</span>` : ''}
        </div>

        ${bulkWarn}

        <div class="cond-lbl" style="margin-top:10px">Taal:</div>
        <div class="lang-row" id="rblLangRow">
          ${(() => {
            const allowed = langsFor(card);
            // Als de huidige keuze niet mag (bv. NL op een set zonder NL), val terug op EN
            if(!allowed.some(l => l.code === (selLang||'EN'))) selLang = 'EN';
            if(allowed.length === 1) {
              // Maar één taal mogelijk → toon als vaste tekst, geen knoppen
              return `<span style="font-weight:400;color:var(--txt3)">${allowed[0].label}</span>`;
            }
            return allowed.map(l=>`<button class="lang-btn${(selLang||'EN')===l.code?' on':''}" onclick="rblSetLang('${l.code}',this)">${l.label}</button>`).join('');
          })()}
        </div>

        ${finishes.length > 1 ? `
        <div class="cond-lbl" style="margin-top:10px">Finish:</div>
        <div class="lang-row" id="rblFinishRow">
          ${finishes.map(f=>`<button class="lang-btn${f===defFin?' on':''}" onclick="rblSetFinish('${f}',this)">${FINISH_LABELS[f]}</button>`).join('')}
        </div>` : `
        <div class="cond-lbl" style="margin-top:10px">Finish: <span style="font-weight:400;color:var(--txt3)">${FINISH_LABELS[defFin]}</span></div>
        <div id="rblFinishRow" style="display:none"></div>`}

        <div class="cond-lbl" style="margin-top:10px;display:flex;align-items:center;justify-content:space-between;gap:8px">
          <span>Conditie:</span>
          <button type="button" onclick="rblShowCondHelp()" style="background:none;border:none;color:var(--blu);font-size:13px;font-weight:600;cursor:pointer;padding:0;text-decoration:underline">❓ Wat betekenen deze condities?</button>
        </div>
        <div class="cond-grid">
          ${CONDS.map(c=>`<div class="cc${c.code==='NM'?' cc-sel':''}" id="rblCc_${c.code}" onclick="rblSelCondSimple('${c.code}')">
            <div class="cc-code">${c.code}</div>
            <div class="cc-desc" style="font-size:11px;color:var(--txt3)">${c.desc||''}</div>
          </div>`).join('')}
        </div>

        <div class="cond-lbl" style="margin-top:10px">Aantal:</div>
        <div style="display:flex;align-items:center;gap:12px">
          <button onclick="rblDetailQty(-1)" style="width:36px;height:36px;border-radius:8px;border:1px solid var(--bdr);background:var(--bg3);font-size:20px;cursor:pointer">−</button>
          <span id="rblDetailQtyVal" style="min-width:36px;text-align:center;font-weight:700;font-size:20px">1</span>
          <button onclick="rblDetailQty(1)" style="width:36px;height:36px;border-radius:8px;border:1px solid var(--bdr);background:var(--bg3);font-size:20px;cursor:pointer">+</button>
        </div>
      </div>
    </div>
    <div class="rcard-footer">
      <div class="add-info" id="rblAddInfo">Kaart wordt toegevoegd als NM · Engels · ${FINISH_LABELS[defFin]} — pas hierboven aan indien nodig</div>
      <button class="btn-add" id="rblBtnAdd" onclick="rblAddDetailToCart()">+ Toevoegen aan verkooplijst</button>
    </div>
  </div>`;
}

window.rblSetLang = function(lang, el) {
  // Veiligheidscheck: Nederlands alleen toestaan op kaarten die het ondersteunen
  if(lang === 'NL' && selCard && !nlAllowedFor(selCard.card)) {
    lang = 'EN';
  }
  selLang = lang;
  if(selCard) selCard.lang = lang;
  document.querySelectorAll('#rblLangRow .lang-btn').forEach(b => b.classList.remove('on'));
  if(el) el.classList.add('on');
};

window.rblSetFinish = function(finish, el) {
  if(selCard) selCard.finish = finish;
  document.querySelectorAll('#rblFinishRow .lang-btn').forEach(b => b.classList.remove('on'));
  el.classList.add('on');
  // Update de info-tekst onderaan
  const info = document.getElementById('rblAddInfo');
  if(info && selCard) info.textContent = `Kaart wordt toegevoegd als ${selCard.cond} · ${selCard.lang} · ${FINISH_LABELS[finish]}`;
};

window.rblSelCondSimple = function(code) {
  if(selCard) selCard.cond = code;
  document.querySelectorAll('#rbl .cc').forEach(el => el.classList.remove('cc-sel'));
  document.getElementById('rblCc_'+code)?.classList.add('cc-sel');
};

// ════════════════════════════════════════════════════════
// CONDITIE-UITLEG (gebaseerd op de officiële CardMarket-gradering,
// vertaald en toegankelijk gemaakt in het Nederlands, met eigen
// illustraties per conditie i.p.v. gekopieerde foto's)
// ════════════════════════════════════════════════════════
const COND_GUIDE = [
  { code:'NM', label:'Near Mint', color:'#16a34a',
    short:'Vrijwel perfect',
    desc:'Zo goed als nieuw. Een Near Mint-kaart ziet er onbeschadigd uit, alsof hij net uit het pakje komt. Bij heel goed kijken zijn er hooguit minuscule oneffenheden, maar geen krassen, witte randjes of beschadigingen.',
    points:['Scherpe, schone randen','Geen krassen of vlekken','Geen witte hoeken','Ligt vlak op tafel'] },
  { code:'EX', label:'Excellent', color:'#65a30d',
    short:'Licht gespeeld',
    desc:'Heel lichte gebruikssporen die je pas ziet als je de kaart van dichtbij of onder een hoek bekijkt. Denk aan minimale slijtage aan een rand of hoek. Op afstand oogt de kaart nog uitstekend.',
    points:['Minimale slijtage aan rand of hoek','Heel lichte krasjes mogelijk','Geen duidelijke beschadiging','Goed speelbaar in een hoesje'] },
  { code:'GD', label:'Good', color:'#ca8a04',
    short:'Normaal gespeeld',
    desc:'Duidelijk zichtbare gebruikssporen, maar de kaart is nog volledig intact. Lichte witte randjes, kleine krassen of een licht versleten hoek zijn normaal voor deze staat.',
    points:['Zichtbare slijtage aan randen/hoeken','Lichte witte randjes mogelijk','Kleine krasjes op het oppervlak','Geen scheuren of vouwen'] },
  { code:'LP', label:'Light Played', color:'#ea580c',
    short:'Merkbaar gespeeld',
    desc:'Goed merkbare slijtage. Witte randen, krassen, lichte verkleuring of een minimale buiging kunnen aanwezig zijn. De kaart is nog prima speelbaar maar duidelijk gebruikt.',
    points:['Duidelijke witte randen','Krassen of lichte verkleuring','Mogelijk een minimale buiging','Nog goed speelbaar'] },
  { code:'PL', label:'Played', color:'#dc2626',
    short:'Flink gespeeld',
    desc:'Flinke gebruikssporen: duidelijke witte randen, krassen, een vouw of buiging, of lichte water-/randschade. De kaart is compleet maar zwaar getekend door gebruik.',
    points:['Veel witte randen en krassen','Mogelijk een vouw of buiging','Lichte verkleuring of randschade','Compleet, maar duidelijk versleten'] },
  { code:'PO', label:'Poor', color:'#991b1b',
    short:'Zwaar beschadigd',
    desc:'Zwaar beschadigd: forse vouwen, scheuren, watervlekken, geschreven tekst, of een bewerkte rand. Ook kaarten met een stempel of beschreven/ingekleurde rand vallen hieronder.',
    points:['Forse vouwen of scheuren','Water- of inktschade','Beschreven of bewerkte rand','Alleen nog als speelkaart bruikbaar'] },
];

// Tekent een kaart-illustratie per conditie (eigen SVG, schaalt mooi)
function rblCondSVG(code, color) {
  const wear = {
    NM:'', EX:'lt', GD:'md', LP:'hv', PL:'xt', PO:'po'
  }[code] || '';
  // Slijtage-elementen opbouwen naar gelang de conditie
  let marks = '';
  const corner = (x,y,n)=>`<path d="M${x} ${y} l${n} 0 l0 ${n}" stroke="#fff" stroke-width="2.5" fill="none" opacity="0.9"/>`;
  const scratch = (x,y,len)=>`<line x1="${x}" y1="${y}" x2="${x+len}" y2="${y+3}" stroke="#fff" stroke-width="1" opacity="0.55"/>`;
  if(['EX','GD','LP','PL','PO'].includes(code)) marks += corner(10,10,9);              // lichte hoekslijtage
  if(['GD','LP','PL','PO'].includes(code))      marks += corner(83,116,-9)+scratch(28,50,30);
  if(['LP','PL','PO'].includes(code))           marks += `<rect x="6" y="6" width="88" height="118" rx="7" fill="none" stroke="#fff" stroke-width="3" opacity="0.4"/>`+scratch(20,80,40);
  if(['PL','PO'].includes(code))                marks += `<line x1="50" y1="8" x2="46" y2="122" stroke="#000" stroke-width="2" opacity="0.25"/>`+scratch(30,95,35); // vouw
  if(code==='PO')                               marks += `<path d="M70 10 L66 60 L78 70 L70 122" stroke="#000" stroke-width="2.5" fill="none" opacity="0.4"/><line x1="15" y1="30" x2="85" y2="40" stroke="#fff" stroke-width="2" opacity="0.6"/>`; // scheur
  return `<svg viewBox="0 0 100 130" xmlns="http://www.w3.org/2000/svg" style="width:100%;height:auto;display:block">
    <rect x="3" y="3" width="94" height="124" rx="8" fill="${color}" opacity="0.16"/>
    <rect x="3" y="3" width="94" height="124" rx="8" fill="none" stroke="${color}" stroke-width="2.5"/>
    <rect x="14" y="16" width="72" height="46" rx="4" fill="${color}" opacity="0.28"/>
    <rect x="14" y="70" width="72" height="8" rx="2" fill="${color}" opacity="0.22"/>
    <rect x="14" y="84" width="56" height="6" rx="2" fill="${color}" opacity="0.18"/>
    <rect x="14" y="96" width="64" height="6" rx="2" fill="${color}" opacity="0.18"/>
    <text x="50" y="120" text-anchor="middle" font-size="12" font-weight="700" fill="${color}">${code}</text>
    ${marks}
  </svg>`;
}

window.rblShowCondHelp = function() {
  const body = document.getElementById('rblCondHelpBody');
  if(!body) return;
  body.innerHTML = `
    <p style="font-size:15px;color:var(--txt2);line-height:1.55;margin-bottom:16px">
      De conditie bepaalt hoe goed je kaart bewaard is gebleven. Kies eerlijk — wij controleren elke kaart bij ontvangst.
      Twijfel je tussen twee niveaus? Kies dan de laagste; dat voorkomt teleurstelling achteraf.
    </p>
    ${COND_GUIDE.map(c=>`
      <div style="display:flex;gap:14px;padding:14px 0;border-top:1px solid var(--bg3)">
        <div style="width:72px;flex-shrink:0">${rblCondSVG(c.code, c.color)}</div>
        <div style="flex:1">
          <div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:4px">
            <span style="font-weight:800;font-size:17px;color:${c.color}">${c.code}</span>
            <span style="font-weight:700;font-size:15px">${c.label}</span>
            <span style="font-size:13px;color:var(--txt3)">· ${c.short}</span>
          </div>
          <div style="font-size:14px;color:var(--txt2);line-height:1.5;margin-bottom:6px">${c.desc}</div>
          <div style="display:flex;flex-wrap:wrap;gap:4px 10px">
            ${c.points.map(p=>`<span style="font-size:12px;color:var(--txt3)">• ${p}</span>`).join('')}
          </div>
        </div>
      </div>`).join('')}
    <div style="background:var(--bg3);border-radius:8px;padding:11px 13px;margin-top:14px;font-size:13px;color:var(--txt3);line-height:1.5">
      💡 <strong>Foil-kaarten</strong> zijn gevoeliger voor krassen en "clouding" (een doffe waas). Beoordeel die net iets strenger.
    </div>`;
  document.getElementById('rblOvCondHelp').classList.add('show');
};
window.rblCloseCondHelp = function() {
  document.getElementById('rblOvCondHelp')?.classList.remove('show');
};

// Toont een voorwaarden-tekst (voorwaarden / nepKaarten / privacy) in een pop-up.
const RBL_TERMS_TITLES = {
  voorwaarden: '📋 Inkoopvoorwaarden',
  nepKaarten: '🛡️ Beleid rond namaak',
  privacy: '🔒 Privacyverklaring',
};
window.rblShowTerms = function(which) {
  const body = document.getElementById('rblTermsBody');
  const title = document.getElementById('rblTermsTitle');
  if(!body) return;
  const entry = (RBL_TERMS && RBL_TERMS[which]) ? RBL_TERMS[which] : null;
  if(title) title.textContent = RBL_TERMS_TITLES[which] || 'Voorwaarden';
  const summary = entry ? (entry.samenvatting || '') : '';
  const url = entry ? (entry.url || '') : '';
  // Tekst veilig tonen met regelafbrekingen
  const safe = summary.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/\n/g,'<br>');
  const linkBtn = url
    ? `<a href="${url}" target="_blank" rel="noopener" style="display:inline-block;margin-top:14px;padding:10px 16px;background:var(--red);color:#fff;border-radius:8px;font-weight:700;text-decoration:none">Lees de volledige tekst →</a>`
    : '';
  body.innerHTML = `<div style="font-size:15px;line-height:1.6;color:var(--txt2)">${safe || 'Nog geen tekst ingevuld.'}</div>${linkBtn}`;
  document.getElementById('rblOvTerms')?.classList.add('show');
};
window.rblCloseTerms = function() {
  document.getElementById('rblOvTerms')?.classList.remove('show');
};

window.rblDetailQty = function(delta) {
  if(!selCard) return;
  selCard.quantity = Math.max(1, (selCard.quantity||1) + delta);
  const el = document.getElementById('rblDetailQtyVal');
  if(el) el.textContent = selCard.quantity;
};

window.rblAddDetailToCart = function() {
  if(!selCard?.card) return;
  const { card, cond, lang, quantity, cmInfo } = selCard;
  const finish = selCard.finish || defaultFinish(card);

  // Bulk-block: common/uncommon in 'normal' finish kopen we als bulk in
  if(isBulkCard(card, finish)) {
    rblToast('📦 Commons/uncommons kopen wij als bulk in — kies holo/reverse/foil om los toe te voegen', true);
    return;
  }

  const isRev = finish === 'reverse';
  const isFoilHolo = finish === 'foil' || finish === 'holo';
  const lineKey = makeInternalKey(card, card.game, { language: lang||'EN', condition: cond, finish });
  const baseKey = makeCardBaseKey(card, card.game);

  // Bestaat deze exacte regel al (identiteit + taal + conditie + finish)? → ophogen
  const existing = cart.find(c => c.internalKey === lineKey);
  if(existing) {
    existing.quantity = (existing.quantity||1) + (quantity||1);
  } else {
    // De kaart die de klant koos is LEIDEND voor set/naam/nummer.
    // De resolver levert ALLEEN de cardmarketProductId (prijs/mapping).
    const cmProductId = card.cardmarketProductId || cmInfo?.cardmarketId || card.cardmarketId || null;
    cart.push({
      internalKey: lineKey,
      _baseKey: baseKey,
      sourceCardId: card.sourceCardId || card.scryfallId || card.apiId || card.code || null,
      cardmarketProductId: cmProductId,
      cardmarketId: cmProductId,  // alias voor CSV-kolom
      _idUncertain: !!cmInfo?._uncertain,
      name: card.name, img: card.img||'', code: card.code||'',
      game: card.game,
      setName: card.setName||'',
      setId:   card.setId||'',
      setCode: card.setCode||'',
      rarity: card.rarity||'',
      cn: card.number || (card.code||'').split('-')[1] || '',
      finish,                              // ← finish bewaard
      isReverseHolo: isRev,
      isFoilHolo,
      cond, lang: lang||'EN', quantity: quantity||1,
      timestamp: Date.now(),
    });
  }
  rblUpdateCart();
  rblRenderMiniCart();
  rblOpenMiniCart();
  const idNote = (cmInfo?.cardmarketId || card.cardmarketId) ? '' : ' ⚠ geen CardMarket-ID';
  rblDebugCard('DetailAdd', card, cart.find(c=>c.internalKey===lineKey));
  rblToast(`${quantity||1}× ${card.name} (${cond} · ${lang} · ${FINISH_LABELS[finish]}) toegevoegd ✓${idNote}`);
  // Sluit het detail-overlay
  document.getElementById('rblOvCardDetail')?.classList.remove('show');
  document.getElementById('rblResultArea').innerHTML = '';
  selCard = null;
};

// ════════════════════════════════════════════════════════
// WINKELWAGEN
// ════════════════════════════════════════════════════════
// ════════════════════════════════════════════════════════
// AANVRAAG TIJDELIJK OPSLAAN (concept in localStorage)
// Geen account nodig. Bewaart de verkooplijst lokaal in de browser.
// ════════════════════════════════════════════════════════
window.rblSaveDraft = function() {
  if(!cart.length) { rblToast('Je verkooplijst is leeg — niets om op te slaan', true); return; }
  try {
    const draft = { cart: cart, savedAt: Date.now() };
    localStorage.setItem(SK.draft, JSON.stringify(draft));
    rblToast('💾 Verkooplijst opgeslagen — je kunt later verdergaan');
    rblRenderResumeBanner();
  } catch(e) {
    rblToast('Opslaan mislukt (opslag vol?)', true);
  }
};

function rblGetDraft() {
  try {
    const d = JSON.parse(localStorage.getItem(SK.draft));
    if(d && Array.isArray(d.cart) && d.cart.length) return d;
  } catch(e) {}
  return null;
}

function rblRenderResumeBanner() {
  const banner = document.getElementById('rblResumeBanner');
  if(!banner) return;
  const d = rblGetDraft();
  if(!d) { banner.style.display = 'none'; return; }
  const n = d.cart.reduce((s,c)=>s+(c.quantity||1),0);
  const when = new Date(d.savedAt);
  const info = document.getElementById('rblResumeInfo');
  if(info) info.textContent = `— ${n} kaart${n!==1?'en':''}, opgeslagen ${when.toLocaleDateString('nl-NL')} ${when.toLocaleTimeString('nl-NL',{hour:'2-digit',minute:'2-digit'})}`;
  banner.style.display = 'flex';
}

window.rblResumeDraft = function() {
  const d = rblGetDraft();
  if(!d) { rblToast('Geen opgeslagen aanvraag gevonden', true); return; }
  // Voeg samen met huidige cart (geen dubbele internalKeys)
  for(const item of d.cart) {
    const existing = cart.find(c => c.internalKey === item.internalKey);
    if(existing) existing.quantity = (existing.quantity||1) + (item.quantity||1);
    else cart.push(item);
  }
  rblUpdateCart(); rblRenderCart(); rblRenderMiniCart();
  document.getElementById('rblResumeBanner').style.display = 'none';
  rblToast(`✓ ${d.cart.length} regel(s) hersteld`);
  rblOpenMiniCart();
};

window.rblDiscardDraft = function() {
  localStorage.removeItem(SK.draft);
  const banner = document.getElementById('rblResumeBanner');
  if(banner) banner.style.display = 'none';
  rblToast('Opgeslagen aanvraag verwijderd');
};

window.rblRemoveFromCart = function(key) {
  cart=cart.filter(c=>c.internalKey!==key);
  rblUpdateCart(); rblRenderCart(); rblRenderSummary(); rblRenderMiniCart();
};

// ── MINI-CART (slide-in bij toevoegen) ───────────────
function rblOpenMiniCart() {
  rblRenderMiniCart();
  const panel = document.getElementById('rblMiniCart');
  const back  = document.getElementById('rblMiniCartBackdrop');
  if(back) back.style.display = 'block';
  if(panel) panel.style.transform = 'translateX(0)';
}
window.rblCloseMiniCart = function() {
  const panel = document.getElementById('rblMiniCart');
  const back  = document.getElementById('rblMiniCartBackdrop');
  if(panel) panel.style.transform = 'translateX(100%)';
  if(back) back.style.display = 'none';
};
function rblRenderMiniCart() {
  const body = document.getElementById('rblMiniBody');
  const cnt  = document.getElementById('rblMiniCount');
  if(!body) return;
  const totalCards = cart.reduce((s,c)=>s+(c.quantity||1),0);
  if(cnt) cnt.textContent = `(${totalCards})`;
  if(!cart.length) { body.innerHTML = '<div style="padding:24px;text-align:center;color:var(--txt3,#888)">Je lijst is leeg</div>'; return; }
  body.innerHTML = cart.map(c=>{
    const k = c.internalKey.replace(/'/g,"\\'");
    return `
    <div style="display:flex;align-items:center;gap:10px;padding:8px 4px;border-bottom:1px solid var(--bdr,#333)">
      ${c.img?`<img src="${c.img}" style="width:34px;height:48px;object-fit:cover;border-radius:4px;flex-shrink:0">`:'<div style="width:34px;height:48px;background:var(--bg3,#222);border-radius:4px;display:flex;align-items:center;justify-content:center;flex-shrink:0">🃏</div>'}
      <div style="flex:1;min-width:0">
        <div style="font-weight:600;font-size:14px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">${c.name}</div>
        <div style="font-size:12px;color:var(--txt3,#888)">${c.setName||''} · ${c.cond} · ${c.lang||'EN'}${c.finish&&c.finish!=='normal'?' · '+(FINISH_LABELS[c.finish]||c.finish):''}</div>
      </div>
      <div style="display:flex;align-items:center;gap:6px;flex-shrink:0">
        <button onclick="rblCartQtyChange('${k}',-1)" style="width:24px;height:24px;border-radius:5px;border:1px solid var(--bdr,#333);background:var(--bg3,#222);cursor:pointer;font-size:15px">−</button>
        <span style="min-width:18px;text-align:center;font-weight:700">${c.quantity||1}</span>
        <button onclick="rblCartQtyChange('${k}',1)" style="width:24px;height:24px;border-radius:5px;border:1px solid var(--bdr,#333);background:var(--bg3,#222);cursor:pointer;font-size:15px">+</button>
        <button onclick="rblRemoveFromCart('${k}')" style="background:none;border:none;color:var(--red,#e8391a);cursor:pointer;font-size:16px;margin-left:2px">✕</button>
      </div>
    </div>`;
  }).join('');
}

function rblUpdateCart() {
  const totalCards = cart.reduce((s,c)=>s+(c.quantity||1),0);
  const badge = document.getElementById('rblCartBadge');
  if(badge) badge.textContent = totalCards;
  const totalEl = document.getElementById('rblCartTotal');
  if(totalEl) totalEl.textContent = `${totalCards} kaart${totalCards!==1?'en':''}`;
  document.getElementById('rblCartBar')?.classList.toggle('show', cart.length>0);
}

function rblRenderCart() {
  const body=document.getElementById('rblCartBody');
  if(!body) return;
  if(!cart.length) { body.innerHTML='<div class="ac-msg" style="padding:24px">Je verkooplijst is nog leeg</div>'; return; }
  const totalCards = cart.reduce((s,c)=>s+(c.quantity||1),0);
  body.innerHTML=cart.map(c=>{
    const k = c.internalKey.replace(/'/g,"\\'");
    return `
    <div class="ci">
      ${c.img?`<img class="ci-img" src="${c.img}">`:'<div class="ci-ph">🃏</div>'}
      <div style="flex:1;min-width:0">
        <div class="ci-name">${c.name}</div>
        <div class="ci-meta">${c.setName||c.code||''} · ${c.cond} · ${c.lang||'EN'}${c.finish&&c.finish!=='normal'?' · '+(FINISH_LABELS[c.finish]||c.finish):''} · ${GAMES[c.game]?.label||c.game}</div>
      </div>
      <div style="display:flex;align-items:center;gap:8px">
        <button class="ci-qtybtn" onclick="rblCartQtyChange('${k}',-1)" style="width:28px;height:28px;border-radius:6px;border:1px solid var(--bdr);background:var(--bg3);font-size:18px;cursor:pointer">−</button>
        <span style="min-width:24px;text-align:center;font-weight:700;font-size:16px">${c.quantity||1}</span>
        <button class="ci-qtybtn" onclick="rblCartQtyChange('${k}',1)" style="width:28px;height:28px;border-radius:6px;border:1px solid var(--bdr);background:var(--bg3);font-size:18px;cursor:pointer">+</button>
      </div>
      <button class="ci-del" onclick="rblRemoveFromCart('${k}')">✕</button>
    </div>`;
  }).join('')
  +`<div class="sum-row total"><span>Totaal</span><span class="sum-val">${totalCards} kaart${totalCards!==1?'en':''}</span></div>`;
}

window.rblCartQtyChange = function(key, delta) {
  const item = cart.find(c=>c.internalKey===key);
  if(!item) return;
  item.quantity = (item.quantity||1) + delta;
  if(item.quantity < 1) { cart = cart.filter(c=>c.internalKey!==key); }
  rblUpdateCart(); rblRenderCart(); rblRenderMiniCart();
};

window.rblOpenCart = function() { rblRenderCart(); document.getElementById('rblOvCart').classList.add('show'); };
window.rblCloseCart = function() { document.getElementById('rblOvCart').classList.remove('show'); };

function rblRenderSummary() {
  const el = document.getElementById('rblSummary');
  if(!el) return;
  const totalCards = cart.reduce((s,c)=>s+(c.quantity||1),0);
  el.innerHTML =
    `<div class="sum-row total"><span>Jouw verkooplijst</span><span class="sum-val">${totalCards} kaart${totalCards!==1?'en':''}</span></div>`;
}

window.rblOpenSubmit = function() {
  const totalCards = cart.reduce((s,c)=>s+(c.quantity||1),0);
  if(!cart.length) { rblToast('Je verkooplijst is nog leeg', true); return; }
  const summaryHtml =
    `<div class="sum-row total"><span>Jouw verkooplijst</span><span class="sum-val">${totalCards} kaart${totalCards!==1?'en':''}</span></div>`;
  document.getElementById('rblSubmitBody').innerHTML = `
    <div id="rblSummary" style="background:var(--bg3);border-radius:8px;padding:11px 13px;margin-bottom:14px">
      ${summaryHtml}
    </div>
    <div class="disclaimer"><strong>ℹ Hoe werkt het?</strong> Je stuurt je verkooplijst in. Wij beoordelen je kaarten en sturen je zo snel mogelijk een persoonlijk bod via e-mail.</div>

    <div class="name-row" style="display:flex;gap:10px;flex-wrap:wrap">
      <div class="frow nm-f"><label>Voornaam *</label>
        <input type="text" id="rblFFirst" placeholder="Jan" oninput="rblClearErr('rblFFirst')">
        <div class="ferr" id="err_rblFFirst"></div></div>
      <div class="frow nm-f"><label>Achternaam *</label>
        <input type="text" id="rblFLast" placeholder="de Vries" oninput="rblClearErr('rblFLast')">
        <div class="ferr" id="err_rblFLast"></div></div>
    </div>
    <div class="frow"><label>E-mail *</label>
      <input type="email" id="rblFEmail" placeholder="jan@email.nl" oninput="rblClearErr('rblFEmail')">
      <div class="ferr" id="err_rblFEmail"></div></div>
    <div class="frow"><label>Telefoonnummer *</label>
      <input type="tel" id="rblFPhone" placeholder="06-12345678" oninput="rblClearErr('rblFPhone')">
      <div class="ferr" id="err_rblFPhone"></div></div>

    <div class="frow"><label>Hoe wil je betaald worden? *</label>
      <div id="rblFPayment" class="pay-grid">
        <label class="pay-opt">
          <input type="radio" name="rblPay" value="Bankoverschrijving" onchange="rblClearErr('rblFPayment');rblPayHighlight()">
          <span>🏦 Bankoverschrijving</span>
        </label>
        <label class="pay-opt">
          <input type="radio" name="rblPay" value="Contant in de winkel" onchange="rblClearErr('rblFPayment');rblPayHighlight()">
          <span>💶 Contant in de winkel</span>
        </label>
      </div>
      <div class="ferr" id="err_rblFPayment"></div></div>

    <div class="frow">
      <label>Heb je ook bulk? <span style="color:var(--txt3);font-weight:400">(optioneel)</span></label>
      <div style="font-size:13px;color:var(--txt3);font-weight:400;margin-bottom:6px;line-height:1.5">
        Losse, niet-gesorteerde kaarten (commons/uncommons) die je niet apart hebt ingevoerd. Geef een schatting van het aantal en het type.
      </div>
      <div style="display:flex;gap:10px;flex-wrap:wrap">
        <input type="number" id="rblFBulkQty" min="0" placeholder="Aantal (bijv. 500)" style="flex:1;min-width:130px">
        <input type="text" id="rblFBulkType" placeholder="Soort (bijv. Pokémon EN commons)" style="flex:2;min-width:170px">
      </div>
    </div>

    <div class="frow"><label>Opmerkingen <span style="color:var(--txt3);font-weight:400">(optioneel)</span></label>
      <textarea id="rblFNote" placeholder="bijv. ik kan langskomen op vrijdag"></textarea></div>

    <div class="frow" style="margin-top:6px">
      <label class="terms-check" style="display:flex;align-items:flex-start;gap:9px;cursor:pointer;font-weight:400;text-transform:none;letter-spacing:0;font-size:14px;color:var(--txt2)">
        <input type="checkbox" id="rblFTerms" onchange="rblClearErr('rblFTerms')" style="margin-top:2px;width:18px;height:18px;flex-shrink:0;accent-color:var(--red)">
        <span>Ik ga akkoord met de <button type="button" onclick="rblShowTerms('voorwaarden')" style="background:none;border:none;color:var(--blu);text-decoration:underline;cursor:pointer;padding:0;font-size:14px">inkoopvoorwaarden</button>, het <button type="button" onclick="rblShowTerms('nepKaarten')" style="background:none;border:none;color:var(--blu);text-decoration:underline;cursor:pointer;padding:0;font-size:14px">beleid rond namaak</button> en de <button type="button" onclick="rblShowTerms('privacy')" style="background:none;border:none;color:var(--blu);text-decoration:underline;cursor:pointer;padding:0;font-size:14px">privacyverklaring</button>.</span>
      </label>
      <div class="ferr" id="err_rblFTerms"></div>
    </div>`;
  document.getElementById('rblOvSubmit').classList.add('show');
};
window.rblCloseSubmit = function() { document.getElementById('rblOvSubmit').classList.remove('show'); };

// Markeer de gekozen betaaloptie visueel
window.rblPayHighlight = function() {
  document.querySelectorAll('#rblFPayment .pay-opt').forEach(l => {
    const r = l.querySelector('input');
    l.classList.toggle('on', !!(r && r.checked));
  });
};
// Foutmelding tonen/wissen per veld
function rblShowErr(id, msg) {
  const e = document.getElementById('err_'+id);
  if(e) { e.textContent = msg; e.style.display='block'; }
  const f = document.getElementById(id);
  if(f && f.style) f.style.borderColor = 'var(--red)';
}
function rblClearErr(id) {
  const e = document.getElementById('err_'+id);
  if(e) { e.textContent=''; e.style.display='none'; }
  const f = document.getElementById(id);
  if(f && f.style) f.style.borderColor = '';
}
window.rblShowErr = rblShowErr;
window.rblClearErr = rblClearErr;

// ════════════════════════════════════════════════════════
// AANVRAAG INDIENEN
// ════════════════════════════════════════════════════════

// Bouwt een Powertools-import CSV uit een lijst kaarten.
// Exact formaat: cardmarketId,quantity,name,set,cn,condition,language,
//   isFirstEd,isReverseHolo,isSigned,price,comment,finishType,buyPrice
// price/buyPrice = 0 (Powertools vult prijzen zelf). Alleen kaarten
// MÉT cardmarketId worden opgenomen.
function rblBuildPowertoolsCsv(cards) {
  const headers = ['cardmarketId','quantity','name','set','cn','condition','language',
                   'isFirstEd','isReverseHolo','isSigned','price','comment','finishType','buyPrice'];
  const esc = (v) => {
    const s = String(v ?? '');
    return /[",\n]/.test(s) ? '"'+s.replace(/"/g,'""')+'"' : s;
  };
  // Groepeer identieke kaarten (zelfde id+conditie+taal+variant) en tel quantity op
  const map = new Map();
  let skipped = 0;
  // Map onze finish → PowerTools finishType
  const PT_FINISH = { normal:'Regular', holo:'Holo', reverse:'ReverseHolo', foil:'Foil' };
  for(const c of cards) {
    if(!c.cardmarketId) { skipped++; continue; }   // ID verplicht
    const cf = c.finish || (c.isReverseHolo ? 'reverse' : 'normal');
    const finishType = PT_FINISH[cf] || 'Regular';
    // Groepeer op VOLLEDIGE identiteit (internalKey bevat al finish).
    const key = c.internalKey
      ? c.internalKey
      : [c.cardmarketId, c.setCode, c.cn, c.cond, c.lang||'EN', finishType].join('|');
    const addQty = c.quantity || 1;
    if(map.has(key)) map.get(key).quantity += addQty;
    else map.set(key, {
      cardmarketId: c.cardmarketId,
      quantity: addQty,
      name: c.name||'',
      set: c.setName||'',
      cn: c.cn||'',
      condition: PT_COND[c.cond] || c.cond || 'NM',
      language: PT_LANG[c.lang||'EN'] || 'English',
      isFirstEd: '',
      isReverseHolo: cf === 'reverse' ? 'true' : '',
      isSigned: '',
      price: 0,
      comment: '',
      finishType,
      buyPrice: 0,
    });
  }
  const rows = [...map.values()].map(r =>
    headers.map(h => esc(r[h])).join(',')
  );
  // UTF-8 BOM + header + rijen
  const csv = '\uFEFF' + headers.join(',') + '\n' + rows.join('\n');
  return { csv, count: map.size, skipped };
}

function rblDownloadCsv(filename, csvText) {
  const blob = new Blob([csvText], {type:'text/csv;charset=utf-8'});
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click();
  document.body.removeChild(a);
  setTimeout(()=>URL.revokeObjectURL(url), 1000);
}

// Stuurt op de achtergrond een e-mailmelding naar de winkel via Formspree.
// Opent NIETS bij de klant. Doet niets als er geen Formspree-ID is ingesteld.
async function rblNotifyShop(req) {
  const fid = (cfg.formspreeId||'').trim().replace(/^.*\/f\//,'').replace(/\/$/,'');
  if(!fid) return;   // geen Formspree ingesteld → stil overslaan
  const cardLines = (req.cards||[]).map(c => {
    const num = (c.cn||'').toString().split('/')[0] || '';
    const set = c.setName || c.setCode || '';
    const fin = c.finish && c.finish!=='normal' ? ` ${FINISH_LABELS[c.finish]||c.finish}` : '';
    return `${c.quantity||1}x ${c.name}${num?` #${num}`:''}${set?` (${set})`:''} — ${c.cond} ${c.lang||'EN'}${fin}`;
  }).join('\n');
  const payload = {
    _subject: `Nieuwe verkooplijst — ${req.name} (${req.totalCards} kaarten)`,
    Naam: req.name,
    Email: req.email,
    Telefoon: req.phone || '-',
    Betaling: req.payment || '-',
    Aantal_kaarten: req.totalCards,
    Bulk: req.bulkQty > 0 ? `${req.bulkQty} stuks${req.bulkType ? ' — ' + req.bulkType : ''}` : '-',
    Opmerking: req.note || '-',
    Datum: `${req.date} ${req.time||''}`,
    Kaarten: cardLines || '(geen)',
    // De volledige PowerTools-CSV meesturen, zodat je 'm altijd hebt
    // ongeacht op welk apparaat de klant de aanvraag deed.
    PowerTools_CSV: req.csv || '(geen CSV gegenereerd)',
  };
  try {
    await fetch(`https://formspree.io/f/${fid}`, {
      method: 'POST',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify(payload),
    });
  } catch(e) { /* stil falen — aanvraag staat al opgeslagen in de admin */ }
}

// Bevestigingsmail naar de KLANT, via hetzelfde Formspree-formulier.
// Formspree stuurt naar het ingestelde adres; om de klant te bereiken
// gebruiken we het _replyto-veld zodat jij makkelijk kunt antwoorden,
// en bevestigen we de ontvangst. (Een echte aparte mail naar de klant
// vereist een tweede Formspree-form met autoresponder — zie uitleg.)
async function rblNotifyCustomer(req) {
  const fid = (cfg.formspreeConfirmId||'').trim().replace(/^.*\/f\//,'').replace(/\/$/,'');
  if(!fid) return;   // geen bevestigings-form ingesteld → overslaan
  const payload = {
    email: req.email,            // Formspree autoresponder stuurt hierheen
    _replyto: req.email,
    _subject: `Bevestiging: we hebben je verkooplijst ontvangen — Retro Empire Gaming`,
    Bericht: `Hoi ${req.firstName||req.name},\n\nBedankt voor je verkooplijst van ${req.totalCards} kaart(en)! `
      + `We beoordelen je kaarten en sturen je zo snel mogelijk een persoonlijk bod via e-mail.\n\n`
      + `Met vriendelijke groet,\nRetro Empire Gaming`,
    Naam: req.name,
    Aantal_kaarten: req.totalCards,
  };
  try {
    await fetch(`https://formspree.io/f/${fid}`, {
      method: 'POST',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify(payload),
    });
  } catch(e) { /* stil falen */ }
}

// Stuurt automatisch een uitnodiging naar de klant met de ID-verificatielink,
// zodra een bod is geaccepteerd. De link bevat het aanvraagnummer als referentie.
async function rblNotifyIdInvite(req) {
  const fid = (cfg.formspreeInviteId||'').trim().replace(/^.*\/f\//,'').replace(/\/$/,'');
  if(!fid) return false;   // geen uitnodigings-form ingesteld → overslaan
  let base = (cfg.idFormUrl||'').trim().replace(/\?.*$/,'').replace(/\/$/,'');
  if(!base) return false;
  const link = `${base}?ref=${req.id}`;
  const payload = {
    email: req.email,
    _replyto: req.email,
    _subject: `Laatste stap: identiteitsverificatie — Retro Empire Gaming`,
    Bericht: `Hoi ${req.firstName||req.name},\n\n`
      + `Bedankt dat je akkoord bent met ons bod! Als professionele inkoper zijn wij wettelijk verplicht `
      + `je identiteit te registreren voordat we de aankoop afronden.\n\n`
      + `Vul hiervoor even dit korte formulier in:\n${link}\n\n`
      + `Zodra we je gegevens hebben, ronden we de aankoop af.\n\n`
      + `Met vriendelijke groet,\nRetro Empire Gaming`,
    Verificatielink: link,
    Naam: req.name,
  };
  try {
    await fetch(`https://formspree.io/f/${fid}`, {
      method: 'POST',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify(payload),
    });
    return true;
  } catch(e) { return false; }
}

window.rblDoSubmit = function() {
  const first   = document.getElementById('rblFFirst')?.value.trim()||'';
  const last    = document.getElementById('rblFLast')?.value.trim()||'';
  const email   = document.getElementById('rblFEmail')?.value.trim()||'';
  const phone   = document.getElementById('rblFPhone')?.value.trim()||'';
  const payEl   = document.querySelector('#rblFPayment input[name="rblPay"]:checked');
  const payment = payEl ? payEl.value : '';
  const note    = document.getElementById('rblFNote')?.value.trim()||'';
  const bulkQty = parseInt(document.getElementById('rblFBulkQty')?.value, 10) || 0;
  const bulkType= document.getElementById('rblFBulkType')?.value.trim()||'';

  // ── Validatie per veld (toont inline fout, focust eerste fout) ──
  let firstErr = null;
  const fail = (id, msg) => { rblShowErr(id, msg); if(!firstErr) firstErr = id; };
  ['rblFFirst','rblFLast','rblFEmail','rblFPhone','rblFPayment','rblFTerms'].forEach(rblClearErr);

  if(!first) fail('rblFFirst', 'Vul je voornaam in');
  if(!last)  fail('rblFLast', 'Vul je achternaam in');
  // E-mail: basis-formaat iets@iets.iets
  if(!email) fail('rblFEmail', 'Vul je e-mailadres in');
  else if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) fail('rblFEmail', 'Dit lijkt geen geldig e-mailadres');
  // Telefoon: minstens 8 cijfers (na verwijderen van spaties/tekens)
  const digits = phone.replace(/[^\d]/g,'');
  if(!phone) fail('rblFPhone', 'Vul je telefoonnummer in');
  else if(digits.length < 8) fail('rblFPhone', 'Vul een geldig telefoonnummer in');
  if(!payment) fail('rblFPayment', 'Kies hoe je betaald wilt worden');
  // Akkoord met voorwaarden verplicht
  const termsOk = document.getElementById('rblFTerms')?.checked;
  if(!termsOk) fail('rblFTerms', 'Je moet akkoord gaan met de voorwaarden om door te gaan');

  if(firstErr) {
    document.getElementById(firstErr)?.focus?.();
    rblToast('Controleer de gemarkeerde velden', true);
    return;
  }
  if(!cart.length && !(bulkQty > 0)) { rblToast('Je verkooplijst is leeg', true); return; }

  const name = `${first} ${last}`.trim();
  const totalCards = cart.reduce((s,c)=>s+(c.quantity||1),0);

  // Powertools CSV genereren (intern)
  const { csv, count, skipped } = rblBuildPowertoolsCsv(cart);
  const safeName = name.replace(/[^a-z0-9]/gi,'-').toLowerCase();
  const stamp = new Date().toISOString().slice(0,10);
  const csvFilename = `powertools-import_${safeName}_${stamp}.csv`;

  const req = {
    id: Date.now(), date: new Date().toLocaleDateString('nl-NL'),
    time: new Date().toLocaleTimeString('nl-NL',{hour:'2-digit',minute:'2-digit'}),
    name, firstName:first, lastName:last, email, phone, payment, note,
    cards: [...cart], totalCards,
    bulkQty, bulkType,
    csv, csvFilename, csvCount: count, csvSkipped: skipped,
    status: 'new',
    timestamp: Date.now(),
  };
  reqs.unshift(req);
  localStorage.setItem(SK.reqs, JSON.stringify(reqs));
  renderReqs(); updateBadge();

  // Concept verwijderen — de aanvraag is nu ingediend
  try { localStorage.removeItem(SK.draft); rblRenderResumeBanner(); } catch(e) {}

  // GEEN automatische download voor de klant — de CSV is intern.
  // De winkelier downloadt hem via de 📥 knop in Admin → Aanvragen.

  // Centraal opslaan in Supabase, zodat de aanvraag op ELK apparaat zichtbaar is.
  sbInsertRequest(req).catch(()=>{});

  // E-mailmelding naar de winkel via Formspree (op de achtergrond, opent niets bij de klant).
  // Vereist een Formspree form-ID in de instellingen.
  rblNotifyShop(req).catch(()=>{});
  // Bevestigingsmail naar de klant (apart Formspree-form met autoresponder).
  rblNotifyCustomer(req).catch(()=>{});

  // Succesbericht — GEEN prijs
  document.getElementById('rblSubmitBody').innerHTML = `
    <div style="text-align:center;padding:32px 20px">
      <div style="font-size:62px;margin-bottom:12px">✅</div>
      <div style="font-size:24px;font-weight:700;color:var(--grn3);margin-bottom:8px">Verkooplijst ontvangen!</div>
      <div style="font-size:18px;color:var(--txt3);line-height:1.6">
        Bedankt <strong>${name}</strong>! We hebben je verkooplijst met <strong>${totalCards} kaart${totalCards!==1?'en':''}</strong> ontvangen.<br><br>
        Wij beoordelen je kaarten en sturen je zo snel mogelijk een <strong>persoonlijk bod</strong> via <strong>${email}</strong>.
      </div>
    </div>`;
  document.getElementById('rblSubmitFooter').style.display='none';

  cart=[];
  rblUpdateCart();
  document.getElementById('rblResultArea').innerHTML='';
  setTimeout(()=>{
    try { rblCloseSubmit(); } catch(e){}
    const f = document.getElementById('rblSubmitFooter');
    if(f) f.style.display='';
  }, 4000);
};

// ════════════════════════════════════════════════════════
// AANVRAGEN ADMIN
// ════════════════════════════════════════════════════════
function updateBadge() {
  const b = document.getElementById('rblNewBadge');
  if(!b) return;
  // Tel aanvragen die nog aandacht nodig hebben (niet afgerond/afgewezen)
  b.textContent = reqs.filter(r=>{ const s=normalizeStatus(r.status); return s!=='done'&&s!=='rejected'; }).length;
}

window.rblReqFilter = function(f, el) {
  reqFil=f;
  document.querySelectorAll('#rbl .rf').forEach(b=>b.classList.remove('on'));
  el.classList.add('on');
  renderReqs();
};

function renderReqs() {
  const body=document.getElementById('rblReqBody');
  if(!body) return;
  // Tellers per fase bijwerken
  rblUpdateReqCounts();
  const list = reqFil==='all' ? reqs : reqs.filter(r=>normalizeStatus(r.status)===reqFil);
  if(!list.length) { body.innerHTML=`<tr><td colspan="8"><div class="empty-tbl">📭 Geen aanvragen in deze fase</div></td></tr>`; return; }
  body.innerHTML = list.map(r => {
    const st = normalizeStatus(r.status);
    const stage = REQ_STAGE[st] || REQ_STAGE.new;
    const totalCards = (r.cards||[]).reduce((s,c)=>s+(c.quantity||1),0);
    const bid = (r.offerAmount!=null && r.offerAmount!=='') ? `€${Number(r.offerAmount).toFixed(2)}` : '—';
    const sub = r.subStatus ? `<br><span style="font-size:12px;color:var(--txt4)">${r.subStatus}</span>` : '';
    return `<tr>
      <td data-label="Datum" style="font-size:15px;color:var(--txt2)">${r.date}<br><span style="color:var(--txt4)">${r.time||''}</span></td>
      <td data-label="Naam" style="font-weight:700">${r.name}</td>
      <td data-label="Email" style="font-size:15px;color:var(--txt2)">${r.email}</td>
      <td data-label="Kaarten" style="font-size:16px">${totalCards}×</td>
      <td data-label="Telefoon" style="font-size:15px;color:var(--txt2)">${r.phone||'—'}</td>
      <td data-label="Bod" style="font-size:15px;font-weight:700;color:${bid!=='—'?'var(--grn3)':'var(--txt4)'}">${bid}</td>
      <td data-label="Status"><span class="st" style="background:${stage.color}22;color:${stage.color};border:1px solid ${stage.color}55">${stage.label}</span>${sub}</td>
      <td style="white-space:nowrap">
        <button class="rb view" onclick="rblViewReq(${r.id})" title="Bekijken & bewerken">👁</button>
        ${r.csv?`<button class="rb" style="background:var(--grn)" onclick="rblReDownloadCsv(${r.id})" title="Download Powertools CSV">📥</button>`:''}
        ${stage.next?`<button class="rb ok" onclick="rblAdvanceStage(${r.id})" title="Naar volgende fase: ${REQ_STAGE[stage.next].label}">→</button>`:''}
      </td>
    </tr>`;
  }).join('');
}

// Tellers per fase-tab
function rblUpdateReqCounts() {
  const counts = { all: reqs.length };
  REQ_STAGES.forEach(s => counts[s.key] = 0);
  reqs.forEach(r => { const st = normalizeStatus(r.status); counts[st] = (counts[st]||0)+1; });
  Object.entries(counts).forEach(([k,v]) => {
    const el = document.getElementById('cnt_'+k);
    if(el) el.textContent = v;
  });
}

// Schuif een aanvraag naar de volgende fase
window.rblAdvanceStage = function(id) {
  const r = reqs.find(x=>x.id===id);
  if(!r) return;
  const st = normalizeStatus(r.status);
  const next = REQ_STAGE[st]?.next;
  if(!next) return;
  r.status = next;
  r.subStatus = '';   // reset sub-status bij faseovergang
  localStorage.setItem(SK.reqs, JSON.stringify(reqs));
  sbUpdateRequest(id, {status: next, subStatus: ''}).catch(()=>{});
  updateBadge(); renderReqs();
  rblToast(`→ ${r.name}: ${REQ_STAGE[next].label}`);
};

window.rblReDownloadCsv = function(id) {
  const r = reqs.find(x=>x.id===id);
  if(!r?.csv) { rblToast('Geen CSV beschikbaar voor deze aanvraag', true); return; }
  rblDownloadCsv(r.csvFilename || `powertools-import_${id}.csv`, r.csv);
  rblToast(`CSV gedownload (${r.csvCount||0} kaarten${r.csvSkipped?`, ${r.csvSkipped} zonder ID overgeslagen`:''})`);
};

window.rblSetStatus = function(id, status) {
  const r = reqs.find(x=>x.id===id);
  if(r) { r.status=status; localStorage.setItem(SK.reqs, JSON.stringify(reqs)); updateBadge(); renderReqs(); rblToast(status==='approved'?'Goedgekeurd ✓':'Afgewezen'); }
};

// ── WORKFLOW-PANEEL (in de aanvraag-detail) ───────────
function rblWorkflowPanelHTML(r, st, stage) {
  // Sub-statussen afhankelijk van fase
  let subs = [];
  if(st==='offer')    subs = OFFER_SUB;
  if(st==='shipping') subs = SHIP_SUB;
  if(st==='checking') subs = CHECK_SUB;

  // Fase-stappenbalk
  const chain = REQ_STAGES.filter(s=>s.key!=='rejected');
  const curIdx = chain.findIndex(s=>s.key===st);
  const steps = chain.map((s,i) => {
    const done = i < curIdx, active = i===curIdx;
    const bg = active ? s.color : (done ? s.color+'88' : 'var(--bg3)');
    const col = (active||done) ? '#fff' : 'var(--txt4)';
    return `<div style="flex:1;text-align:center;font-size:10px;font-weight:700">
      <div style="height:6px;border-radius:3px;background:${bg};margin-bottom:3px"></div>
      <span style="color:${(active||done)?s.color:'var(--txt4)'}">${s.label}</span>
    </div>`;
  }).join('');

  const offerVal = (r.offerAmount!=null) ? r.offerAmount : '';

  return `<div style="background:var(--bg2,#fafafa);border:2px solid ${stage.color}55;border-radius:10px;padding:14px;margin-bottom:14px">
    <div style="display:flex;align-items:center;justify-content:space-between;gap:10px;flex-wrap:wrap;margin-bottom:10px">
      <div style="font-size:13px;font-weight:700;color:var(--txt3);text-transform:uppercase;letter-spacing:1px">Workflow</div>
      <span class="st" style="background:${stage.color}22;color:${stage.color};border:1px solid ${stage.color}55;font-size:14px">${stage.label}</span>
    </div>

    ${st!=='rejected' ? `<div style="display:flex;gap:3px;margin-bottom:12px">${steps}</div>` : ''}

    ${subs.length ? `
    <div style="margin-bottom:12px">
      <div style="font-size:12px;font-weight:700;color:var(--txt3);margin-bottom:5px">Sub-status</div>
      <div style="display:flex;gap:6px;flex-wrap:wrap">
        ${subs.map(s=>`<button onclick="rblSetSubStatus(${r.id},'${s.replace(/'/g,"\\'")}')"
          style="padding:6px 11px;border-radius:7px;font-size:13px;font-weight:600;cursor:pointer;border:1px solid ${r.subStatus===s?stage.color:'var(--bdr)'};background:${r.subStatus===s?stage.color:'#fff'};color:${r.subStatus===s?'#fff':'var(--txt2)'}">${s}</button>`).join('')}
      </div>
    </div>` : ''}

    ${(st==='offer'||st==='checking'||r.offerAmount!=null) ? `
    <div style="margin-bottom:12px">
      <div style="font-size:12px;font-weight:700;color:var(--txt3);margin-bottom:5px">Bodbedrag (€)</div>
      <div style="display:flex;gap:8px">
        <input type="number" id="rblOfferAmt_${r.id}" value="${offerVal}" placeholder="0.00" step="0.01" min="0"
          style="flex:1;padding:8px 11px;border:1px solid var(--bdr);border-radius:7px;font-size:16px">
        <button onclick="rblSaveOffer(${r.id})" style="padding:8px 16px;background:var(--grn);color:#fff;border:none;border-radius:7px;font-weight:700;cursor:pointer">Opslaan</button>
      </div>
    </div>` : ''}

    ${(st==='shipping') ? `
    <div style="margin-bottom:12px">
      <div style="font-size:12px;font-weight:700;color:var(--txt3);margin-bottom:5px">📦 Verzending — Track & Trace</div>
      <div style="display:flex;gap:8px">
        <input type="text" id="rblTrack_${r.id}" value="${(r.tracking||'').replace(/"/g,'&quot;')}" placeholder="bijv. 3SABC1234567890"
          style="flex:1;padding:8px 11px;border:1px solid var(--bdr);border-radius:7px;font-size:15px">
        <button onclick="rblSaveTracking(${r.id})" style="padding:8px 16px;background:var(--grn);color:#fff;border:none;border-radius:7px;font-weight:700;cursor:pointer">Opslaan</button>
      </div>
      ${r.tracking?`<div style="font-size:13px;color:var(--grn3);margin-top:4px">✓ Tracking opgeslagen: ${r.tracking}</div>`:''}
    </div>` : ''}

    ${(st==='checking') ? `
    <div style="margin-bottom:12px;background:var(--bg3);border-radius:8px;padding:11px">
      <div style="font-size:12px;font-weight:700;color:var(--txt3);margin-bottom:5px">🔍 Controle — mankement(en)</div>
      <textarea id="rblDefect_${r.id}" placeholder="bijv. Charizard heeft een knik in de hoek, conditie LP i.p.v. NM…"
        style="width:100%;min-height:44px;padding:8px;border:1px solid var(--bdr);border-radius:7px;font-size:14px;resize:vertical">${r.defects||''}</textarea>
      <div style="display:flex;gap:8px;align-items:center;margin-top:8px;flex-wrap:wrap">
        <span style="font-size:13px;color:var(--txt3)">Aangepast bod (€):</span>
        <input type="number" id="rblCompAmt_${r.id}" value="${r.compensationAmount!=null?r.compensationAmount:''}" placeholder="0.00" step="0.01" min="0"
          style="width:110px;padding:7px 10px;border:1px solid var(--bdr);border-radius:7px;font-size:15px">
        <button onclick="rblSaveCompensation(${r.id})" style="padding:7px 14px;background:var(--grn);color:#fff;border:none;border-radius:7px;font-weight:700;cursor:pointer">Opslaan</button>
      </div>
      ${r.compensationAmount!=null?`<div style="font-size:13px;color:var(--txt3);margin-top:6px">Oorspronkelijk bod: <strong>€${(r.offerAmount||0).toFixed(2)}</strong> → aangepast: <strong style="color:var(--grn3)">€${Number(r.compensationAmount).toFixed(2)}</strong></div>`:''}
    </div>` : ''}

    <div style="margin-bottom:12px">
      <div style="font-size:12px;font-weight:700;color:var(--txt3);margin-bottom:5px">Interne notities <span style="font-weight:400">(niet zichtbaar voor klant)</span></div>
      <textarea id="rblNotes_${r.id}" placeholder="bijv. klant belde, conditie valt tegen…"
        style="width:100%;min-height:50px;padding:8px;border:1px solid var(--bdr);border-radius:7px;font-size:14px;resize:vertical">${r.internalNotes||''}</textarea>
      <button onclick="rblSaveNotes(${r.id})" style="margin-top:6px;padding:6px 14px;background:var(--bg3);border:1px solid var(--bdr);border-radius:7px;font-weight:600;cursor:pointer;font-size:13px">Notitie opslaan</button>
    </div>

    <div style="display:flex;gap:8px;flex-wrap:wrap;border-top:1px solid var(--bdr);padding-top:10px">
      ${stage.next ? `<button onclick="rblAdvanceStage(${r.id});rblViewReq(${r.id})" style="flex:1;min-width:160px;padding:10px;background:${REQ_STAGE[stage.next].color};color:#fff;border:none;border-radius:8px;font-weight:700;cursor:pointer">→ ${REQ_STAGE[stage.next].label}</button>` : ''}
      ${st!=='rejected'&&st!=='done' ? `<button onclick="rblRejectReq(${r.id})" style="padding:10px 16px;background:#fff;color:var(--red);border:1px solid var(--red);border-radius:8px;font-weight:700;cursor:pointer">✕ Afwijzen</button>` : ''}
      ${st==='rejected' ? `<button onclick="rblDeleteReq(${r.id})" style="flex:1;padding:10px 16px;background:var(--red);color:#fff;border:none;border-radius:8px;font-weight:700;cursor:pointer">🗑 Permanent verwijderen</button>` : ''}
    </div>
  </div>`;
}

window.rblSetSubStatus = function(id, sub) {
  const r = reqs.find(x=>x.id===id);
  if(!r) return;
  const wasAlready = (r.subStatus === sub);
  r.subStatus = wasAlready ? '' : sub;
  localStorage.setItem(SK.reqs, JSON.stringify(reqs));
  sbUpdateRequest(id, {subStatus: r.subStatus}).catch(()=>{});
  renderReqs(); rblViewReq(id);
  // Automatische ID-verificatie-uitnodiging zodra het bod is geaccepteerd.
  // Alleen bij het AANzetten van "Klant akkoord" (niet bij uitzetten), en
  // niet dubbel als er al een uitnodiging is verstuurd.
  if(!wasAlready && sub === 'Klant akkoord' && !r.idInviteSent) {
    rblNotifyIdInvite(r).then(ok => {
      if(ok) {
        r.idInviteSent = true;
        localStorage.setItem(SK.reqs, JSON.stringify(reqs));
        rblToast('ID-verificatie-uitnodiging verstuurd ✓');
      }
    }).catch(()=>{});
  }
};

window.rblSaveOffer = function(id) {
  const r = reqs.find(x=>x.id===id);
  if(!r) return;
  const v = document.getElementById('rblOfferAmt_'+id)?.value;
  r.offerAmount = (v===''||v==null) ? null : Number(v);
  localStorage.setItem(SK.reqs, JSON.stringify(reqs));
  sbUpdateRequest(id, {offerAmount: r.offerAmount}).catch(()=>{});
  renderReqs();
  rblToast(r.offerAmount!=null ? `Bod €${r.offerAmount.toFixed(2)} opgeslagen` : 'Bod gewist');
};

window.rblSaveNotes = function(id) {
  const r = reqs.find(x=>x.id===id);
  if(!r) return;
  r.internalNotes = document.getElementById('rblNotes_'+id)?.value || '';
  localStorage.setItem(SK.reqs, JSON.stringify(reqs));
  sbUpdateRequest(id, {internalNotes: r.internalNotes}).catch(()=>{});
  rblToast('Notitie opgeslagen');
};

window.rblRejectReq = function(id) {
  const r = reqs.find(x=>x.id===id);
  if(!r) return;
  r.status = 'rejected'; r.subStatus = '';
  localStorage.setItem(SK.reqs, JSON.stringify(reqs));
  sbUpdateRequest(id, {status:'rejected', subStatus:''}).catch(()=>{});
  updateBadge(); renderReqs(); rblViewReq(id);
  rblToast(`${r.name} afgewezen`);
};

window.rblSaveTracking = function(id) {
  const r = reqs.find(x=>x.id===id);
  if(!r) return;
  r.tracking = document.getElementById('rblTrack_'+id)?.value.trim() || '';
  localStorage.setItem(SK.reqs, JSON.stringify(reqs));
  sbUpdateRequest(id, {tracking: r.tracking}).catch(()=>{});
  rblViewReq(id);
  rblToast(r.tracking ? 'Track & trace opgeslagen' : 'Tracking gewist');
};

window.rblSaveCompensation = function(id) {
  const r = reqs.find(x=>x.id===id);
  if(!r) return;
  r.defects = document.getElementById('rblDefect_'+id)?.value.trim() || '';
  const v = document.getElementById('rblCompAmt_'+id)?.value;
  r.compensationAmount = (v===''||v==null) ? null : Number(v);
  localStorage.setItem(SK.reqs, JSON.stringify(reqs));
  sbUpdateRequest(id, {defects: r.defects, compensationAmount: r.compensationAmount}).catch(()=>{});
  renderReqs(); rblViewReq(id);
  rblToast('Controle-gegevens opgeslagen');
};

window.rblDeleteReq = function(id) {
  const r = reqs.find(x=>x.id===id);
  if(!r) return;
  // Alleen afgewezen aanvragen mogen permanent weg
  if(normalizeStatus(r.status) !== 'rejected') { rblToast('Alleen afgewezen aanvragen kunnen permanent verwijderd worden', true); return; }
  if(!confirm(`Aanvraag van ${r.name} permanent verwijderen? Dit kan niet ongedaan worden gemaakt.`)) return;
  reqs = reqs.filter(x=>x.id!==id);
  localStorage.setItem(SK.reqs, JSON.stringify(reqs));
  sbDeleteRequest(id).catch(()=>{});
  updateBadge(); renderReqs();
  document.getElementById('rblOvDetail')?.classList.remove('show');
  rblToast('Aanvraag permanent verwijderd');
};

function rblViewReq(id) {
  const r = reqs.find(x=>x.id===id);
  if(!r) return;
  const st = normalizeStatus(r.status);
  const stage = REQ_STAGE[st] || REQ_STAGE.new;
  document.getElementById('rblDetailTitle').textContent = `Aanvraag — ${r.name}`;

  // Bulk-teller: Pokémon commons (bulk) apart van losse holo's/rares
  const bulkCount = (r.cards||[]).filter(c => isBulkCard(c, c.finish||'normal')).reduce((s,c)=>s+(c.quantity||1),0);
  const looseCount = (r.cards||[]).reduce((s,c)=>s+(c.quantity||1),0) - bulkCount;

  document.getElementById('rblDetailBody').innerHTML = `
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:14px">
      <div><div style="font-size:12px;font-weight:700;color:var(--txt3);text-transform:uppercase;margin-bottom:2px">Naam</div><strong>${r.name}</strong></div>
      <div><div style="font-size:12px;font-weight:700;color:var(--txt3);text-transform:uppercase;margin-bottom:2px">Email</div><a href="mailto:${r.email}" style="color:var(--blu)">${r.email}</a></div>
      <div><div style="font-size:12px;font-weight:700;color:var(--txt3);text-transform:uppercase;margin-bottom:2px">Telefoon</div>${r.phone||'—'}</div>
      <div><div style="font-size:12px;font-weight:700;color:var(--txt3);text-transform:uppercase;margin-bottom:2px">Betaling</div>${r.payment||'—'}</div>
    </div>

    ${rblWorkflowPanelHTML(r, st, stage)}

    ${(() => {
      // Bulk kan lokaal als r.bulkQty staan, of (uit Supabase) in de notitie als "📦 BULK: ..."
      let bulkLine = '';
      if(r.bulkQty > 0) {
        bulkLine = `${r.bulkQty} stuks${r.bulkType ? ' — ' + r.bulkType : ''}`;
      } else if(r.note && /📦\s*BULK:/i.test(r.note)) {
        const m = r.note.match(/📦\s*BULK:\s*([^\n]+)/i);
        if(m) bulkLine = m[1].trim();
      }
      return bulkLine
        ? `<div style="background:#fff7ed;border:1px solid #fdba74;border-radius:8px;padding:10px 12px;margin-bottom:12px;font-size:16px;color:#9a3412"><strong>📦 Klant heeft ook bulk:</strong> ${bulkLine}</div>`
        : '';
    })()}

    ${(() => {
      // Toon de notitie, maar zonder de bulk-regel (die staat al hierboven)
      const cleanNote = (r.note||'').replace(/📦\s*BULK:[^\n]*\n?/i,'').trim();
      return cleanNote ? `<div style="background:var(--bg3);border-radius:6px;padding:8px 10px;margin-bottom:12px;font-size:17px"><strong>Opmerking klant:</strong> ${cleanNote}</div>` : '';
    })()}

    <div style="display:flex;gap:8px;margin-bottom:10px;flex-wrap:wrap">
      <div style="flex:1;min-width:120px;background:var(--bg3);border-radius:8px;padding:10px 12px;text-align:center">
        <div style="font-size:22px;font-weight:800;color:var(--grn3)">${looseCount}</div>
        <div style="font-size:12px;color:var(--txt3);text-transform:uppercase;letter-spacing:.5px">Los (holo/rare/MTG)</div>
      </div>
      <div style="flex:1;min-width:120px;background:var(--bg3);border-radius:8px;padding:10px 12px;text-align:center">
        <div style="font-size:22px;font-weight:800;color:var(--txt2)">${bulkCount}</div>
        <div style="font-size:12px;color:var(--txt3);text-transform:uppercase;letter-spacing:.5px">📦 Bulk (PKM commons)</div>
      </div>
    </div>

    <div style="font-size:12px;font-weight:700;color:var(--txt3);text-transform:uppercase;letter-spacing:1.5px;margin-bottom:8px">Kaarten (${r.cards.reduce((s,c)=>s+(c.quantity||1),0)})</div>
    ${(() => {
      const csvCount = r.cards.filter(c=>c._fromCsv||c._idUncertain).length;
      return csvCount ? `<div style="background:var(--bg3);border:1px solid var(--ylw,#e0a020);border-radius:6px;padding:8px 10px;margin-bottom:10px;font-size:13px;color:var(--txt2)">⚠ ${csvCount} kaart(en) komen uit een klant-upload — controleer set/nummer en koppel zelf de juiste CardMarket-ID in PowerTools.</div>` : '';
    })()}
    ${r.cards.map(c=>{
      const num = (c.cn||'').toString().split('/')[0] || (c.code||'').split('-').pop() || '';
      const setLbl = c.setName || c.setCode || '';
      const meta = [setLbl, num?('#'+num):'', c.cond, c.lang||'EN'].filter(Boolean).join(' · ');
      return `
      <div style="display:flex;align-items:center;gap:10px;padding:7px 0;border-bottom:1px solid var(--bg3)">
        ${c.img?`<img style="width:36px;height:50px;object-fit:cover;border-radius:4px;border:1px solid var(--bdr)" src="${c.img}">`:''}
        <div style="flex:1">
          <div style="font-weight:700;font-size:17px">${c.name}${c.rarity?` <span style="font-size:13px;font-weight:400;color:var(--txt3)">${c.rarity}</span>`:''}</div>
          <div style="font-size:14px;color:var(--txt3)">${meta}${c.finish&&c.finish!=='normal'?' · '+(FINISH_LABELS[c.finish]||c.finish):''}${c.cardmarketId?` · ID:${c.cardmarketId}`:''}</div>
        </div>
        <div style="font-weight:700;font-size:18px">${c.quantity||1}×</div>
      </div>`;
    }).join('')}
    <div style="display:flex;justify-content:flex-end;padding-top:10px;border-top:2px solid var(--bdr);margin-top:6px">
      <span style="font-size:20px;font-weight:700">${r.cards.reduce((s,c)=>s+(c.quantity||1),0)} kaarten totaal</span>
    </div>`;
  document.getElementById('rblOvDetail').classList.add('show');
}
window.rblViewReq = rblViewReq;

// ════════════════════════════════════════════════════════
// TOAST
// ════════════════════════════════════════════════════════
function rblToast(msg, err=false) {
  const t=document.getElementById('rblToast');
  t.textContent=msg; t.className='toast show'+(err?' err':'');
  setTimeout(()=>t.className='toast', 3000);
}
window.rblToast=rblToast;

// ── Late init: deze functies gebruiken consts die hierboven
// pas gedefinieerd zijn (PriceList, PriceValidator). Daarom
// draaien ze helemaal aan het eind, niet halverwege het script.
try { rblRenderPriceListStatus(); } catch(e) { console.warn('pricelist status init:', e); }
try { rblValRender(); } catch(e) { console.warn('validator init:', e); }

})();